var _defs, _g, _text;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 189.71 49.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        clip-path: url(#clippath-290);\n      }\n\n      .cls-2 {\n        clip-path: url(#clippath-376);\n      }\n\n      .cls-3 {\n        fill: #f69057;\n      }\n\n      .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85, .cls-86, .cls-87, .cls-88, .cls-89, .cls-90, .cls-91, .cls-92, .cls-93, .cls-94, .cls-95, .cls-96, .cls-97, .cls-98, .cls-99, .cls-100, .cls-101, .cls-102, .cls-103, .cls-104, .cls-105, .cls-106, .cls-107, .cls-108, .cls-109, .cls-110, .cls-111, .cls-112, .cls-113, .cls-114, .cls-115, .cls-116, .cls-117, .cls-118, .cls-119, .cls-120, .cls-121, .cls-122, .cls-123, .cls-124, .cls-125, .cls-126, .cls-127, .cls-128, .cls-129, .cls-130, .cls-131, .cls-132, .cls-133, .cls-134, .cls-135, .cls-136, .cls-137, .cls-138, .cls-139, .cls-140, .cls-141, .cls-142, .cls-143, .cls-144, .cls-145, .cls-146, .cls-147, .cls-148, .cls-149, .cls-150, .cls-151, .cls-152, .cls-153, .cls-154, .cls-155, .cls-156, .cls-157, .cls-158, .cls-159, .cls-160, .cls-161, .cls-162, .cls-163, .cls-164, .cls-165, .cls-166, .cls-167, .cls-168, .cls-169, .cls-170, .cls-171, .cls-172, .cls-173, .cls-174, .cls-175, .cls-176, .cls-177, .cls-178, .cls-179, .cls-180, .cls-181, .cls-182, .cls-183, .cls-184, .cls-185, .cls-186, .cls-187, .cls-188, .cls-189, .cls-190, .cls-191, .cls-192, .cls-193, .cls-194, .cls-195, .cls-196, .cls-197, .cls-198, .cls-199, .cls-200, .cls-201, .cls-202, .cls-203, .cls-204, .cls-205, .cls-206, .cls-207, .cls-208, .cls-209, .cls-210, .cls-211, .cls-212, .cls-213, .cls-214, .cls-215, .cls-216, .cls-217, .cls-218, .cls-219, .cls-220, .cls-221, .cls-222, .cls-223, .cls-224, .cls-225, .cls-226, .cls-227, .cls-228, .cls-229, .cls-230, .cls-231, .cls-232, .cls-233, .cls-234, .cls-235, .cls-236, .cls-237, .cls-238, .cls-239, .cls-240, .cls-241, .cls-242, .cls-243, .cls-244, .cls-245, .cls-246, .cls-247, .cls-248, .cls-249, .cls-250, .cls-251, .cls-252, .cls-253, .cls-254, .cls-255, .cls-256, .cls-257, .cls-258, .cls-259, .cls-260, .cls-261, .cls-262, .cls-263, .cls-264, .cls-265, .cls-266, .cls-267, .cls-268, .cls-269, .cls-270, .cls-271, .cls-272, .cls-273, .cls-274, .cls-275, .cls-276, .cls-277, .cls-278, .cls-279, .cls-280, .cls-281, .cls-282, .cls-283, .cls-284, .cls-285, .cls-286, .cls-287, .cls-288, .cls-289, .cls-290, .cls-291, .cls-292, .cls-293, .cls-294, .cls-295, .cls-296, .cls-297, .cls-298, .cls-299, .cls-300, .cls-301, .cls-302, .cls-303, .cls-304, .cls-305, .cls-306, .cls-307, .cls-308, .cls-309, .cls-310, .cls-311, .cls-312, .cls-313, .cls-314, .cls-315, .cls-316, .cls-317, .cls-318, .cls-319, .cls-320, .cls-321, .cls-322, .cls-323, .cls-324, .cls-325, .cls-326, .cls-327, .cls-328, .cls-329, .cls-330, .cls-331, .cls-332, .cls-333, .cls-334, .cls-335, .cls-336, .cls-337, .cls-338 {\n        stroke-width: 0px;\n      }\n\n      .cls-4 {\n        fill: #260f07;\n      }\n\n      .cls-339 {\n        clip-path: url(#clippath-73);\n      }\n\n      .cls-5 {\n        fill: #d56063;\n      }\n\n      .cls-340 {\n        clip-path: url(#clippath-559);\n      }\n\n      .cls-6 {\n        fill: #f8b340;\n      }\n\n      .cls-7 {\n        fill: #b16d3c;\n      }\n\n      .cls-341 {\n        clip-path: url(#clippath-382);\n      }\n\n      .cls-342 {\n        clip-path: url(#clippath-655);\n      }\n\n      .cls-343 {\n        clip-path: url(#clippath-249);\n      }\n\n      .cls-344 {\n        clip-path: url(#clippath-361);\n      }\n\n      .cls-345 {\n        clip-path: url(#clippath-489);\n      }\n\n      .cls-8 {\n        fill: #f37d5c;\n      }\n\n      .cls-9 {\n        fill: #a8683a;\n      }\n\n      .cls-346 {\n        clip-path: url(#clippath-234);\n      }\n\n      .cls-347 {\n        clip-path: url(#clippath-206);\n      }\n\n      .cls-348 {\n        clip-path: url(#clippath-467);\n      }\n\n      .cls-349 {\n        clip-path: url(#clippath-448);\n      }\n\n      .cls-350 {\n        clip-path: url(#clippath-270);\n      }\n\n      .cls-10 {\n        fill: #912988;\n      }\n\n      .cls-351 {\n        clip-path: url(#clippath-72);\n      }\n\n      .cls-352 {\n        clip-path: url(#clippath-505);\n      }\n\n      .cls-353 {\n        clip-path: url(#clippath-321);\n      }\n\n      .cls-11 {\n        fill: #f8a749;\n      }\n\n      .cls-354 {\n        clip-path: url(#clippath-62);\n      }\n\n      .cls-355 {\n        clip-path: url(#clippath-710);\n      }\n\n      .cls-356 {\n        clip-path: url(#clippath-313);\n      }\n\n      .cls-12 {\n        fill: #ad6b3b;\n      }\n\n      .cls-357 {\n        clip-path: url(#clippath-302);\n      }\n\n      .cls-13 {\n        fill: #8f278a;\n      }\n\n      .cls-358 {\n        clip-path: url(#clippath-186);\n      }\n\n      .cls-359 {\n        clip-path: url(#clippath-520);\n      }\n\n      .cls-360 {\n        clip-path: url(#clippath-684);\n      }\n\n      .cls-361 {\n        clip-path: url(#clippath-45);\n      }\n\n      .cls-14 {\n        fill: #a24a78;\n      }\n\n      .cls-362 {\n        clip-path: url(#clippath-208);\n      }\n\n      .cls-363 {\n        clip-path: url(#clippath-63);\n      }\n\n      .cls-364 {\n        clip-path: url(#clippath-518);\n      }\n\n      .cls-365 {\n        clip-path: url(#clippath-188);\n      }\n\n      .cls-366 {\n        clip-path: url(#clippath-602);\n      }\n\n      .cls-367 {\n        clip-path: url(#clippath-597);\n      }\n\n      .cls-368 {\n        clip-path: url(#clippath-485);\n      }\n\n      .cls-369 {\n        clip-path: url(#clippath-170);\n      }\n\n      .cls-370 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-15 {\n        fill: #945c33;\n      }\n\n      .cls-371 {\n        clip-path: url(#clippath-135);\n      }\n\n      .cls-372 {\n        clip-path: url(#clippath-659);\n      }\n\n      .cls-373 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-374 {\n        clip-path: url(#clippath-123);\n      }\n\n      .cls-375 {\n        clip-path: url(#clippath-539);\n      }\n\n      .cls-376 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-16 {\n        fill: #f8af43;\n      }\n\n      .cls-377 {\n        clip-path: url(#clippath-671);\n      }\n\n      .cls-17 {\n        fill: #e8645f;\n      }\n\n      .cls-18 {\n        fill: #ad586e;\n      }\n\n      .cls-378 {\n        clip-path: url(#clippath-157);\n      }\n\n      .cls-379 {\n        clip-path: url(#clippath-315);\n      }\n\n      .cls-380 {\n        clip-path: url(#clippath-510);\n      }\n\n      .cls-381 {\n        clip-path: url(#clippath-340);\n      }\n\n      .cls-382 {\n        clip-path: url(#clippath-59);\n      }\n\n      .cls-383 {\n        clip-path: url(#clippath-357);\n      }\n\n      .cls-384 {\n        clip-path: url(#clippath-593);\n      }\n\n      .cls-385 {\n        clip-path: url(#clippath-681);\n      }\n\n      .cls-19 {\n        fill: #b06d3c;\n      }\n\n      .cls-20 {\n        fill: #f1655d;\n      }\n\n      .cls-386 {\n        clip-path: url(#clippath-78);\n      }\n\n      .cls-21 {\n        fill: #cc5f66;\n      }\n\n      .cls-22 {\n        fill: #f2735d;\n      }\n\n      .cls-387 {\n        clip-path: url(#clippath-287);\n      }\n\n      .cls-388 {\n        clip-path: url(#clippath-207);\n      }\n\n      .cls-389 {\n        clip-path: url(#clippath-451);\n      }\n\n      .cls-390 {\n        clip-path: url(#clippath-477);\n      }\n\n      .cls-391 {\n        clip-path: url(#clippath-199);\n      }\n\n      .cls-23 {\n        fill: #b0596d;\n      }\n\n      .cls-392 {\n        clip-path: url(#clippath-440);\n      }\n\n      .cls-393 {\n        clip-path: url(#clippath-303);\n      }\n\n      .cls-394 {\n        clip-path: url(#clippath-289);\n      }\n\n      .cls-24 {\n        fill: #e5645f;\n      }\n\n      .cls-25 {\n        fill: #af6c3c;\n      }\n\n      .cls-395 {\n        clip-path: url(#clippath-275);\n      }\n\n      .cls-396 {\n        clip-path: url(#clippath-411);\n      }\n\n      .cls-397 {\n        clip-path: url(#clippath-169);\n      }\n\n      .cls-398 {\n        clip-path: url(#clippath-93);\n      }\n\n      .cls-399 {\n        clip-path: url(#clippath-261);\n      }\n\n      .cls-400 {\n        clip-path: url(#clippath-388);\n      }\n\n      .cls-401 {\n        clip-path: url(#clippath-267);\n      }\n\n      .cls-402 {\n        clip-path: url(#clippath-609);\n      }\n\n      .cls-403 {\n        clip-path: url(#clippath-342);\n      }\n\n      .cls-404 {\n        clip-path: url(#clippath-542);\n      }\n\n      .cls-405 {\n        clip-path: url(#clippath-337);\n      }\n\n      .cls-26 {\n        fill: #f4865a;\n      }\n\n      .cls-406 {\n        clip-path: url(#clippath-379);\n      }\n\n      .cls-407 {\n        clip-path: url(#clippath-158);\n      }\n\n      .cls-27 {\n        fill: #993980;\n      }\n\n      .cls-28 {\n        fill: #d36064;\n      }\n\n      .cls-29 {\n        fill: #704526;\n      }\n\n      .cls-408 {\n        clip-path: url(#clippath-715);\n      }\n\n      .cls-409 {\n        clip-path: url(#clippath-89);\n      }\n\n      .cls-410 {\n        clip-path: url(#clippath-311);\n      }\n\n      .cls-411 {\n        clip-path: url(#clippath-33);\n      }\n\n      .cls-412 {\n        clip-path: url(#clippath-64);\n      }\n\n      .cls-413 {\n        clip-path: url(#clippath-233);\n      }\n\n      .cls-414 {\n        clip-path: url(#clippath-47);\n      }\n\n      .cls-415 {\n        clip-path: url(#clippath-220);\n      }\n\n      .cls-416 {\n        clip-path: url(#clippath-436);\n      }\n\n      .cls-30 {\n        fill: #e06360;\n      }\n\n      .cls-31 {\n        fill: #a7683a;\n      }\n\n      .cls-417 {\n        clip-path: url(#clippath-94);\n      }\n\n      .cls-418 {\n        clip-path: url(#clippath-77);\n      }\n\n      .cls-419 {\n        clip-path: url(#clippath-588);\n      }\n\n      .cls-420 {\n        clip-path: url(#clippath-162);\n      }\n\n      .cls-421 {\n        clip-path: url(#clippath-121);\n      }\n\n      .cls-422 {\n        clip-path: url(#clippath-501);\n      }\n\n      .cls-32 {\n        fill: #965d34;\n      }\n\n      .cls-33 {\n        fill: #a1477a;\n      }\n\n      .cls-34 {\n        fill: #9c3d7f;\n      }\n\n      .cls-35 {\n        fill: #ab6a3b;\n      }\n\n      .cls-423 {\n        clip-path: url(#clippath-320);\n      }\n\n      .cls-36 {\n        fill: #ab586e;\n      }\n\n      .cls-424 {\n        clip-path: url(#clippath-703);\n      }\n\n      .cls-37 {\n        fill: #d46064;\n      }\n\n      .cls-425 {\n        clip-path: url(#clippath-572);\n      }\n\n      .cls-426 {\n        clip-path: url(#clippath-160);\n      }\n\n      .cls-38 {\n        fill: #c47942;\n      }\n\n      .cls-39 {\n        fill: #c87c43;\n      }\n\n      .cls-427 {\n        clip-path: url(#clippath-116);\n      }\n\n      .cls-428 {\n        clip-path: url(#clippath-161);\n      }\n\n      .cls-429 {\n        clip-path: url(#clippath-151);\n      }\n\n      .cls-40 {\n        fill: #f69f4f;\n      }\n\n      .cls-430 {\n        clip-path: url(#clippath-682);\n      }\n\n      .cls-431 {\n        clip-path: url(#clippath-371);\n      }\n\n      .cls-41 {\n        fill: #cd7e44;\n      }\n\n      .cls-42 {\n        fill: #a1467a;\n      }\n\n      .cls-432 {\n        clip-path: url(#clippath-323);\n      }\n\n      .cls-433 {\n        clip-path: url(#clippath-136);\n      }\n\n      .cls-434 {\n        clip-path: url(#clippath-387);\n      }\n\n      .cls-435 {\n        clip-path: url(#clippath-326);\n      }\n\n      .cls-436 {\n        clip-path: url(#clippath-680);\n      }\n\n      .cls-437 {\n        clip-path: url(#clippath-293);\n      }\n\n      .cls-438 {\n        clip-path: url(#clippath-132);\n      }\n\n      .cls-43 {\n        fill: #9d417d;\n      }\n\n      .cls-439 {\n        clip-path: url(#clippath-276);\n      }\n\n      .cls-440 {\n        clip-path: url(#clippath-711);\n      }\n\n      .cls-441 {\n        clip-path: url(#clippath-557);\n      }\n\n      .cls-442 {\n        clip-path: url(#clippath-627);\n      }\n\n      .cls-44 {\n        fill: #ef665e;\n      }\n\n      .cls-443 {\n        clip-path: url(#clippath-427);\n      }\n\n      .cls-45 {\n        fill: #a44b77;\n      }\n\n      .cls-444 {\n        clip-path: url(#clippath-645);\n      }\n\n      .cls-46 {\n        fill: #a26538;\n      }\n\n      .cls-445 {\n        clip-path: url(#clippath-41);\n      }\n\n      .cls-446 {\n        clip-path: url(#clippath-661);\n      }\n\n      .cls-47 {\n        fill: #932e85;\n      }\n\n      .cls-447 {\n        clip-path: url(#clippath-334);\n      }\n\n      .cls-448 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-449 {\n        clip-path: url(#clippath-305);\n      }\n\n      .cls-450 {\n        clip-path: url(#clippath-190);\n      }\n\n      .cls-451 {\n        clip-path: url(#clippath-624);\n      }\n\n      .cls-48 {\n        fill: #8b5731;\n      }\n\n      .cls-452 {\n        clip-path: url(#clippath-309);\n      }\n\n      .cls-453 {\n        clip-path: url(#clippath-197);\n      }\n\n      .cls-49 {\n        fill: #f2775d;\n      }\n\n      .cls-454 {\n        clip-path: url(#clippath-108);\n      }\n\n      .cls-50 {\n        fill: #f3795c;\n      }\n\n      .cls-51 {\n        fill: #82512d;\n      }\n\n      .cls-52 {\n        fill: #cc7e44;\n      }\n\n      .cls-455 {\n        clip-path: url(#clippath-491);\n      }\n\n      .cls-456 {\n        clip-path: url(#clippath-163);\n      }\n\n      .cls-53 {\n        fill: #a66739;\n      }\n\n      .cls-54 {\n        fill: #935b33;\n      }\n\n      .cls-457 {\n        clip-path: url(#clippath-439);\n      }\n\n      .cls-458 {\n        clip-path: url(#clippath-112);\n      }\n\n      .cls-459 {\n        clip-path: url(#clippath-403);\n      }\n\n      .cls-55 {\n        fill: #faba3a;\n      }\n\n      .cls-56 {\n        fill: #f2725d;\n      }\n\n      .cls-460 {\n        clip-path: url(#clippath-87);\n      }\n\n      .cls-461 {\n        clip-path: url(#clippath-347);\n      }\n\n      .cls-57 {\n        fill: #85532e;\n      }\n\n      .cls-462 {\n        clip-path: url(#clippath-515);\n      }\n\n      .cls-463 {\n        clip-path: url(#clippath-536);\n      }\n\n      .cls-58 {\n        fill: #c55d67;\n      }\n\n      .cls-59 {\n        fill: #a34c77;\n      }\n\n      .cls-464 {\n        clip-path: url(#clippath-346);\n      }\n\n      .cls-465 {\n        clip-path: url(#clippath-512);\n      }\n\n      .cls-60 {\n        fill: #a9693a;\n      }\n\n      .cls-466 {\n        clip-path: url(#clippath-626);\n      }\n\n      .cls-467 {\n        clip-path: url(#clippath-385);\n      }\n\n      .cls-468 {\n        clip-path: url(#clippath-585);\n      }\n\n      .cls-61 {\n        fill: #f5885a;\n      }\n\n      .cls-469 {\n        clip-path: url(#clippath-217);\n      }\n\n      .cls-470 {\n        clip-path: url(#clippath-194);\n      }\n\n      .cls-471 {\n        clip-path: url(#clippath-553);\n      }\n\n      .cls-472 {\n        clip-path: url(#clippath-341);\n      }\n\n      .cls-473 {\n        clip-path: url(#clippath-142);\n      }\n\n      .cls-474 {\n        clip-path: url(#clippath-173);\n      }\n\n      .cls-475 {\n        clip-path: url(#clippath-478);\n      }\n\n      .cls-62 {\n        fill: #8f268a;\n      }\n\n      .cls-476 {\n        clip-path: url(#clippath-281);\n      }\n\n      .cls-477 {\n        clip-path: url(#clippath-236);\n      }\n\n      .cls-478 {\n        clip-path: url(#clippath-282);\n      }\n\n      .cls-479 {\n        clip-path: url(#clippath-83);\n      }\n\n      .cls-480 {\n        clip-path: url(#clippath-128);\n      }\n\n      .cls-63 {\n        fill: #f16e5d;\n      }\n\n      .cls-481 {\n        clip-path: url(#clippath-319);\n      }\n\n      .cls-482 {\n        clip-path: url(#clippath-119);\n      }\n\n      .cls-64 {\n        fill: #7e4e2b;\n      }\n\n      .cls-483 {\n        clip-path: url(#clippath-353);\n      }\n\n      .cls-484 {\n        clip-path: url(#clippath-114);\n      }\n\n      .cls-65 {\n        fill: #eb655e;\n      }\n\n      .cls-66 {\n        fill: #a34a77;\n      }\n\n      .cls-485 {\n        clip-path: url(#clippath-648);\n      }\n\n      .cls-486 {\n        clip-path: url(#clippath-398);\n      }\n\n      .cls-487 {\n        clip-path: url(#clippath-243);\n      }\n\n      .cls-488 {\n        clip-path: url(#clippath-185);\n      }\n\n      .cls-67 {\n        fill: #953283;\n      }\n\n      .cls-489 {\n        clip-path: url(#clippath-105);\n      }\n\n      .cls-490 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-491 {\n        clip-path: url(#clippath-554);\n      }\n\n      .cls-68 {\n        fill: #f69e4f;\n      }\n\n      .cls-492 {\n        clip-path: url(#clippath-441);\n      }\n\n      .cls-493 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-494 {\n        clip-path: url(#clippath-714);\n      }\n\n      .cls-495 {\n        clip-path: url(#clippath-325);\n      }\n\n      .cls-496 {\n        clip-path: url(#clippath-586);\n      }\n\n      .cls-69 {\n        fill: #c35c67;\n      }\n\n      .cls-497 {\n        clip-path: url(#clippath-295);\n      }\n\n      .cls-498 {\n        clip-path: url(#clippath-88);\n      }\n\n      .cls-499 {\n        clip-path: url(#clippath-402);\n      }\n\n      .cls-500 {\n        clip-path: url(#clippath-115);\n      }\n\n      .cls-70 {\n        fill: #ab576f;\n      }\n\n      .cls-501 {\n        clip-path: url(#clippath-182);\n      }\n\n      .cls-502 {\n        clip-path: url(#clippath-386);\n      }\n\n      .cls-71 {\n        fill: #f8aa48;\n      }\n\n      .cls-503 {\n        clip-path: url(#clippath-479);\n      }\n\n      .cls-504 {\n        clip-path: url(#clippath-124);\n      }\n\n      .cls-72 {\n        fill: #a85372;\n      }\n\n      .cls-505 {\n        clip-path: url(#clippath-368);\n      }\n\n      .cls-73 {\n        fill: #f2745d;\n      }\n\n      .cls-74 {\n        fill: #f58a59;\n      }\n\n      .cls-506 {\n        clip-path: url(#clippath-348);\n      }\n\n      .cls-507 {\n        clip-path: url(#clippath-225);\n      }\n\n      .cls-508 {\n        clip-path: url(#clippath-37);\n      }\n\n      .cls-75 {\n        fill: #f7a14e;\n      }\n\n      .cls-76 {\n        fill: #6d4325;\n      }\n\n      .cls-77 {\n        fill: #942f85;\n      }\n\n      .cls-78 {\n        fill: #794b2a;\n      }\n\n      .cls-509 {\n        clip-path: url(#clippath-248);\n      }\n\n      .cls-510 {\n        clip-path: url(#clippath-46);\n      }\n\n      .cls-511 {\n        clip-path: url(#clippath-25);\n      }\n\n      .cls-512 {\n        clip-path: url(#clippath-484);\n      }\n\n      .cls-80 {\n        fill: #84522e;\n      }\n\n      .cls-513 {\n        clip-path: url(#clippath-98);\n      }\n\n      .cls-81 {\n        fill: #c65d67;\n      }\n\n      .cls-82 {\n        fill: #a64f74;\n      }\n\n      .cls-514 {\n        clip-path: url(#clippath-650);\n      }\n\n      .cls-515 {\n        clip-path: url(#clippath-407);\n      }\n\n      .cls-516 {\n        clip-path: url(#clippath-369);\n      }\n\n      .cls-83 {\n        fill: #e16360;\n      }\n\n      .cls-517 {\n        clip-path: url(#clippath-651);\n      }\n\n      .cls-84 {\n        fill: #df6261;\n      }\n\n      .cls-518 {\n        clip-path: url(#clippath-219);\n      }\n\n      .cls-519 {\n        clip-path: url(#clippath-563);\n      }\n\n      .cls-520 {\n        clip-path: url(#clippath-172);\n      }\n\n      .cls-521 {\n        clip-path: url(#clippath-499);\n      }\n\n      .cls-522 {\n        clip-path: url(#clippath-107);\n      }\n\n      .cls-523 {\n        clip-path: url(#clippath-561);\n      }\n\n      .cls-85 {\n        fill: #a16438;\n      }\n\n      .cls-86 {\n        fill: #963383;\n      }\n\n      .cls-87 {\n        fill: #f4825b;\n      }\n\n      .cls-524 {\n        clip-path: url(#clippath-656);\n      }\n\n      .cls-525 {\n        clip-path: url(#clippath-644);\n      }\n\n      .cls-526 {\n        clip-path: url(#clippath-164);\n      }\n\n      .cls-527 {\n        clip-path: url(#clippath-628);\n      }\n\n      .cls-528 {\n        clip-path: url(#clippath-590);\n      }\n\n      .cls-88 {\n        fill: #9d3f7d;\n      }\n\n      .cls-89 {\n        fill: #f58c59;\n      }\n\n      .cls-90 {\n        fill: #a24978;\n      }\n\n      .cls-529 {\n        clip-path: url(#clippath-707);\n      }\n\n      .cls-530 {\n        clip-path: url(#clippath-493);\n      }\n\n      .cls-531 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-532 {\n        clip-path: url(#clippath-713);\n      }\n\n      .cls-533 {\n        clip-path: url(#clippath-415);\n      }\n\n      .cls-534 {\n        clip-path: url(#clippath-705);\n      }\n\n      .cls-91 {\n        fill: #e6645f;\n      }\n\n      .cls-535 {\n        clip-path: url(#clippath-196);\n      }\n\n      .cls-92 {\n        fill: #a0447b;\n      }\n\n      .cls-536 {\n        clip-path: url(#clippath-568);\n      }\n\n      .cls-537 {\n        clip-path: url(#clippath-247);\n      }\n\n      .cls-538 {\n        clip-path: url(#clippath-391);\n      }\n\n      .cls-93 {\n        fill: #f4855b;\n      }\n\n      .cls-539 {\n        clip-path: url(#clippath-396);\n      }\n\n      .cls-540 {\n        clip-path: url(#clippath-697);\n      }\n\n      .cls-541 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-94 {\n        fill: #cd5f65;\n      }\n\n      .cls-542 {\n        clip-path: url(#clippath-153);\n      }\n\n      .cls-95 {\n        fill: #ba733f;\n      }\n\n      .cls-543 {\n        clip-path: url(#clippath-266);\n      }\n\n      .cls-544 {\n        clip-path: url(#clippath-299);\n      }\n\n      .cls-96 {\n        fill: #d26064;\n      }\n\n      .cls-545 {\n        clip-path: url(#clippath-508);\n      }\n\n      .cls-97 {\n        fill: #f7ae45;\n      }\n\n      .cls-546 {\n        clip-path: url(#clippath-104);\n      }\n\n      .cls-547 {\n        clip-path: url(#clippath-76);\n      }\n\n      .cls-98 {\n        fill: #b2596d;\n      }\n\n      .cls-548 {\n        clip-path: url(#clippath-527);\n      }\n\n      .cls-549 {\n        clip-path: url(#clippath-269);\n      }\n\n      .cls-99 {\n        fill: #d08045;\n      }\n\n      .cls-550 {\n        clip-path: url(#clippath-393);\n      }\n\n      .cls-100 {\n        fill: #ae586e;\n      }\n\n      .cls-101 {\n        fill: #9f6337;\n      }\n\n      .cls-551 {\n        clip-path: url(#clippath-255);\n      }\n\n      .cls-552 {\n        clip-path: url(#clippath-545);\n      }\n\n      .cls-553 {\n        clip-path: url(#clippath-40);\n      }\n\n      .cls-102 {\n        fill: #a36538;\n      }\n\n      .cls-554 {\n        clip-path: url(#clippath-566);\n      }\n\n      .cls-103 {\n        fill: #9b3e7e;\n      }\n\n      .cls-555 {\n        clip-path: url(#clippath-117);\n      }\n\n      .cls-556 {\n        clip-path: url(#clippath-521);\n      }\n\n      .cls-557 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-104 {\n        fill: #f7ac46;\n      }\n\n      .cls-105 {\n        fill: #db6161;\n      }\n\n      .cls-558 {\n        clip-path: url(#clippath-81);\n      }\n\n      .cls-559 {\n        clip-path: url(#clippath-390);\n      }\n\n      .cls-106 {\n        fill: #fabd36;\n      }\n\n      .cls-560 {\n        clip-path: url(#clippath-698);\n      }\n\n      .cls-561 {\n        clip-path: url(#clippath-504);\n      }\n\n      .cls-562 {\n        clip-path: url(#clippath-567);\n      }\n\n      .cls-107 {\n        fill: #cf8045;\n      }\n\n      .cls-563 {\n        clip-path: url(#clippath-549);\n      }\n\n      .cls-108 {\n        fill: #a85471;\n      }\n\n      .cls-109 {\n        fill: #b2596c;\n      }\n\n      .cls-564 {\n        clip-path: url(#clippath-531);\n      }\n\n      .cls-565 {\n        clip-path: url(#clippath-579);\n      }\n\n      .cls-566 {\n        clip-path: url(#clippath-296);\n      }\n\n      .cls-567 {\n        clip-path: url(#clippath-693);\n      }\n\n      .cls-568 {\n        clip-path: url(#clippath-111);\n      }\n\n      .cls-569 {\n        clip-path: url(#clippath-473);\n      }\n\n      .cls-110 {\n        fill: #902889;\n      }\n\n      .cls-570 {\n        clip-path: url(#clippath-603);\n      }\n\n      .cls-571 {\n        clip-path: url(#clippath-469);\n      }\n\n      .cls-572 {\n        clip-path: url(#clippath-497);\n      }\n\n      .cls-573 {\n        clip-path: url(#clippath-318);\n      }\n\n      .cls-574 {\n        clip-path: url(#clippath-574);\n      }\n\n      .cls-575 {\n        clip-path: url(#clippath-511);\n      }\n\n      .cls-576 {\n        clip-path: url(#clippath-181);\n      }\n\n      .cls-111 {\n        fill: #c67b42;\n      }\n\n      .cls-112 {\n        fill: #f1695d;\n      }\n\n      .cls-577 {\n        clip-path: url(#clippath-278);\n      }\n\n      .cls-578 {\n        clip-path: url(#clippath-525);\n      }\n\n      .cls-113 {\n        fill: #8b5630;\n      }\n\n      .cls-579 {\n        clip-path: url(#clippath-460);\n      }\n\n      .cls-114 {\n        fill: #f26f5d;\n      }\n\n      .cls-580 {\n        clip-path: url(#clippath-394);\n      }\n\n      .cls-581 {\n        clip-path: url(#clippath-435);\n      }\n\n      .cls-115 {\n        fill: #895530;\n      }\n\n      .cls-116 {\n        fill: #9a3c80;\n      }\n\n      .cls-582 {\n        clip-path: url(#clippath-556);\n      }\n\n      .cls-583 {\n        clip-path: url(#clippath-75);\n      }\n\n      .cls-117 {\n        fill: #a85173;\n      }\n\n      .cls-584 {\n        clip-path: url(#clippath-246);\n      }\n\n      .cls-118 {\n        fill: #b4703e;\n      }\n\n      .cls-119 {\n        fill: #c05c69;\n      }\n\n      .cls-585 {\n        clip-path: url(#clippath-523);\n      }\n\n      .cls-120 {\n        fill: #9a3a80;\n      }\n\n      .cls-586 {\n        clip-path: url(#clippath-458);\n      }\n\n      .cls-121 {\n        fill: #f7ab46;\n      }\n\n      .cls-587 {\n        clip-path: url(#clippath-453);\n      }\n\n      .cls-588 {\n        clip-path: url(#clippath-381);\n      }\n\n      .cls-122 {\n        fill: none;\n      }\n\n      .cls-589 {\n        clip-path: url(#clippath-317);\n      }\n\n      .cls-123 {\n        fill: #c37941;\n      }\n\n      .cls-590 {\n        clip-path: url(#clippath-189);\n      }\n\n      .cls-124 {\n        fill: #b65a6b;\n      }\n\n      .cls-591 {\n        clip-path: url(#clippath-250);\n      }\n\n      .cls-125 {\n        fill: #973582;\n      }\n\n      .cls-126 {\n        fill: #a44c76;\n      }\n\n      .cls-592 {\n        clip-path: url(#clippath-392);\n      }\n\n      .cls-127 {\n        fill: #932e86;\n      }\n\n      .cls-593 {\n        clip-path: url(#clippath-461);\n      }\n\n      .cls-594 {\n        clip-path: url(#clippath-481);\n      }\n\n      .cls-128 {\n        fill: #764828;\n      }\n\n      .cls-595 {\n        clip-path: url(#clippath-573);\n      }\n\n      .cls-129 {\n        fill: #9b3c7f;\n      }\n\n      .cls-130 {\n        fill: #f4875b;\n      }\n\n      .cls-596 {\n        clip-path: url(#clippath-336);\n      }\n\n      .cls-597 {\n        clip-path: url(#clippath-312);\n      }\n\n      .cls-598 {\n        clip-path: url(#clippath-517);\n      }\n\n      .cls-599 {\n        clip-path: url(#clippath-226);\n      }\n\n      .cls-600 {\n        clip-path: url(#clippath-167);\n      }\n\n      .cls-131 {\n        fill: #f9b83b;\n      }\n\n      .cls-601 {\n        clip-path: url(#clippath-354);\n      }\n\n      .cls-602 {\n        clip-path: url(#clippath-625);\n      }\n\n      .cls-603 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-604 {\n        clip-path: url(#clippath-570);\n      }\n\n      .cls-605 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-606 {\n        clip-path: url(#clippath-529);\n      }\n\n      .cls-607 {\n        clip-path: url(#clippath-130);\n      }\n\n      .cls-132 {\n        fill: #724627;\n      }\n\n      .cls-608 {\n        clip-path: url(#clippath-716);\n      }\n\n      .cls-609 {\n        clip-path: url(#clippath-706);\n      }\n\n      .cls-610 {\n        clip-path: url(#clippath-668);\n      }\n\n      .cls-133 {\n        fill: #a75074;\n      }\n\n      .cls-611 {\n        clip-path: url(#clippath-551);\n      }\n\n      .cls-134 {\n        fill: #fabc37;\n      }\n\n      .cls-612 {\n        clip-path: url(#clippath-676);\n      }\n\n      .cls-613 {\n        clip-path: url(#clippath-34);\n      }\n\n      .cls-135 {\n        fill: #d05f65;\n      }\n\n      .cls-136 {\n        fill: #f7ad45;\n      }\n\n      .cls-614 {\n        clip-path: url(#clippath-214);\n      }\n\n      .cls-615 {\n        clip-path: url(#clippath-700);\n      }\n\n      .cls-616 {\n        clip-path: url(#clippath-176);\n      }\n\n      .cls-137 {\n        fill: #f2785c;\n      }\n\n      .cls-617 {\n        clip-path: url(#clippath-57);\n      }\n\n      .cls-618 {\n        clip-path: url(#clippath-264);\n      }\n\n      .cls-138 {\n        fill: #a54d76;\n      }\n\n      .cls-619 {\n        clip-path: url(#clippath-102);\n      }\n\n      .cls-620 {\n        clip-path: url(#clippath-228);\n      }\n\n      .cls-139 {\n        fill: #f1675d;\n      }\n\n      .cls-621 {\n        clip-path: url(#clippath-335);\n      }\n\n      .cls-622 {\n        clip-path: url(#clippath-616);\n      }\n\n      .cls-623 {\n        clip-path: url(#clippath-688);\n      }\n\n      .cls-140 {\n        fill: #c35c68;\n      }\n\n      .cls-141 {\n        fill: #985e35;\n      }\n\n      .cls-624 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-625 {\n        clip-path: url(#clippath-672);\n      }\n\n      .cls-626 {\n        clip-path: url(#clippath-673);\n      }\n\n      .cls-627 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-628 {\n        clip-path: url(#clippath-329);\n      }\n\n      .cls-629 {\n        clip-path: url(#clippath-138);\n      }\n\n      .cls-630 {\n        clip-path: url(#clippath-210);\n      }\n\n      .cls-631 {\n        clip-path: url(#clippath-331);\n      }\n\n      .cls-632 {\n        clip-path: url(#clippath-38);\n      }\n\n      .cls-142 {\n        fill: #a54e75;\n      }\n\n      .cls-633 {\n        clip-path: url(#clippath-449);\n      }\n\n      .cls-143 {\n        fill: #b95b6b;\n      }\n\n      .cls-144 {\n        fill: #f8b042;\n      }\n\n      .cls-634 {\n        clip-path: url(#clippath-200);\n      }\n\n      .cls-635 {\n        clip-path: url(#clippath-641);\n      }\n\n      .cls-145 {\n        fill: #7f4f2b;\n      }\n\n      .cls-636 {\n        clip-path: url(#clippath-634);\n      }\n\n      .cls-146 {\n        fill: #a0467b;\n      }\n\n      .cls-637 {\n        clip-path: url(#clippath-689);\n      }\n\n      .cls-147 {\n        fill: #983880;\n      }\n\n      .cls-638 {\n        clip-path: url(#clippath-245);\n      }\n\n      .cls-639 {\n        clip-path: url(#clippath-712);\n      }\n\n      .cls-148 {\n        fill: #a56639;\n      }\n\n      .cls-640 {\n        clip-path: url(#clippath-36);\n      }\n\n      .cls-641 {\n        clip-path: url(#clippath-127);\n      }\n\n      .cls-642 {\n        clip-path: url(#clippath-27);\n      }\n\n      .cls-149 {\n        fill: #aa5670;\n      }\n\n      .cls-643 {\n        clip-path: url(#clippath-125);\n      }\n\n      .cls-150 {\n        fill: #c97c43;\n      }\n\n      .cls-151 {\n        fill: #f7a34c;\n      }\n\n      .cls-644 {\n        clip-path: url(#clippath-581);\n      }\n\n      .cls-645 {\n        clip-path: url(#clippath-687);\n      }\n\n      .cls-646 {\n        clip-path: url(#clippath-528);\n      }\n\n      .cls-647 {\n        clip-path: url(#clippath-380);\n      }\n\n      .cls-648 {\n        clip-path: url(#clippath-109);\n      }\n\n      .cls-649 {\n        clip-path: url(#clippath-434);\n      }\n\n      .cls-152 {\n        fill: #b8723e;\n      }\n\n      .cls-153 {\n        fill: #cb5e66;\n      }\n\n      .cls-154 {\n        fill: #f5895a;\n      }\n\n      .cls-155 {\n        fill: #983581;\n      }\n\n      .cls-650 {\n        clip-path: url(#clippath-149);\n      }\n\n      .cls-156 {\n        fill: #d76063;\n      }\n\n      .cls-651 {\n        clip-path: url(#clippath-316);\n      }\n\n      .cls-157 {\n        fill: #dc6261;\n      }\n\n      .cls-652 {\n        clip-path: url(#clippath-141);\n      }\n\n      .cls-653 {\n        clip-path: url(#clippath-643);\n      }\n\n      .cls-158 {\n        fill: #9d417c;\n      }\n\n      .cls-654 {\n        clip-path: url(#clippath-272);\n      }\n\n      .cls-655 {\n        clip-path: url(#clippath-101);\n      }\n\n      .cls-656 {\n        clip-path: url(#clippath-239);\n      }\n\n      .cls-159 {\n        fill: #8f5932;\n      }\n\n      .cls-160 {\n        fill: #f7a54b;\n      }\n\n      .cls-657 {\n        clip-path: url(#clippath-635);\n      }\n\n      .cls-161 {\n        fill: #f69355;\n      }\n\n      .cls-658 {\n        clip-path: url(#clippath-60);\n      }\n\n      .cls-162 {\n        fill: #f2755d;\n      }\n\n      .cls-659 {\n        clip-path: url(#clippath-690);\n      }\n\n      .cls-660 {\n        clip-path: url(#clippath-475);\n      }\n\n      .cls-661 {\n        clip-path: url(#clippath-421);\n      }\n\n      .cls-163 {\n        fill: #bd5c6a;\n      }\n\n      .cls-164 {\n        fill: #915a32;\n      }\n\n      .cls-662 {\n        clip-path: url(#clippath-429);\n      }\n\n      .cls-663 {\n        clip-path: url(#clippath-638);\n      }\n\n      .cls-165 {\n        fill: #a14879;\n      }\n\n      .cls-664 {\n        clip-path: url(#clippath-662);\n      }\n\n      .cls-665 {\n        clip-path: url(#clippath-471);\n      }\n\n      .cls-166 {\n        fill: #fabb39;\n      }\n\n      .cls-666 {\n        clip-path: url(#clippath-168);\n      }\n\n      .cls-667 {\n        clip-path: url(#clippath-677);\n      }\n\n      .cls-668 {\n        clip-path: url(#clippath-44);\n      }\n\n      .cls-669 {\n        clip-path: url(#clippath-332);\n      }\n\n      .cls-670 {\n        clip-path: url(#clippath-154);\n      }\n\n      .cls-671 {\n        clip-path: url(#clippath-383);\n      }\n\n      .cls-672 {\n        clip-path: url(#clippath-122);\n      }\n\n      .cls-673 {\n        clip-path: url(#clippath-580);\n      }\n\n      .cls-167 {\n        fill: #f69455;\n      }\n\n      .cls-674 {\n        clip-path: url(#clippath-314);\n      }\n\n      .cls-675 {\n        clip-path: url(#clippath-397);\n      }\n\n      .cls-168 {\n        fill: #d96162;\n      }\n\n      .cls-676 {\n        clip-path: url(#clippath-678);\n      }\n\n      .cls-677 {\n        clip-path: url(#clippath-604);\n      }\n\n      .cls-169 {\n        fill: #f69b51;\n      }\n\n      .cls-170 {\n        fill: #f79953;\n      }\n\n      .cls-171 {\n        fill: #905a32;\n      }\n\n      .cls-678 {\n        clip-path: url(#clippath-640);\n      }\n\n      .cls-679 {\n        clip-path: url(#clippath-192);\n      }\n\n      .cls-172 {\n        fill: #f69256;\n      }\n\n      .cls-680 {\n        clip-path: url(#clippath-646);\n      }\n\n      .cls-681 {\n        clip-path: url(#clippath-519);\n      }\n\n      .cls-682 {\n        clip-path: url(#clippath-426);\n      }\n\n      .cls-683 {\n        clip-path: url(#clippath-139);\n      }\n\n      .cls-173 {\n        fill: #bd5c69;\n      }\n\n      .cls-684 {\n        clip-path: url(#clippath-633);\n      }\n\n      .cls-685 {\n        clip-path: url(#clippath-366);\n      }\n\n      .cls-686 {\n        clip-path: url(#clippath-614);\n      }\n\n      .cls-174 {\n        fill: #b0586d;\n      }\n\n      .cls-687 {\n        clip-path: url(#clippath-232);\n      }\n\n      .cls-688 {\n        clip-path: url(#clippath-345);\n      }\n\n      .cls-689 {\n        clip-path: url(#clippath-576);\n      }\n\n      .cls-690 {\n        clip-path: url(#clippath-674);\n      }\n\n      .cls-175 {\n        fill: #88542f;\n      }\n\n      .cls-176 {\n        fill: #925b32;\n      }\n\n      .cls-691 {\n        clip-path: url(#clippath-601);\n      }\n\n      .cls-692 {\n        clip-path: url(#clippath-395);\n      }\n\n      .cls-693 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-177 {\n        fill: #d86162;\n      }\n\n      .cls-178 {\n        fill: #c75d67;\n      }\n\n      .cls-694 {\n        clip-path: url(#clippath-377);\n      }\n\n      .cls-179 {\n        fill: #f8a64a;\n      }\n\n      .cls-695 {\n        clip-path: url(#clippath-516);\n      }\n\n      .cls-180 {\n        fill: #f8aa47;\n      }\n\n      .cls-696 {\n        clip-path: url(#clippath-273);\n      }\n\n      .cls-697 {\n        clip-path: url(#clippath-548);\n      }\n\n      .cls-181 {\n        fill: #ca5e66;\n      }\n\n      .cls-698 {\n        clip-path: url(#clippath-463);\n      }\n\n      .cls-699 {\n        clip-path: url(#clippath-134);\n      }\n\n      .cls-700 {\n        clip-path: url(#clippath-113);\n      }\n\n      .cls-182 {\n        fill: #c15c68;\n      }\n\n      .cls-701 {\n        clip-path: url(#clippath-352);\n      }\n\n      .cls-702 {\n        clip-path: url(#clippath-178);\n      }\n\n      .cls-703 {\n        clip-path: url(#clippath-95);\n      }\n\n      .cls-704 {\n        clip-path: url(#clippath-365);\n      }\n\n      .cls-705 {\n        clip-path: url(#clippath-284);\n      }\n\n      .cls-706 {\n        clip-path: url(#clippath-447);\n      }\n\n      .cls-707 {\n        clip-path: url(#clippath-221);\n      }\n\n      .cls-183 {\n        fill: #f2705d;\n      }\n\n      .cls-184 {\n        fill: #cb7e44;\n      }\n\n      .cls-185 {\n        fill: #bc7540;\n      }\n\n      .cls-186 {\n        fill: #9c3f7e;\n      }\n\n      .cls-187 {\n        fill: #993880;\n      }\n\n      .cls-188 {\n        fill: #f7a44b;\n      }\n\n      .cls-708 {\n        clip-path: url(#clippath-80);\n      }\n\n      .cls-709 {\n        clip-path: url(#clippath-310);\n      }\n\n      .cls-710 {\n        clip-path: url(#clippath-242);\n      }\n\n      .cls-711 {\n        clip-path: url(#clippath-330);\n      }\n\n      .cls-712 {\n        clip-path: url(#clippath-254);\n      }\n\n      .cls-189 {\n        fill: #6f4426;\n      }\n\n      .cls-190 {\n        fill: #a0457a;\n      }\n\n      .cls-191 {\n        fill: #953184;\n      }\n\n      .cls-713 {\n        clip-path: url(#clippath-600);\n      }\n\n      .cls-714 {\n        clip-path: url(#clippath-468);\n      }\n\n      .cls-192 {\n        fill: #a75073;\n      }\n\n      .cls-193 {\n        fill: #d66063;\n      }\n\n      .cls-194 {\n        fill: #be7640;\n      }\n\n      .cls-715 {\n        clip-path: url(#clippath-229);\n      }\n\n      .cls-195 {\n        fill: #f8b141;\n      }\n\n      .cls-196 {\n        fill: #f7a24d;\n      }\n\n      .cls-716 {\n        clip-path: url(#clippath-241);\n      }\n\n      .cls-717 {\n        clip-path: url(#clippath-583);\n      }\n\n      .cls-718 {\n        clip-path: url(#clippath-203);\n      }\n\n      .cls-719 {\n        clip-path: url(#clippath-364);\n      }\n\n      .cls-720 {\n        clip-path: url(#clippath-620);\n      }\n\n      .cls-197 {\n        fill: #ba743f;\n      }\n\n      .cls-198 {\n        fill: #9c6136;\n      }\n\n      .cls-721 {\n        clip-path: url(#clippath-513);\n      }\n\n      .cls-722 {\n        clip-path: url(#clippath-120);\n      }\n\n      .cls-723 {\n        clip-path: url(#clippath-546);\n      }\n\n      .cls-724 {\n        clip-path: url(#clippath-231);\n      }\n\n      .cls-725 {\n        clip-path: url(#clippath-494);\n      }\n\n      .cls-726 {\n        clip-path: url(#clippath-384);\n      }\n\n      .cls-727 {\n        clip-path: url(#clippath-147);\n      }\n\n      .cls-199 {\n        fill: #b6713e;\n      }\n\n      .cls-200 {\n        fill: #8d5831;\n      }\n\n      .cls-728 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-729 {\n        clip-path: url(#clippath-490);\n      }\n\n      .cls-201 {\n        fill: #f7a14d;\n      }\n\n      .cls-202 {\n        fill: #9b6136;\n      }\n\n      .cls-730 {\n        clip-path: url(#clippath-373);\n      }\n\n      .cls-203 {\n        fill: #f69c51;\n      }\n\n      .cls-731 {\n        clip-path: url(#clippath-211);\n      }\n\n      .cls-204 {\n        fill: #a34a78;\n      }\n\n      .cls-732 {\n        clip-path: url(#clippath-304);\n      }\n\n      .cls-733 {\n        clip-path: url(#clippath-307);\n      }\n\n      .cls-734 {\n        clip-path: url(#clippath-432);\n      }\n\n      .cls-735 {\n        clip-path: url(#clippath-675);\n      }\n\n      .cls-205 {\n        fill: #f59952;\n      }\n\n      .cls-206 {\n        fill: #804f2c;\n      }\n\n      .cls-736 {\n        clip-path: url(#clippath-237);\n      }\n\n      .cls-737 {\n        clip-path: url(#clippath-222);\n      }\n\n      .cls-738 {\n        clip-path: url(#clippath-285);\n      }\n\n      .cls-739 {\n        clip-path: url(#clippath-540);\n      }\n\n      .cls-207 {\n        fill: #ce5f65;\n      }\n\n      .cls-740 {\n        clip-path: url(#clippath-622);\n      }\n\n      .cls-741 {\n        clip-path: url(#clippath-99);\n      }\n\n      .cls-742 {\n        clip-path: url(#clippath-166);\n      }\n\n      .cls-208 {\n        fill: #922b87;\n      }\n\n      .cls-743 {\n        clip-path: url(#clippath-487);\n      }\n\n      .cls-744 {\n        clip-path: url(#clippath-268);\n      }\n\n      .cls-745 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-209 {\n        fill: #bb5b6a;\n      }\n\n      .cls-210 {\n        fill: #a65073;\n      }\n\n      .cls-746 {\n        clip-path: url(#clippath-308);\n      }\n\n      .cls-747 {\n        clip-path: url(#clippath-193);\n      }\n\n      .cls-211 {\n        fill: #714526;\n      }\n\n      .cls-748 {\n        clip-path: url(#clippath-179);\n      }\n\n      .cls-212 {\n        fill: #270f06;\n      }\n\n      .cls-213 {\n        fill: #b46f3d;\n      }\n\n      .cls-214 {\n        fill: #9d407d;\n      }\n\n      .cls-215 {\n        fill: #f79853;\n      }\n\n      .cls-216 {\n        fill: #da6162;\n      }\n\n      .cls-217 {\n        fill: #f8ae44;\n      }\n\n      .cls-749 {\n        clip-path: url(#clippath-367);\n      }\n\n      .cls-750 {\n        clip-path: url(#clippath-462);\n      }\n\n      .cls-751 {\n        clip-path: url(#clippath-701);\n      }\n\n      .cls-218 {\n        fill: #7c4d2b;\n      }\n\n      .cls-752 {\n        clip-path: url(#clippath-483);\n      }\n\n      .cls-219 {\n        fill: #f69a52;\n      }\n\n      .cls-753 {\n        clip-path: url(#clippath-507);\n      }\n\n      .cls-754 {\n        clip-path: url(#clippath-79);\n      }\n\n      .cls-755 {\n        clip-path: url(#clippath-699);\n      }\n\n      .cls-756 {\n        clip-path: url(#clippath-535);\n      }\n\n      .cls-757 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-220 {\n        fill: #f1685e;\n      }\n\n      .cls-758 {\n        clip-path: url(#clippath-96);\n      }\n\n      .cls-759 {\n        clip-path: url(#clippath-195);\n      }\n\n      .cls-760 {\n        clip-path: url(#clippath-343);\n      }\n\n      .cls-761 {\n        clip-path: url(#clippath-691);\n      }\n\n      .cls-762 {\n        clip-path: url(#clippath-657);\n      }\n\n      .cls-763 {\n        clip-path: url(#clippath-562);\n      }\n\n      .cls-764 {\n        clip-path: url(#clippath-150);\n      }\n\n      .cls-221 {\n        fill: #c07741;\n      }\n\n      .cls-222 {\n        fill: #c27841;\n      }\n\n      .cls-765 {\n        clip-path: url(#clippath-201);\n      }\n\n      .cls-766 {\n        clip-path: url(#clippath-389);\n      }\n\n      .cls-767 {\n        clip-path: url(#clippath-437);\n      }\n\n      .cls-768 {\n        clip-path: url(#clippath-215);\n      }\n\n      .cls-769 {\n        clip-path: url(#clippath-509);\n      }\n\n      .cls-223 {\n        fill: #963482;\n      }\n\n      .cls-224 {\n        fill: #f4845b;\n      }\n\n      .cls-225 {\n        fill: #943084;\n      }\n\n      .cls-226 {\n        fill: #b36f3d;\n      }\n\n      .cls-770 {\n        clip-path: url(#clippath-607);\n      }\n\n      .cls-771 {\n        clip-path: url(#clippath-271);\n      }\n\n      .cls-772 {\n        clip-path: url(#clippath-522);\n      }\n\n      .cls-773 {\n        clip-path: url(#clippath-623);\n      }\n\n      .cls-774 {\n        clip-path: url(#clippath-274);\n      }\n\n      .cls-775 {\n        clip-path: url(#clippath-259);\n      }\n\n      .cls-776 {\n        clip-path: url(#clippath-183);\n      }\n\n      .cls-777 {\n        clip-path: url(#clippath-454);\n      }\n\n      .cls-778 {\n        clip-path: url(#clippath-103);\n      }\n\n      .cls-227 {\n        fill: #8e5831;\n      }\n\n      .cls-779 {\n        clip-path: url(#clippath-696);\n      }\n\n      .cls-228 {\n        fill: #f37f5c;\n      }\n\n      .cls-229 {\n        fill: #f69654;\n      }\n\n      .cls-230 {\n        fill: #9f457b;\n      }\n\n      .cls-780 {\n        clip-path: url(#clippath-126);\n      }\n\n      .cls-781 {\n        clip-path: url(#clippath-137);\n      }\n\n      .cls-782 {\n        clip-path: url(#clippath-338);\n      }\n\n      .cls-231 {\n        fill: #9f437b;\n      }\n\n      .cls-783 {\n        clip-path: url(#clippath-252);\n      }\n\n      .cls-784 {\n        clip-path: url(#clippath-533);\n      }\n\n      .cls-785 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-232 {\n        fill: #cf5f65;\n      }\n\n      .cls-786 {\n        clip-path: url(#clippath-413);\n      }\n\n      .cls-787 {\n        clip-path: url(#clippath-82);\n      }\n\n      .cls-233 {\n        fill: #f9bd36;\n      }\n\n      .cls-788 {\n        clip-path: url(#clippath-52);\n      }\n\n      .cls-789 {\n        clip-path: url(#clippath-455);\n      }\n\n      .cls-790 {\n        clip-path: url(#clippath-144);\n      }\n\n      .cls-791 {\n        clip-path: url(#clippath-541);\n      }\n\n      .cls-792 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-793 {\n        clip-path: url(#clippath-262);\n      }\n\n      .cls-794 {\n        clip-path: url(#clippath-496);\n      }\n\n      .cls-234 {\n        fill: #ab566f;\n      }\n\n      .cls-795 {\n        clip-path: url(#clippath-280);\n      }\n\n      .cls-796 {\n        clip-path: url(#clippath-204);\n      }\n\n      .cls-797 {\n        clip-path: url(#clippath-187);\n      }\n\n      .cls-798 {\n        clip-path: url(#clippath-665);\n      }\n\n      .cls-799 {\n        clip-path: url(#clippath-694);\n      }\n\n      .cls-800 {\n        clip-path: url(#clippath-412);\n      }\n\n      .cls-801 {\n        clip-path: url(#clippath-406);\n      }\n\n      .cls-802 {\n        clip-path: url(#clippath-50);\n      }\n\n      .cls-803 {\n        clip-path: url(#clippath-152);\n      }\n\n      .cls-804 {\n        clip-path: url(#clippath-301);\n      }\n\n      .cls-805 {\n        clip-path: url(#clippath-156);\n      }\n\n      .cls-235 {\n        fill: #f8b240;\n      }\n\n      .cls-806 {\n        clip-path: url(#clippath-605);\n      }\n\n      .cls-236 {\n        fill: #f58e58;\n      }\n\n      .cls-807 {\n        clip-path: url(#clippath-48);\n      }\n\n      .cls-237 {\n        fill: #f79753;\n      }\n\n      .cls-808 {\n        clip-path: url(#clippath-61);\n      }\n\n      .cls-809 {\n        clip-path: url(#clippath-180);\n      }\n\n      .cls-238 {\n        fill: #f58b59;\n      }\n\n      .cls-810 {\n        clip-path: url(#clippath-159);\n      }\n\n      .cls-811 {\n        clip-path: url(#clippath-198);\n      }\n\n      .cls-812 {\n        clip-path: url(#clippath-452);\n      }\n\n      .cls-813 {\n        clip-path: url(#clippath-39);\n      }\n\n      .cls-239 {\n        fill: #f8a849;\n      }\n\n      .cls-814 {\n        clip-path: url(#clippath-503);\n      }\n\n      .cls-815 {\n        clip-path: url(#clippath-704);\n      }\n\n      .cls-816 {\n        clip-path: url(#clippath-532);\n      }\n\n      .cls-817 {\n        clip-path: url(#clippath-617);\n      }\n\n      .cls-240 {\n        fill: #dd6261;\n      }\n\n      .cls-241 {\n        fill: #e3635f;\n      }\n\n      .cls-818 {\n        clip-path: url(#clippath-524);\n      }\n\n      .cls-819 {\n        clip-path: url(#clippath-257);\n      }\n\n      .cls-820 {\n        clip-path: url(#clippath-457);\n      }\n\n      .cls-821 {\n        clip-path: url(#clippath-595);\n      }\n\n      .cls-822 {\n        clip-path: url(#clippath-664);\n      }\n\n      .cls-242 {\n        fill: #734727;\n      }\n\n      .cls-823 {\n        clip-path: url(#clippath-613);\n      }\n\n      .cls-824 {\n        clip-path: url(#clippath-420);\n      }\n\n      .cls-825 {\n        clip-path: url(#clippath-291);\n      }\n\n      .cls-243 {\n        fill: #f58d58;\n      }\n\n      .cls-826 {\n        clip-path: url(#clippath-419);\n      }\n\n      .cls-827 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-244 {\n        fill: #f37b5c;\n      }\n\n      .cls-828 {\n        clip-path: url(#clippath-592);\n      }\n\n      .cls-829 {\n        clip-path: url(#clippath-472);\n      }\n\n      .cls-830 {\n        clip-path: url(#clippath-31);\n      }\n\n      .cls-831 {\n        clip-path: url(#clippath-218);\n      }\n\n      .cls-832 {\n        clip-path: url(#clippath-86);\n      }\n\n      .cls-833 {\n        opacity: .28;\n      }\n\n      .cls-245 {\n        fill: #f58f57;\n      }\n\n      .cls-834 {\n        clip-path: url(#clippath-438);\n      }\n\n      .cls-246 {\n        fill: #f9b63e;\n      }\n\n      .cls-835 {\n        clip-path: url(#clippath-54);\n      }\n\n      .cls-836 {\n        clip-path: url(#clippath-618);\n      }\n\n      .cls-837 {\n        clip-path: url(#clippath-630);\n      }\n\n      .cls-838 {\n        clip-path: url(#clippath-408);\n      }\n\n      .cls-247 {\n        fill: #ed655e;\n      }\n\n      .cls-839 {\n        clip-path: url(#clippath-431);\n      }\n\n      .cls-840 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-248 {\n        fill: #e36360;\n      }\n\n      .cls-841 {\n        clip-path: url(#clippath-356);\n      }\n\n      .cls-842 {\n        clip-path: url(#clippath-131);\n      }\n\n      .cls-843 {\n        clip-path: url(#clippath-359);\n      }\n\n      .cls-844 {\n        clip-path: url(#clippath-91);\n      }\n\n      .cls-249 {\n        fill: #a85272;\n      }\n\n      .cls-845 {\n        clip-path: url(#clippath-322);\n      }\n\n      .cls-250 {\n        fill: #81502d;\n      }\n\n      .cls-846 {\n        clip-path: url(#clippath-129);\n      }\n\n      .cls-251 {\n        fill: #dda440;\n      }\n\n      .cls-252 {\n        fill: #9a5f35;\n      }\n\n      .cls-847 {\n        clip-path: url(#clippath-202);\n      }\n\n      .cls-848 {\n        clip-path: url(#clippath-596);\n      }\n\n      .cls-849 {\n        clip-path: url(#clippath-578);\n      }\n\n      .cls-850 {\n        clip-path: url(#clippath-165);\n      }\n\n      .cls-851 {\n        clip-path: url(#clippath-686);\n      }\n\n      .cls-253 {\n        fill: #f4835b;\n      }\n\n      .cls-254 {\n        fill: #774929;\n      }\n\n      .cls-852 {\n        clip-path: url(#clippath-350);\n      }\n\n      .cls-853 {\n        clip-path: url(#clippath-213);\n      }\n\n      .cls-854 {\n        clip-path: url(#clippath-422);\n      }\n\n      .cls-855 {\n        clip-path: url(#clippath-283);\n      }\n\n      .cls-255 {\n        fill: #f16b5d;\n      }\n\n      .cls-856 {\n        clip-path: url(#clippath-260);\n      }\n\n      .cls-256 {\n        fill: #993a80;\n      }\n\n      .cls-257 {\n        fill: #f8a948;\n      }\n\n      .cls-857 {\n        clip-path: url(#clippath-498);\n      }\n\n      .cls-858 {\n        clip-path: url(#clippath-175);\n      }\n\n      .cls-258 {\n        fill: #a85273;\n      }\n\n      .cls-859 {\n        clip-path: url(#clippath-702);\n      }\n\n      .cls-259 {\n        fill: #973681;\n      }\n\n      .cls-860 {\n        clip-path: url(#clippath-155);\n      }\n\n      .cls-861 {\n        clip-path: url(#clippath-306);\n      }\n\n      .cls-862 {\n        clip-path: url(#clippath-43);\n      }\n\n      .cls-863 {\n        clip-path: url(#clippath-466);\n      }\n\n      .cls-864 {\n        clip-path: url(#clippath-362);\n      }\n\n      .cls-865 {\n        clip-path: url(#clippath-663);\n      }\n\n      .cls-866 {\n        clip-path: url(#clippath-171);\n      }\n\n      .cls-260 {\n        fill: #754828;\n      }\n\n      .cls-867 {\n        clip-path: url(#clippath-70);\n      }\n\n      .cls-868 {\n        clip-path: url(#clippath-417);\n      }\n\n      .cls-261 {\n        fill: #f16a5d;\n      }\n\n      .cls-869 {\n        clip-path: url(#clippath-639);\n      }\n\n      .cls-262 {\n        fill: #f16c5d;\n      }\n\n      .cls-870 {\n        clip-path: url(#clippath-298);\n      }\n\n      .cls-263 {\n        fill: #7c4c2a;\n      }\n\n      .cls-871 {\n        clip-path: url(#clippath-558);\n      }\n\n      .cls-872 {\n        clip-path: url(#clippath-442);\n      }\n\n      .cls-264 {\n        fill: #f16d5d;\n      }\n\n      .cls-873 {\n        clip-path: url(#clippath-327);\n      }\n\n      .cls-874 {\n        clip-path: url(#clippath-591);\n      }\n\n      .cls-265 {\n        fill: #932d86;\n      }\n\n      .cls-875 {\n        clip-path: url(#clippath-695);\n      }\n\n      .cls-876 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-877 {\n        clip-path: url(#clippath-401);\n      }\n\n      .cls-878 {\n        clip-path: url(#clippath-328);\n      }\n\n      .cls-879 {\n        clip-path: url(#clippath-177);\n      }\n\n      .cls-266 {\n        fill: #ca7d44;\n      }\n\n      .cls-880 {\n        clip-path: url(#clippath-351);\n      }\n\n      .cls-881 {\n        clip-path: url(#clippath-502);\n      }\n\n      .cls-882 {\n        clip-path: url(#clippath-632);\n      }\n\n      .cls-883 {\n        clip-path: url(#clippath-589);\n      }\n\n      .cls-884 {\n        clip-path: url(#clippath-608);\n      }\n\n      .cls-885 {\n        clip-path: url(#clippath-223);\n      }\n\n      .cls-886 {\n        clip-path: url(#clippath-555);\n      }\n\n      .cls-887 {\n        clip-path: url(#clippath-256);\n      }\n\n      .cls-888 {\n        clip-path: url(#clippath-550);\n      }\n\n      .cls-889 {\n        fill: #ff9e0d;\n        font-family: Poppins-Bold, Poppins;\n        font-size: 11.99px;\n        font-weight: 700;\n        isolation: isolate;\n      }\n\n      .cls-890 {\n        clip-path: url(#clippath-212);\n      }\n\n      .cls-267 {\n        fill: #f69554;\n      }\n\n      .cls-268 {\n        fill: #b4596c;\n      }\n\n      .cls-891 {\n        clip-path: url(#clippath-297);\n      }\n\n      .cls-269 {\n        fill: #ac6b3b;\n      }\n\n      .cls-892 {\n        clip-path: url(#clippath-400);\n      }\n\n      .cls-893 {\n        clip-path: url(#clippath-424);\n      }\n\n      .cls-270 {\n        fill: #f9b53e;\n      }\n\n      .cls-271 {\n        fill: #912989;\n      }\n\n      .cls-272 {\n        fill: #983781;\n      }\n\n      .cls-273 {\n        fill: #9d6237;\n      }\n\n      .cls-894 {\n        clip-path: url(#clippath-575);\n      }\n\n      .cls-895 {\n        clip-path: url(#clippath-459);\n      }\n\n      .cls-896 {\n        clip-path: url(#clippath-587);\n      }\n\n      .cls-897 {\n        clip-path: url(#clippath-416);\n      }\n\n      .cls-274 {\n        fill: #bc7440;\n      }\n\n      .cls-898 {\n        clip-path: url(#clippath-209);\n      }\n\n      .cls-899 {\n        clip-path: url(#clippath-654);\n      }\n\n      .cls-900 {\n        clip-path: url(#clippath-606);\n      }\n\n      .cls-275 {\n        fill: #f9b83c;\n      }\n\n      .cls-901 {\n        clip-path: url(#clippath-476);\n      }\n\n      .cls-902 {\n        clip-path: url(#clippath-355);\n      }\n\n      .cls-903 {\n        clip-path: url(#clippath-286);\n      }\n\n      .cls-276 {\n        fill: #f9b73d;\n      }\n\n      .cls-904 {\n        clip-path: url(#clippath-488);\n      }\n\n      .cls-905 {\n        clip-path: url(#clippath-692);\n      }\n\n      .cls-906 {\n        clip-path: url(#clippath-133);\n      }\n\n      .cls-277 {\n        fill: #aa566f;\n      }\n\n      .cls-907 {\n        clip-path: url(#clippath-55);\n      }\n\n      .cls-908 {\n        clip-path: url(#clippath-445);\n      }\n\n      .cls-909 {\n        clip-path: url(#clippath-235);\n      }\n\n      .cls-910 {\n        clip-path: url(#clippath-482);\n      }\n\n      .cls-911 {\n        clip-path: url(#clippath-560);\n      }\n\n      .cls-912 {\n        clip-path: url(#clippath-69);\n      }\n\n      .cls-278 {\n        fill: #f4805b;\n      }\n\n      .cls-913 {\n        clip-path: url(#clippath-414);\n      }\n\n      .cls-914 {\n        clip-path: url(#clippath-547);\n      }\n\n      .cls-915 {\n        clip-path: url(#clippath-333);\n      }\n\n      .cls-916 {\n        clip-path: url(#clippath-292);\n      }\n\n      .cls-917 {\n        clip-path: url(#clippath-405);\n      }\n\n      .cls-279 {\n        fill: #bf5c69;\n      }\n\n      .cls-918 {\n        clip-path: url(#clippath-140);\n      }\n\n      .cls-280 {\n        fill: #f69c50;\n      }\n\n      .cls-281 {\n        fill: #f37a5c;\n      }\n\n      .cls-919 {\n        clip-path: url(#clippath-709);\n      }\n\n      .cls-920 {\n        clip-path: url(#clippath-621);\n      }\n\n      .cls-282 {\n        fill: #b26e3d;\n      }\n\n      .cls-283 {\n        fill: #f69156;\n      }\n\n      .cls-284 {\n        fill: #aa5570;\n      }\n\n      .cls-921 {\n        clip-path: url(#clippath-29);\n      }\n\n      .cls-285 {\n        fill: #9b3d7f;\n      }\n\n      .cls-922 {\n        clip-path: url(#clippath-375);\n      }\n\n      .cls-923 {\n        clip-path: url(#clippath-433);\n      }\n\n      .cls-924 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-286 {\n        fill: #c95e66;\n      }\n\n      .cls-925 {\n        clip-path: url(#clippath-90);\n      }\n\n      .cls-287 {\n        fill: #f4815c;\n      }\n\n      .cls-926 {\n        clip-path: url(#clippath-349);\n      }\n\n      .cls-927 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-928 {\n        clip-path: url(#clippath-538);\n      }\n\n      .cls-929 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-930 {\n        clip-path: url(#clippath-240);\n      }\n\n      .cls-931 {\n        clip-path: url(#clippath-97);\n      }\n\n      .cls-932 {\n        clip-path: url(#clippath-464);\n      }\n\n      .cls-933 {\n        clip-path: url(#clippath-615);\n      }\n\n      .cls-934 {\n        clip-path: url(#clippath-552);\n      }\n\n      .cls-935 {\n        clip-path: url(#clippath-649);\n      }\n\n      .cls-288 {\n        fill: #a06437;\n      }\n\n      .cls-936 {\n        clip-path: url(#clippath-571);\n      }\n\n      .cls-937 {\n        clip-path: url(#clippath-658);\n      }\n\n      .cls-938 {\n        clip-path: url(#clippath-216);\n      }\n\n      .cls-939 {\n        clip-path: url(#clippath-577);\n      }\n\n      .cls-289 {\n        fill: #aa6a3a;\n      }\n\n      .cls-940 {\n        clip-path: url(#clippath-599);\n      }\n\n      .cls-941 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-942 {\n        clip-path: url(#clippath-444);\n      }\n\n      .cls-943 {\n        clip-path: url(#clippath-174);\n      }\n\n      .cls-290 {\n        fill: #a46638;\n      }\n\n      .cls-944 {\n        clip-path: url(#clippath-612);\n      }\n\n      .cls-945 {\n        clip-path: url(#clippath-652);\n      }\n\n      .cls-291 {\n        fill: #f8a848;\n      }\n\n      .cls-946 {\n        clip-path: url(#clippath-611);\n      }\n\n      .cls-292 {\n        fill: #a95471;\n      }\n\n      .cls-293 {\n        fill: #f2765d;\n      }\n\n      .cls-294 {\n        fill: #9a6035;\n      }\n\n      .cls-947 {\n        clip-path: url(#clippath-631);\n      }\n\n      .cls-948 {\n        clip-path: url(#clippath-683);\n      }\n\n      .cls-949 {\n        clip-path: url(#clippath-534);\n      }\n\n      .cls-950 {\n        clip-path: url(#clippath-598);\n      }\n\n      .cls-951 {\n        clip-path: url(#clippath-58);\n      }\n\n      .cls-295 {\n        fill: #912a87;\n      }\n\n      .cls-296 {\n        fill: #b95b6a;\n      }\n\n      .cls-952 {\n        clip-path: url(#clippath-610);\n      }\n\n      .cls-953 {\n        clip-path: url(#clippath-492);\n      }\n\n      .cls-954 {\n        clip-path: url(#clippath-263);\n      }\n\n      .cls-955 {\n        clip-path: url(#clippath-344);\n      }\n\n      .cls-297 {\n        fill: #87542f;\n      }\n\n      .cls-298 {\n        fill: #f9b63d;\n      }\n\n      .cls-299 {\n        fill: #f8b33f;\n      }\n\n      .cls-956 {\n        clip-path: url(#clippath-84);\n      }\n\n      .cls-957 {\n        clip-path: url(#clippath-544);\n      }\n\n      .cls-958 {\n        clip-path: url(#clippath-148);\n      }\n\n      .cls-300 {\n        fill: #f16a5e;\n      }\n\n      .cls-959 {\n        clip-path: url(#clippath-279);\n      }\n\n      .cls-301 {\n        fill: #f9b43e;\n      }\n\n      .cls-960 {\n        clip-path: url(#clippath-465);\n      }\n\n      .cls-302 {\n        fill: #f7a04e;\n      }\n\n      .cls-961 {\n        clip-path: url(#clippath-666);\n      }\n\n      .cls-962 {\n        clip-path: url(#clippath-565);\n      }\n\n      .cls-963 {\n        clip-path: url(#clippath-543);\n      }\n\n      .cls-964 {\n        clip-path: url(#clippath-629);\n      }\n\n      .cls-965 {\n        clip-path: url(#clippath-594);\n      }\n\n      .cls-966 {\n        clip-path: url(#clippath-514);\n      }\n\n      .cls-967 {\n        clip-path: url(#clippath-42);\n      }\n\n      .cls-303 {\n        fill: #7e4d2b;\n      }\n\n      .cls-304 {\n        fill: #f2715d;\n      }\n\n      .cls-968 {\n        clip-path: url(#clippath-450);\n      }\n\n      .cls-969 {\n        clip-path: url(#clippath-288);\n      }\n\n      .cls-305 {\n        fill: #9e437c;\n      }\n\n      .cls-970 {\n        clip-path: url(#clippath-244);\n      }\n\n      .cls-971 {\n        clip-path: url(#clippath-363);\n      }\n\n      .cls-972 {\n        clip-path: url(#clippath-372);\n      }\n\n      .cls-306 {\n        fill: #7a4b2a;\n      }\n\n      .cls-307 {\n        fill: #c85e67;\n      }\n\n      .cls-973 {\n        clip-path: url(#clippath-65);\n      }\n\n      .cls-308 {\n        fill: #f3805c;\n      }\n\n      .cls-974 {\n        clip-path: url(#clippath-253);\n      }\n\n      .cls-975 {\n        clip-path: url(#clippath-708);\n      }\n\n      .cls-976 {\n        clip-path: url(#clippath-480);\n      }\n\n      .cls-977 {\n        clip-path: url(#clippath-456);\n      }\n\n      .cls-309 {\n        fill: #7b4b2a;\n      }\n\n      .cls-978 {\n        clip-path: url(#clippath-584);\n      }\n\n      .cls-979 {\n        clip-path: url(#clippath-537);\n      }\n\n      .cls-980 {\n        clip-path: url(#clippath-446);\n      }\n\n      .cls-981 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-310 {\n        fill: #b85a6b;\n      }\n\n      .cls-982 {\n        clip-path: url(#clippath-404);\n      }\n\n      .cls-311 {\n        fill: #985f35;\n      }\n\n      .cls-983 {\n        clip-path: url(#clippath-443);\n      }\n\n      .cls-984 {\n        clip-path: url(#clippath-564);\n      }\n\n      .cls-985 {\n        clip-path: url(#clippath-637);\n      }\n\n      .cls-312 {\n        fill: #744727;\n      }\n\n      .cls-313 {\n        fill: #774928;\n      }\n\n      .cls-314 {\n        fill: #f9b93b;\n      }\n\n      .cls-986 {\n        clip-path: url(#clippath-409);\n      }\n\n      .cls-987 {\n        clip-path: url(#clippath-118);\n      }\n\n      .cls-988 {\n        clip-path: url(#clippath-324);\n      }\n\n      .cls-989 {\n        clip-path: url(#clippath-423);\n      }\n\n      .cls-990 {\n        clip-path: url(#clippath-277);\n      }\n\n      .cls-991 {\n        clip-path: url(#clippath-636);\n      }\n\n      .cls-315 {\n        fill: #ae6c3b;\n      }\n\n      .cls-992 {\n        clip-path: url(#clippath-230);\n      }\n\n      .cls-993 {\n        clip-path: url(#clippath-23);\n      }\n\n      .cls-316 {\n        fill: #90278a;\n      }\n\n      .cls-994 {\n        clip-path: url(#clippath-647);\n      }\n\n      .cls-995 {\n        clip-path: url(#clippath-191);\n      }\n\n      .cls-317 {\n        fill: #922c86;\n      }\n\n      .cls-996 {\n        clip-path: url(#clippath-100);\n      }\n\n      .cls-997 {\n        clip-path: url(#clippath-92);\n      }\n\n      .cls-998 {\n        clip-path: url(#clippath-74);\n      }\n\n      .cls-318 {\n        fill: #955d34;\n      }\n\n      .cls-999 {\n        clip-path: url(#clippath-495);\n      }\n\n      .cls-1000 {\n        clip-path: url(#clippath-619);\n      }\n\n      .cls-1001 {\n        clip-path: url(#clippath-428);\n      }\n\n      .cls-319 {\n        fill: #f37e5c;\n      }\n\n      .cls-1002 {\n        clip-path: url(#clippath-56);\n      }\n\n      .cls-1003 {\n        clip-path: url(#clippath-53);\n      }\n\n      .cls-1004 {\n        clip-path: url(#clippath-49);\n      }\n\n      .cls-1005 {\n        clip-path: url(#clippath-425);\n      }\n\n      .cls-320 {\n        fill: #a95470;\n      }\n\n      .cls-1006 {\n        clip-path: url(#clippath-582);\n      }\n\n      .cls-1007 {\n        clip-path: url(#clippath-569);\n      }\n\n      .cls-1008 {\n        clip-path: url(#clippath-360);\n      }\n\n      .cls-321 {\n        fill: #f3795d;\n      }\n\n      .cls-1009 {\n        clip-path: url(#clippath-410);\n      }\n\n      .cls-1010 {\n        clip-path: url(#clippath-205);\n      }\n\n      .cls-322 {\n        fill: #86532e;\n      }\n\n      .cls-1011 {\n        clip-path: url(#clippath-224);\n      }\n\n      .cls-1012 {\n        clip-path: url(#clippath-110);\n      }\n\n      .cls-1013 {\n        clip-path: url(#clippath-685);\n      }\n\n      .cls-1014 {\n        clip-path: url(#clippath-146);\n      }\n\n      .cls-323 {\n        fill: #ce8044;\n      }\n\n      .cls-1015 {\n        clip-path: url(#clippath-67);\n      }\n\n      .cls-1016 {\n        clip-path: url(#clippath-51);\n      }\n\n      .cls-1017 {\n        clip-path: url(#clippath-145);\n      }\n\n      .cls-1018 {\n        clip-path: url(#clippath-500);\n      }\n\n      .cls-1019 {\n        clip-path: url(#clippath-474);\n      }\n\n      .cls-1020 {\n        clip-path: url(#clippath-358);\n      }\n\n      .cls-324 {\n        fill: #784a29;\n      }\n\n      .cls-325 {\n        fill: #ab576d;\n      }\n\n      .cls-326 {\n        fill: #c57a42;\n      }\n\n      .cls-327 {\n        fill: #953383;\n      }\n\n      .cls-1021 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-328 {\n        fill: #e9645e;\n      }\n\n      .cls-1022 {\n        clip-path: url(#clippath-399);\n      }\n\n      .cls-1023 {\n        clip-path: url(#clippath-251);\n      }\n\n      .cls-1024 {\n        clip-path: url(#clippath-378);\n      }\n\n      .cls-329 {\n        fill: #8a5630;\n      }\n\n      .cls-330 {\n        fill: #912b86;\n      }\n\n      .cls-1025 {\n        clip-path: url(#clippath-258);\n      }\n\n      .cls-331 {\n        fill: #9e427c;\n      }\n\n      .cls-1026 {\n        clip-path: url(#clippath-71);\n      }\n\n      .cls-1027 {\n        clip-path: url(#clippath-642);\n      }\n\n      .cls-332 {\n        fill: #f37c5c;\n      }\n\n      .cls-1028 {\n        clip-path: url(#clippath-184);\n      }\n\n      .cls-1029 {\n        clip-path: url(#clippath-660);\n      }\n\n      .cls-333 {\n        fill: #9a3b80;\n      }\n\n      .cls-1030 {\n        clip-path: url(#clippath-85);\n      }\n\n      .cls-1031 {\n        clip-path: url(#clippath-530);\n      }\n\n      .cls-1032 {\n        clip-path: url(#clippath-667);\n      }\n\n      .cls-1033 {\n        clip-path: url(#clippath-526);\n      }\n\n      .cls-1034 {\n        clip-path: url(#clippath-430);\n      }\n\n      .cls-334 {\n        fill: #a24879;\n      }\n\n      .cls-1035 {\n        clip-path: url(#clippath-106);\n      }\n\n      .cls-1036 {\n        clip-path: url(#clippath-374);\n      }\n\n      .cls-1037 {\n        clip-path: url(#clippath-679);\n      }\n\n      .cls-1038 {\n        clip-path: url(#clippath-294);\n      }\n\n      .cls-335 {\n        fill: #af586d;\n      }\n\n      .cls-1039 {\n        clip-path: url(#clippath-265);\n      }\n\n      .cls-336 {\n        fill: #f69d50;\n      }\n\n      .cls-1040 {\n        clip-path: url(#clippath-506);\n      }\n\n      .cls-337 {\n        fill: #c77b43;\n      }\n\n      .cls-1041 {\n        clip-path: url(#clippath-68);\n      }\n\n      .cls-1042 {\n        clip-path: url(#clippath-653);\n      }\n\n      .cls-1043 {\n        clip-path: url(#clippath-670);\n      }\n\n      .cls-1044 {\n        clip-path: url(#clippath-669);\n      }\n\n      .cls-1045 {\n        clip-path: url(#clippath-238);\n      }\n\n      .cls-1046 {\n        clip-path: url(#clippath-143);\n      }\n\n      .cls-1047 {\n        clip-path: url(#clippath-35);\n      }\n\n      .cls-1048 {\n        clip-path: url(#clippath-339);\n      }\n\n      .cls-1049 {\n        clip-path: url(#clippath-370);\n      }\n\n      .cls-1050 {\n        clip-path: url(#clippath-418);\n      }\n\n      .cls-1051 {\n        clip-path: url(#clippath-300);\n      }\n\n      .cls-1052 {\n        clip-path: url(#clippath-486);\n      }\n\n      .cls-1053 {\n        clip-path: url(#clippath-227);\n      }\n\n      .cls-1054 {\n        clip-path: url(#clippath-470);\n      }\n\n      .cls-338 {\n        fill: #d18045;\n      }\n\n      .cls-1055 {\n        clip-path: url(#clippath-66);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-55"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-56"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-57"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-58"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-59"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-60"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-61"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-62"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-63"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-64"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-65"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-66"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-67"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-68"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-69"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-70"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-71"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-72"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-73"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-74"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-75"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-76"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-77"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-78"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-79"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-80"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-81"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-82"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-83"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-84"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-85"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-86"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-87"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-88"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-89"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-90"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-91"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-92"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-93"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-94"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-95"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-96"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-97"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-98"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-99"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-100"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-101"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-102"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-103"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-104"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-105"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-106"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-107"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-108"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-109"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-110"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-111"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-112"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-113"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-114"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-115"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-116"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-117"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-118"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-119"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-120"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-121"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-122"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-123"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-124"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-125"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-126"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-127"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-128"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-129"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-130"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-131"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-132"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-133"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-134"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-135"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-136"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-137"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-138"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-139"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-140"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-141"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-142"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-143"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-144"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-145"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-146"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-147"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-148"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-149"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-150"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-151"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-152"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-153"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-154"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-155"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-156"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-157"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-158"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-159"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-160"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-161"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-162"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-163"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-164"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-165"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-166"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-167"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-168"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-169"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-170"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-171"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-172"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-173"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-174"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-175"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-176"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-177"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-178"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-179"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-180"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-181"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-182"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-183"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-184"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-185"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-186"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-187"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-188"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-189"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-190"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-191"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-192"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-193"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-194"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-195"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-196"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-197"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-198"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-199"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-200"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-201"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-202"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-203"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-204"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-205"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-206"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-207"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-208"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-209"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-210"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-211"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-212"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-213"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-214"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-215"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-216"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-217"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-218"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-219"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-220"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-221"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-222"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-223"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-224"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-225"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-226"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-227"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-228"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-229"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-230"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-231"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-232"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-233"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-234"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-235"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-236"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-237"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-238"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-239"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-240"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-241"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-242"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-243"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-244"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-245"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-246"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-247"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-248"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-249"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-250"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-251"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-252"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-253"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-254"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-255"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-256"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-257"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-258"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-259"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-260"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-261"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-262"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-263"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-264"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-265"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-266"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-267"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-268"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-269"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-270"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-271"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-272"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-273"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-274"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-275"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-276"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-277"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.71,
    cy: 22.52,
    r: 4.89
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-278"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-279"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-280"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-281"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-282"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-283"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-284"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-285"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-286"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-287"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-288"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-289"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-290"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-291"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-292"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-293"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-294"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-295"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-296"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-297"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-298"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-299"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-300"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-301"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-302"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-303"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-304"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-305"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-306"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-307"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-308"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-309"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-310"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-311"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-312"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-313"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-314"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-315"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-316"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-317"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-318"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-319"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-320"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-321"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-322"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-323"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-324"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-325"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-326"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-327"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-328"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-329"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-330"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-331"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-332"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-333"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-334"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-335"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-336"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-337"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-338"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-339"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-340"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-341"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-342"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-343"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-344"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-345"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-346"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-347"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-348"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-349"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-350"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-351"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-352"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-353"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-354"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-355"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-356"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-357"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-358"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-359"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-360"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-361"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-362"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-363"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-364"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-365"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-366"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-367"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-368"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-369"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-370"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-371"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-372"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-373"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-374"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-375"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-376"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-377"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-378"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-379"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-380"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-381"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-382"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-383"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-384"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-385"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-386"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-387"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-388"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-389"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-390"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-391"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-392"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-393"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-394"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-395"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-396"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-397"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-398"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-399"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-400"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-401"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-402"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-403"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-404"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-405"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-406"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-407"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-408"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-409"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-410"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-411"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-412"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-413"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-414"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-415"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M38.6,19.09c0-2.7-2.19-4.89-4.89-4.89s-4.89,2.19-4.89,4.89c0,.61.11,1.19.31,1.72h9.15c.21-.53.32-1.12.32-1.72Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-417"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.79,
    cy: 20.81,
    r: 15.82
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-418"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-122",
    cx: 33.79,
    cy: 20.81,
    r: 15.82
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-419"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-420"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-421"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-422"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-423"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-424"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-425"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-426"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-427"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-428"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-429"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-430"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-431"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-432"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-433"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-434"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-435"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-436"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-437"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-438"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-439"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-440"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-441"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-442"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-443"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-444"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-445"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-446"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-447"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-448"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-449"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-450"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-451"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-452"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-453"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-454"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-455"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-456"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-457"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-458"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-459"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-460"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-461"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-462"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-463"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-464"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-465"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-466"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-467"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-468"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-469"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-470"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-471"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-472"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-473"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-474"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-475"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-476"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-477"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-478"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-479"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-480"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-481"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-482"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-483"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-484"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-485"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-486"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-487"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-488"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-489"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-490"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-491"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-492"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-493"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-494"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-495"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-496"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-497"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-498"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-499"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-500"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-501"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-502"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-503"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-504"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-505"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-506"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-507"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-508"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-509"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-510"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-511"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-512"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-513"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-514"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-515"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-516"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-517"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-518"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-519"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-520"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-521"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-522"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-523"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-524"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-525"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-526"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-527"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-528"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-529"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-530"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-531"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-532"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-533"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-534"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-535"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-536"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-537"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-538"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-539"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-540"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-541"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-542"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-543"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-544"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-545"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-546"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-547"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-548"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-549"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-550"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-551"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-552"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-553"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-554"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-555"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-556"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-557"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-558"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-559"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-560"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-561"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-562"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-563"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-564"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-565"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-566"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-567"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-568"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-569"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-570"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-571"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-572"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-573"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-574"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-575"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-576"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-577"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-578"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-579"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-580"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-581"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-582"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-583"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-584"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-585"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-586"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-587"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-588"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-589"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-590"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-591"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-592"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-593"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-594"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-595"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-596"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-597"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-598"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-599"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-600"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-601"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-602"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-603"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-604"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-605"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-606"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-607"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-122",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-608"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-609"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-610"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-611"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-612"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-613"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-614"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-615"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-616"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-617"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-618"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-619"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-620"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-621"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-622"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-623"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-624"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-625"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-626"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-627"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-628"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-629"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-630"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-631"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-632"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-633"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-634"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-635"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-636"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-637"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-638"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-639"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-640"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-641"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-642"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-643"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-644"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-645"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-646"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-647"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-648"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-649"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-650"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-651"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-652"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-653"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-654"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-655"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-656"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-657"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-658"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-659"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-660"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-661"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-662"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-663"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-664"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-665"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-666"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-667"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-668"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-669"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-670"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-671"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-672"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-673"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-674"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-675"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-676"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-677"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-678"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-679"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-680"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-681"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-682"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-683"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-684"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-685"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-686"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-687"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-688"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-689"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-690"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-691"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-692"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-693"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-694"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-695"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-696"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-697"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-698"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-699"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-700"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-701"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-702"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-703"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-704"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-705"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-706"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-707"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-708"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-709"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-710"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-711"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-712"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-713"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-714"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-715"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-716"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M48.37,27.11c-.02-.17.67-1.46.53-1.56-.51-.37-1.05.16-1.33-.22-.01-.02-.02-.03-.03-.05h-.01s-.02-.04-.03-.05c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.24-.34-.48-.72-.81-.81-.34-.1-.71.18-1.02.37-.19.12-.38.23-.58.34-.19.1-.38.16-.58.23-.24.09-.48.24-.69.45h-.01s-.03.04-.05.06l-.02.02-.03.03-.04.04s0,0,0,0h0c-.34-.36-.66-.66-.87-.79-.02-.01-.04-.03-.07-.04-.01,0-.01-.01-.02-.01-.02-.01-.04-.02-.05-.03-.01,0-.01-.01-.02-.01-.05-.02-.09-.04-.14-.06h-.01s-.05-.02-.07-.02h-.01c-.07-.02-.15-.04-.22-.04h0c-.11-.01-.21,0-.32.03-.19.05-.38.15-.57.22s-.38.11-.57.12c-.36.04-.71.02-1.07.06-.02,0-.04,0-.05.01h0c-.22.02-.49.01-.7.14h0s-.03.02-.04.02c-.01.01-.02.02-.04.03,0,0-.01,0-.01.01-.01.01-.03.02-.04.04-.19.18-.31.5-.42.79-.14-.16-.3-.28-.47-.35-.02-.01-.03-.01-.05-.02-.02-.01-.05-.02-.07-.03h0c-.07-.03-.13-.05-.2-.09-.11-.06-.21-.12-.31-.19-.17-.1-.37-.26-.56-.21-.21.05-.36.3-.52.5-.08.1-.17.19-.25.3-.01-.01-.01-.02-.02-.04-.21-.43-.4-.98-.73-1.27l-.03-.03h0c-.3-.24-.71-.23-1.07-.26h-.07s-.05,0-.07-.01c-.5-.05-1-.03-1.5-.07-.27-.02-.54-.06-.8-.15-.27-.09-.53-.2-.8-.27-.26-.06-.52-.05-.76.01h-.01s-.06.02-.1.03h-.01c-.07.02-.13.05-.2.07-.01,0-.02.01-.02.01-.02.01-.05.02-.07.03-.01,0-.02.01-.03.01-.03.02-.06.03-.09.05-.3.15-.73.52-1.22.96h0s-.02-.02-.04-.03c-.01-.01-.03-.03-.04-.04-.02-.02-.04-.03-.05-.05-.01-.01-.02-.01-.02-.02-.02-.02-.05-.04-.07-.06h-.01c-.3-.26-.63-.44-.97-.56-.27-.09-.54-.15-.81-.28-.27-.13-.54-.27-.81-.41-.43-.23-.95-.57-1.42-.45-.49.12-.84.63-1.19,1.07-.01.01-.02.02-.03.03s-.01.01-.02.02c-.02.02-.03.04-.05.06-.07.09-.15.17-.22.25-.03-.01-.05-.02-.08-.03-.26-.06-.54.13-.78.26-.15.08-.29.16-.44.23-.09.05-.19.08-.28.11h0s-.07.02-.1.03c-.02.01-.04.01-.06.02-.27.09-.52.27-.73.51-.08.09-.89.41-.97.5-.08.23.41.3.25.58,0,0,29.02,0,29.02,0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-792"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 28.82,
    y: 23.86,
    width: 9.78,
    height: 3.56
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-624"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 28.82,
    y: 23.83,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-490"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 28.82,
    y: 23.8,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-840"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 28.82,
    y: 23.77,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-627"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 28.82,
    y: 23.74,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-941"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 28.82,
    y: 23.71,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-541"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 28.82,
    y: 23.68,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-603"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-314",
    x: 28.82,
    y: 23.65,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-876"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 28.82,
    y: 23.62,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-785"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 28.82,
    y: 23.59,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-981"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 28.82,
    y: 23.56,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-373"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-298",
    x: 28.82,
    y: 23.53,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-693"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 28.82,
    y: 23.5,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-493"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 28.82,
    y: 23.47,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-927"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-301",
    x: 28.82,
    y: 23.44,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-531"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-299",
    x: 28.82,
    y: 23.41,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-376"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 28.82,
    y: 23.38,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-929"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 28.82,
    y: 23.35,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-924"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 28.82,
    y: 23.32,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-827"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 28.82,
    y: 23.29,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-370"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 28.82,
    y: 23.26,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-605"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 28.82,
    y: 23.23,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-757"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 28.82,
    y: 23.2,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-993"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 28.82,
    y: 23.17,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-728"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 28.82,
    y: 23.14,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-511"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 28.82,
    y: 23.1,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-557"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 28.82,
    y: 23.07,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-642"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 28.82,
    y: 23.04,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1021"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 28.82,
    y: 23.01,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-921"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 28.82,
    y: 22.98,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-745"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-257",
    x: 28.82,
    y: 22.95,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-830"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-291",
    x: 28.82,
    y: 22.92,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-448"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 28.82,
    y: 22.89,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-411"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 28.82,
    y: 22.86,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-613"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 28.82,
    y: 22.83,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1047"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 28.82,
    y: 22.8,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-640"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 28.82,
    y: 22.77,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-508"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 28.82,
    y: 22.74,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-632"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 28.82,
    y: 22.71,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-813"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 28.82,
    y: 22.68,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-553"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 28.82,
    y: 22.65,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-445"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 28.82,
    y: 22.62,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-967"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 28.82,
    y: 22.59,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-862"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-302",
    x: 28.82,
    y: 22.56,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-668"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 28.82,
    y: 22.53,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-361"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 28.82,
    y: 22.5,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-510"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 28.82,
    y: 22.47,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-414"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-336",
    x: 28.82,
    y: 22.44,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-807"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 28.82,
    y: 22.41,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1004"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 28.82,
    y: 22.38,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-802"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 28.82,
    y: 22.35,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1016"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 28.82,
    y: 22.32,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-788"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 28.82,
    y: 22.29,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1003"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 28.82,
    y: 22.26,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-835"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 28.82,
    y: 22.23,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-907"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 28.82,
    y: 22.2,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1002"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-237",
    x: 28.82,
    y: 22.17,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-617"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: 28.82,
    y: 22.14,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-951"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: 28.82,
    y: 22.11,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-382"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-267",
    x: 28.82,
    y: 22.08,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-658"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 28.82,
    y: 22.05,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-808"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 28.82,
    y: 22.02,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-354"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 28.82,
    y: 21.99,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-363"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 28.82,
    y: 21.96,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-412"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 28.82,
    y: 21.93,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-973"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 28.82,
    y: 21.9,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1055"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.82,
    y: 21.87,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1015"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.82,
    y: 21.84,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1041"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-245",
    x: 28.82,
    y: 21.81,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-912"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 28.82,
    y: 21.78,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-867"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 28.82,
    y: 21.75,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1026"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 28.82,
    y: 21.72,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-351"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 28.82,
    y: 21.69,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-339"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 28.82,
    y: 21.66,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-998"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 28.82,
    y: 21.63,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-583"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 28.82,
    y: 21.6,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-547"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 28.82,
    y: 21.57,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-418"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 28.82,
    y: 21.54,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-386"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 28.82,
    y: 21.51,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-754"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 28.82,
    y: 21.48,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-708"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 28.82,
    y: 21.45,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-558"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 28.82,
    y: 21.43,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-787"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 28.82,
    y: 21.41,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-479"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 28.82,
    y: 21.38,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-956"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 28.82,
    y: 21.36,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1030"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-253",
    x: 28.82,
    y: 21.34,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-832"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 28.82,
    y: 21.31,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-460"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 28.82,
    y: 21.29,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-498"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-287",
    x: 28.82,
    y: 21.27,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-409"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-278",
    x: 28.82,
    y: 21.24,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-925"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-308",
    x: 28.82,
    y: 21.22,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-844"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-308",
    x: 28.82,
    y: 21.2,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-997"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 28.82,
    y: 21.17,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-398"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-319",
    x: 28.82,
    y: 21.15,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-417"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-319",
    x: 28.82,
    y: 21.13,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-703"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 28.82,
    y: 21.11,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-758"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-332",
    x: 28.82,
    y: 21.08,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-931"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-332",
    x: 28.82,
    y: 21.06,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-513"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 28.82,
    y: 21.04,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-741"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 28.82,
    y: 21.01,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-996"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 28.82,
    y: 20.99,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-655"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-321",
    x: 28.82,
    y: 20.97,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-619"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 28.82,
    y: 20.94,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-778"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 28.82,
    y: 20.92,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-546"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-293",
    x: 28.82,
    y: 20.9,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-489"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-293",
    x: 28.82,
    y: 20.87,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1035"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 28.82,
    y: 20.85,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-522"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 28.82,
    y: 20.83,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-454"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 28.82,
    y: 20.81,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-648"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 28.82,
    y: 20.78,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1012"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 28.82,
    y: 20.76,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-568"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-304",
    x: 28.82,
    y: 20.74,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-458"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 28.82,
    y: 20.71,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-700"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 28.82,
    y: 20.69,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-484"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 28.82,
    y: 20.67,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-500"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 28.82,
    y: 20.64,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-427"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 28.82,
    y: 20.62,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-555"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 28.82,
    y: 20.6,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-987"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-255",
    x: 28.82,
    y: 20.57,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-482"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-261",
    x: 28.82,
    y: 20.55,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-722"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-300",
    x: 28.82,
    y: 20.53,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-421"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 28.82,
    y: 20.5,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-672"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 28.82,
    y: 20.48,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-374"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 28.82,
    y: 20.46,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-504"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 28.82,
    y: 20.44,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-643"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 28.82,
    y: 20.42,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-780"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 28.82,
    y: 20.4,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-641"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: 28.82,
    y: 20.38,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-480"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 28.82,
    y: 20.36,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-846"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-328",
    x: 28.82,
    y: 20.35,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-607"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 28.82,
    y: 20.33,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-842"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 28.82,
    y: 20.31,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-438"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 28.82,
    y: 20.29,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-906"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 28.82,
    y: 20.27,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-699"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 28.82,
    y: 20.25,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-371"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 28.82,
    y: 20.24,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-433"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 28.82,
    y: 20.22,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-781"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 28.82,
    y: 20.2,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-629"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 28.82,
    y: 20.18,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-683"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-157",
    x: 28.82,
    y: 20.16,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-918"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-105",
    x: 28.82,
    y: 20.15,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-652"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-216",
    x: 28.82,
    y: 20.13,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-473"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-168",
    x: 28.82,
    y: 20.11,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1046"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-177",
    x: 28.82,
    y: 20.09,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-790"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-156",
    x: 28.82,
    y: 20.07,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1017"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-193",
    x: 28.82,
    y: 20.06,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1014"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 28.82,
    y: 20.04,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-727"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-37",
    x: 28.82,
    y: 20.02,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-958"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 28.82,
    y: 20,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-650"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-96",
    x: 28.82,
    y: 19.98,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-764"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-135",
    x: 28.82,
    y: 19.96,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-429"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-232",
    x: 28.82,
    y: 19.95,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-803"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-207",
    x: 28.82,
    y: 19.93,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-542"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-94",
    x: 28.82,
    y: 19.91,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-670"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-21",
    x: 28.82,
    y: 19.89,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-860"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-153",
    x: 28.82,
    y: 19.87,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-805"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-181",
    x: 28.82,
    y: 19.86,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-378"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-286",
    x: 28.82,
    y: 19.84,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-407"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-307",
    x: 28.82,
    y: 19.82,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-810"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-178",
    x: 28.82,
    y: 19.8,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-426"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 28.82,
    y: 19.78,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-428"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-58",
    x: 28.82,
    y: 19.77,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-420"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 28.82,
    y: 19.75,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-456"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-140",
    x: 28.82,
    y: 19.73,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-526"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 28.82,
    y: 19.71,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-850"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-182",
    x: 28.82,
    y: 19.69,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-742"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-119",
    x: 28.82,
    y: 19.68,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-600"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-279",
    x: 28.82,
    y: 19.66,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-666"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-173",
    x: 28.82,
    y: 19.64,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-397"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-163",
    x: 28.82,
    y: 19.62,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-369"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 28.82,
    y: 19.6,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-866"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-209",
    x: 28.82,
    y: 19.58,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-520"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-296",
    x: 28.82,
    y: 19.57,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-474"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-143",
    x: 28.82,
    y: 19.55,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-943"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-310",
    x: 28.82,
    y: 19.53,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-858"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 28.82,
    y: 19.51,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-616"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-124",
    x: 28.82,
    y: 19.49,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-879"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 28.82,
    y: 19.48,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-702"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-268",
    x: 28.82,
    y: 19.46,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-748"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-109",
    x: 28.82,
    y: 19.44,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-809"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-98",
    x: 28.82,
    y: 19.42,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-576"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-23",
    x: 28.82,
    y: 19.4,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-501"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-174",
    x: 28.82,
    y: 19.39,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-776"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-335",
    x: 28.82,
    y: 19.37,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1028"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-100",
    x: 28.82,
    y: 19.35,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-488"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 28.82,
    y: 19.33,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-358"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-325",
    x: 28.82,
    y: 19.31,
    width: 9.78,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-797"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-325",
    x: 28.82,
    y: 19.3,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-365"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 28.82,
    y: 19.29,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-590"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-70",
    x: 28.82,
    y: 19.27,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-450"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-234",
    x: 28.82,
    y: 19.26,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-995"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-277",
    x: 28.82,
    y: 19.24,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-679"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-149",
    x: 28.82,
    y: 19.23,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-747"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-284",
    x: 28.82,
    y: 19.22,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-470"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-320",
    x: 28.82,
    y: 19.2,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-759"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-108",
    x: 28.82,
    y: 19.19,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-535"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-292",
    x: 28.82,
    y: 19.18,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-453"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-72",
    x: 28.82,
    y: 19.16,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-811"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-249",
    x: 28.82,
    y: 19.15,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-391"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-249",
    x: 28.82,
    y: 19.14,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-634"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-258",
    x: 28.82,
    y: 19.12,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-765"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-117",
    x: 28.82,
    y: 19.11,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-847"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-192",
    x: 28.82,
    y: 19.09,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-718"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-210",
    x: 28.82,
    y: 19.08,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-796"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-133",
    x: 28.82,
    y: 19.07,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1010"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-82",
    x: 28.82,
    y: 19.05,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-347"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 28.82,
    y: 19.04,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-388"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 28.82,
    y: 19.03,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-362"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-142",
    x: 28.82,
    y: 19.01,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-898"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 28.82,
    y: 19,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-630"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-138",
    x: 28.82,
    y: 18.99,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-731"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-126",
    x: 28.82,
    y: 18.97,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-890"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-59",
    x: 28.82,
    y: 18.96,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-853"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-45",
    x: 28.82,
    y: 18.94,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-614"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-66",
    x: 28.82,
    y: 18.93,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-768"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-204",
    x: 28.82,
    y: 18.92,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-938"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 28.82,
    y: 18.9,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-469"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-90",
    x: 28.82,
    y: 18.89,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-831"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-334",
    x: 28.82,
    y: 18.88,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-518"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-334",
    x: 28.82,
    y: 18.86,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-415"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-165",
    x: 28.82,
    y: 18.85,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-707"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-33",
    x: 28.82,
    y: 18.84,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-737"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-42",
    x: 28.82,
    y: 18.82,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-885"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-190",
    x: 28.82,
    y: 18.81,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1011"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-146",
    x: 28.82,
    y: 18.79,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-507"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-230",
    x: 28.82,
    y: 18.78,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-599"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-92",
    x: 28.82,
    y: 18.77,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1053"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-231",
    x: 28.82,
    y: 18.75,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-620"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-305",
    x: 28.82,
    y: 18.74,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-715"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-305",
    x: 28.82,
    y: 18.73,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-992"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-331",
    x: 28.82,
    y: 18.71,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-724"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-158",
    x: 28.82,
    y: 18.7,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-687"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-43",
    x: 28.82,
    y: 18.68,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-413"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-214",
    x: 28.82,
    y: 18.67,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-346"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-88",
    x: 28.82,
    y: 18.66,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-909"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 28.82,
    y: 18.64,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-477"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-186",
    x: 28.82,
    y: 18.63,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-736"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-103",
    x: 28.82,
    y: 18.62,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1045"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    x: 28.82,
    y: 18.6,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-656"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-129",
    x: 28.82,
    y: 18.59,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-930"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-285",
    x: 28.82,
    y: 18.58,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-716"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-116",
    x: 28.82,
    y: 18.56,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-710"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-333",
    x: 28.82,
    y: 18.55,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-487"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 28.82,
    y: 18.53,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-970"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-256",
    x: 28.82,
    y: 18.52,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-638"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 28.82,
    y: 18.51,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-584"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-27",
    x: 28.82,
    y: 18.49,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-537"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-187",
    x: 28.82,
    y: 18.48,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-509"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-147",
    x: 28.82,
    y: 18.47,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-343"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-272",
    x: 28.82,
    y: 18.45,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-591"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-259",
    x: 28.82,
    y: 18.44,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1023"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-155",
    x: 28.82,
    y: 18.43,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-783"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-125",
    x: 28.82,
    y: 18.41,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-974"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 28.82,
    y: 18.4,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-712"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-223",
    x: 28.82,
    y: 18.38,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-551"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-86",
    x: 28.82,
    y: 18.37,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-887"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-327",
    x: 28.82,
    y: 18.36,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-819"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-67",
    x: 28.82,
    y: 18.34,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1025"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-191",
    x: 28.82,
    y: 18.33,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-775"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 28.82,
    y: 18.32,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-856"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-225",
    x: 28.82,
    y: 18.3,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-399"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-77",
    x: 28.82,
    y: 18.29,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-793"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 28.82,
    y: 18.28,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-954"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 28.82,
    y: 18.26,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-618"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-127",
    x: 28.82,
    y: 18.25,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1039"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-265",
    x: 28.82,
    y: 18.23,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-543"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-317",
    x: 28.82,
    y: 18.22,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-401"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-330",
    x: 28.82,
    y: 18.21,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-744"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-208",
    x: 28.82,
    y: 18.19,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-549"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-295",
    x: 28.82,
    y: 18.18,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-350"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 28.82,
    y: 18.17,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-771"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 28.82,
    y: 18.15,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-654"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-271",
    x: 28.82,
    y: 18.14,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-696"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 28.82,
    y: 18.12,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-774"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-316",
    x: 28.82,
    y: 18.11,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-395"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 28.82,
    y: 18.1,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-439"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 28.82,
    y: 18.08,
    width: 9.78,
    height: 0.01
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-990"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 28.82,
    y: 17.63,
    width: 9.78,
    height: 0.45
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-833"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-577"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 28.82,
    y: 14.2,
    width: 9.78,
    height: 1.47
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-959"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-233",
    x: 28.82,
    y: 15.67,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-795"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-106",
    x: 28.82,
    y: 15.7,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-476"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-134",
    x: 28.82,
    y: 15.74,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-478"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 28.82,
    y: 15.78,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-855"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-166",
    x: 28.82,
    y: 15.81,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-705"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 28.82,
    y: 15.85,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-738"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-314",
    x: 28.82,
    y: 15.88,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-903"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-131",
    x: 28.82,
    y: 15.92,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-387"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-275",
    x: 28.82,
    y: 15.95,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-969"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-276",
    x: 28.82,
    y: 15.99,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-394"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-298",
    x: 28.82,
    y: 16.02,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-246",
    x: 28.82,
    y: 16.06,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-825"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-270",
    x: 28.82,
    y: 16.09,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-916"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-301",
    x: 28.82,
    y: 16.13,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-437"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-299",
    x: 28.82,
    y: 16.16,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1038"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 28.82,
    y: 16.2,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-497"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-235",
    x: 28.82,
    y: 16.24,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-566"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-195",
    x: 28.82,
    y: 16.27,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-891"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 28.82,
    y: 16.31,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-870"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-144",
    x: 28.82,
    y: 16.34,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-544"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 28.82,
    y: 16.38,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1051"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-217",
    x: 28.82,
    y: 16.41,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-804"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-97",
    x: 28.82,
    y: 16.45,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-357"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-136",
    x: 28.82,
    y: 16.48,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-393"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-104",
    x: 28.82,
    y: 16.52,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-732"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 28.82,
    y: 16.55,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-449"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-121",
    x: 28.82,
    y: 16.59,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-861"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-180",
    x: 28.82,
    y: 16.63,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-733"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-71",
    x: 28.82,
    y: 16.66,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-746"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-257",
    x: 28.82,
    y: 16.7,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-452"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-291",
    x: 28.82,
    y: 16.73,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-709"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-239",
    x: 28.82,
    y: 16.77,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-410"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 28.82,
    y: 16.8,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-597"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-179",
    x: 28.82,
    y: 16.84,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-356"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 28.82,
    y: 16.87,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-674"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-160",
    x: 28.82,
    y: 16.91,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-379"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-188",
    x: 28.82,
    y: 16.94,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-651"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 28.82,
    y: 16.98,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-589"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-151",
    x: 28.82,
    y: 17.01,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-573"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-196",
    x: 28.82,
    y: 17.05,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-481"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-201",
    x: 28.82,
    y: 17.09,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-423"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-75",
    x: 28.82,
    y: 17.12,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-353"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-302",
    x: 28.82,
    y: 17.16,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-845"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 28.82,
    y: 17.19,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-432"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 28.82,
    y: 17.23,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-988"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-68",
    x: 28.82,
    y: 17.26,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-495"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-336",
    x: 28.82,
    y: 17.3,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-435"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-203",
    x: 28.82,
    y: 17.33,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-873"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-280",
    x: 28.82,
    y: 17.37,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-878"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-169",
    x: 28.82,
    y: 17.4,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-628"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 28.82,
    y: 17.44,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-711"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-219",
    x: 28.82,
    y: 17.48,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-631"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-205",
    x: 28.82,
    y: 17.51,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-669"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-170",
    x: 28.82,
    y: 17.55,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-915"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-215",
    x: 28.82,
    y: 17.58,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-447"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-237",
    x: 28.82,
    y: 17.62,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-621"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: 28.82,
    y: 17.65,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-596"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-229",
    x: 28.82,
    y: 17.69,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-405"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-267",
    x: 28.82,
    y: 17.72,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-782"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 28.82,
    y: 17.76,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1048"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-167",
    x: 28.82,
    y: 17.79,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-381"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-161",
    x: 28.82,
    y: 17.83,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-472"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 28.82,
    y: 17.86,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-403"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-172",
    x: 28.82,
    y: 17.9,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-760"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-283",
    x: 28.82,
    y: 17.94,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-955"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.82,
    y: 17.97,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-688"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 28.82,
    y: 18.01,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-464"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-245",
    x: 28.82,
    y: 18.04,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-461"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 28.82,
    y: 18.08,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-506"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-236",
    x: 28.82,
    y: 18.11,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-926"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-243",
    x: 28.82,
    y: 18.15,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-852"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 28.82,
    y: 18.18,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-880"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-89",
    x: 28.82,
    y: 18.22,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-701"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-238",
    x: 28.82,
    y: 18.25,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-483"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 28.82,
    y: 18.29,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-601"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 28.82,
    y: 18.33,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-902"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-154",
    x: 28.82,
    y: 18.36,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-841"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-61",
    x: 28.82,
    y: 18.4,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-383"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-130",
    x: 28.82,
    y: 18.43,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1020"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 28.82,
    y: 18.47,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-843"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-26",
    x: 28.82,
    y: 18.5,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1008"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 28.82,
    y: 18.54,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-344"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-93",
    x: 28.82,
    y: 18.59,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-864"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-224",
    x: 28.82,
    y: 18.63,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-971"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-253",
    x: 28.82,
    y: 18.67,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-719"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 28.82,
    y: 18.71,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-704"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-87",
    x: 28.82,
    y: 18.76,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-685"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-287",
    x: 28.82,
    y: 18.8,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-749"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-278",
    x: 28.82,
    y: 18.84,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-505"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-308",
    x: 28.82,
    y: 18.88,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-516"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-308",
    x: 28.82,
    y: 18.93,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1049"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-228",
    x: 28.82,
    y: 18.97,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-431"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-319",
    x: 28.82,
    y: 19.01,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-972"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-319",
    x: 28.82,
    y: 19.05,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-730"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 28.82,
    y: 19.1,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1036"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-332",
    x: 28.82,
    y: 19.14,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-922"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-332",
    x: 28.82,
    y: 19.18,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-244",
    x: 28.82,
    y: 19.22,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-694"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-281",
    x: 28.82,
    y: 19.27,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1024"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-50",
    x: 28.82,
    y: 19.31,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-406"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-321",
    x: 28.82,
    y: 19.35,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-647"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-137",
    x: 28.82,
    y: 19.4,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-588"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-49",
    x: 28.82,
    y: 19.44,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-341"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-293",
    x: 28.82,
    y: 19.48,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-671"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-293",
    x: 28.82,
    y: 19.52,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-726"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-162",
    x: 28.82,
    y: 19.57,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-467"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-73",
    x: 28.82,
    y: 19.61,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-502"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 28.82,
    y: 19.65,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-434"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 28.82,
    y: 19.69,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-400"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-56",
    x: 28.82,
    y: 19.74,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-766"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-304",
    x: 28.82,
    y: 19.78,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-559"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-183",
    x: 28.82,
    y: 19.82,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-538"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 28.82,
    y: 19.86,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-592"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-114",
    x: 28.82,
    y: 19.91,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-550"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 28.82,
    y: 19.95,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-580"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-264",
    x: 28.82,
    y: 19.99,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-692"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-262",
    x: 28.82,
    y: 20.03,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-539"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-255",
    x: 28.82,
    y: 20.08,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-675"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-261",
    x: 28.82,
    y: 20.12,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-486"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-300",
    x: 28.82,
    y: 20.16,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1022"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-112",
    x: 28.82,
    y: 20.2,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-892"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-220",
    x: 28.82,
    y: 20.25,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-877"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-139",
    x: 28.82,
    y: 20.29,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-499"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 28.82,
    y: 20.33,
    width: 9.78,
    height: 0.04
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-459"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 28.82,
    y: 20.37,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-982"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-44",
    x: 28.82,
    y: 20.4,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-917"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-247",
    x: 28.82,
    y: 20.44,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-801"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-65",
    x: 28.82,
    y: 20.47,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-515"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-328",
    x: 28.82,
    y: 20.5,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-838"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 28.82,
    y: 20.53,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-986"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-91",
    x: 28.82,
    y: 20.56,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1009"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-24",
    x: 28.82,
    y: 20.6,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-396"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-241",
    x: 28.82,
    y: 20.63,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-800"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-248",
    x: 28.82,
    y: 20.66,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-786"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-83",
    x: 28.82,
    y: 20.69,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-913"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 28.82,
    y: 20.72,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-533"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-84",
    x: 28.82,
    y: 20.76,
    width: 9.78,
    height: 0.03
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-897"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-240",
    x: 28.82,
    y: 20.79,
    width: 9.78,
    height: 0.02
  })))), /*#__PURE__*/React.createElement("g", {
    className: "cls-868"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-212",
    x: 13.42,
    y: 28.4,
    width: 40.75,
    height: 21.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1050"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-826"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-325",
    x: 1.52,
    y: 1.1,
    width: 64.55,
    height: 35.53
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-824"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M34.38.9h16.58v-.9c5.08,2.07,9.64,5.02,13.45,8.65.95.91,1.86,1.85,2.72,2.84h-.85v25.34H1.34V10.52h-.11c.88-.96,1.82-1.88,2.8-2.76,1.96-1.75,4.1-3.34,6.39-4.72,1.15-.69,2.33-1.33,3.55-1.92.61-.29,1.23-.58,1.85-.84v.63h18.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-661"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M34.33.02c10.79.16,20.5,4.34,27.47,10.97,1.74,1.66,3.32,3.47,4.69,5.41h-.22v20.44H1.33v-19.95h-.67c.33-.49.68-.97,1.04-1.45,1.43-1.9,3.06-3.66,4.85-5.27C13.71,3.75,23.54-.14,34.33.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-854"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-325",
    d: "M34.28,3.38c9.78.14,18.59,3.94,24.91,9.95,3.16,3.01,5.71,6.57,7.44,10.51h-.37v13H1.32v-10.99H.09c.36-1.02.77-2.02,1.24-2.99,1.85-3.89,4.5-7.37,7.75-10.28C15.58,6.76,24.49,3.23,34.28,3.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-989"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M34.28,3.51c9.75.14,18.52,3.92,24.82,9.91,3.15,2.99,5.68,6.54,7.41,10.46h-.24v12.95H1.33v-10.94H.24c.36-1.01.77-2.01,1.23-2.97,1.84-3.87,4.48-7.34,7.72-10.24C15.65,6.88,24.53,3.36,34.28,3.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-893"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M34.27,3.64c9.71.14,18.44,3.9,24.72,9.87,3.14,2.98,5.66,6.52,7.38,10.42h-.11v12.91H1.32v-10.9H.36c.36-1.01.77-2,1.23-2.96,1.84-3.85,4.46-7.31,7.69-10.2C15.72,6.99,24.57,3.49,34.27,3.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1005"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-335",
    d: "M34.27,3.77c9.67.14,18.37,3.89,24.62,9.83,3.12,2.97,5.64,6.49,7.35,10.38.43.97.81,1.97,1.13,2.99h-1.11v9.87H1.32v-10.87H.49c.36-1.01.76-1.99,1.22-2.95,1.83-3.84,4.44-7.28,7.66-10.16C15.8,7.11,24.6,3.62,34.27,3.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-682"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-174",
    d: "M34.27,3.89c9.63.14,18.3,3.87,24.52,9.79,3.11,2.96,5.61,6.46,7.32,10.34.43.97.8,1.96,1.13,2.97h-.98v9.84H1.32v-10.82h-.69c.35-1,.76-1.98,1.22-2.94,1.82-3.82,4.43-7.25,7.62-10.12C15.87,7.23,24.64,3.75,34.27,3.89Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-443"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M34.27,4.02c9.59.14,18.22,3.86,24.42,9.75,3.1,2.95,5.59,6.44,7.29,10.3.43.97.8,1.95,1.12,2.96h-.84v9.8H1.32v-10.78h-.56c.35-1,.76-1.98,1.21-2.93,1.81-3.81,4.41-7.22,7.59-10.08,6.38-5.7,15.12-9.16,24.71-9.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1001"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M34.27,4.15c9.55.14,18.15,3.84,24.32,9.71,3.09,2.93,5.57,6.41,7.26,10.26.42.96.8,1.95,1.12,2.95h-.71v9.76H1.32v-7.69H0c.49-2.07,1.2-4.07,2.1-5.96,1.81-3.79,4.39-7.2,7.56-10.04,6.35-5.68,15.05-9.13,24.61-8.99Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-662"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M34.26,4.28c9.51.14,18.07,3.83,24.22,9.67,3.07,2.92,5.55,6.39,7.23,10.21.84,1.91,1.49,3.92,1.92,6h-1.38v6.67H1.31v-7.66H.12c.49-2.06,1.2-4.05,2.1-5.94,1.8-3.78,4.37-7.17,7.53-10,6.33-5.66,15-9.09,24.51-8.95Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1034"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M34.26,4.41c9.48.14,18,3.81,24.13,9.63,3.06,2.91,5.52,6.36,7.21,10.17.84,1.91,1.48,3.91,1.91,5.97h-1.24v6.64H1.33v-7.64H.28c.49-2.05,1.19-4.03,2.09-5.91,1.79-3.76,4.36-7.14,7.5-9.96,6.29-5.62,14.92-9.04,24.39-8.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-839"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-268",
    d: "M34.26,4.54c9.44.14,17.93,3.8,24.03,9.59,3.05,2.9,5.5,6.33,7.18,10.13.84,1.9,1.48,3.89,1.9,5.95h-1.1v6.62H1.33v-7.61H.42c.49-2.05,1.19-4.02,2.08-5.89,1.78-3.75,4.34-7.11,7.47-9.92,6.26-5.6,14.85-9.01,24.29-8.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-734"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M34.26,4.67c9.4.14,17.85,3.78,23.93,9.55,3.04,2.89,5.48,6.31,7.15,10.09.83,1.89,1.47,3.87,1.9,5.92h-.96v6.59H1.34v-7.58h-.78c.48-2.04,1.18-4,2.07-5.87,1.78-3.73,4.32-7.08,7.44-9.87,6.23-5.58,14.79-8.97,24.19-8.83Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-923"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M34.26,4.8c9.36.14,17.78,3.76,23.83,9.51,3.02,2.88,5.46,6.28,7.12,10.05.83,1.88,1.47,3.86,1.89,5.9h-.83v6.57H1.33v-7.55h-.64c.48-2.03,1.18-3.98,2.06-5.84,1.77-3.72,4.3-7.05,7.41-9.83,6.21-5.57,14.74-8.95,24.1-8.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-649"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-310",
    d: "M34.25,4.93c9.32.14,17.71,3.75,23.73,9.48,3.01,2.86,5.43,6.26,7.09,10.01,1.65,3.75,2.54,7.86,2.47,12.16h-1.28v.26H1.32v-1.26H.04C.3,18.38,15.61,4.65,34.25,4.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-581"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M34.25,5.06c9.28.14,17.63,3.73,23.63,9.44,6,5.71,9.65,13.51,9.52,22.08h-1.14v.26H1.32v-1.25H.18C.43,18.45,15.69,4.78,34.25,5.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-416"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-296",
    d: "M34.25,5.19c18.49.27,33.27,14.32,33.02,31.38h-1v.26H1.33v-1.25H.33C.57,18.52,15.76,4.91,34.25,5.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-767"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M34.25,5.32c18.41.27,33.13,14.26,32.88,31.25h-.86v.27H1.33v-1.25H.47C.71,18.6,15.84,5.04,34.25,5.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-834"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-209",
    d: "M34.25,5.45c18.33.27,32.99,14.2,32.74,31.12h-.72v.27H1.33v-1.25h-.72C.85,18.67,15.91,5.17,34.25,5.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-457"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-163",
    d: "M34.24,5.57c18.25.27,32.85,14.14,32.6,30.99h-.58v.27H1.32v-1.25h-.58C.99,18.74,15.99,5.31,34.24,5.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-392"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-173",
    d: "M34.24,5.7c18.18.27,32.71,14.08,32.46,30.86h-.44v.27H1.32v-1.24h-.44C1.13,18.82,16.07,5.44,34.24,5.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-492"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-279",
    d: "M34.24,5.83c18.1.27,32.57,14.02,32.33,30.73h-.3v.27H1.33v-1.24h-.3c.24-16.7,15.11-30.02,33.21-29.76Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-872"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M34.24,5.96c18.02.27,32.43,13.96,32.19,30.6h-.16v.28H1.33v-1.24h-.16c.24-16.64,15.05-29.9,33.07-29.64Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-983"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M34.24,6.09c17.95.26,32.29,13.9,32.05,30.46,0,.52-.03,1.03-.07,1.54v-1.26H1.32v-1.24h-.02C1.55,19.04,16.29,5.83,34.24,6.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-942"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-182",
    d: "M34.24,6.22c17.87.26,32.16,13.84,31.91,30.33,0,.52-.03,1.03-.06,1.54v-1.26H1.47v.3c-.02-.51-.03-1.02-.02-1.54.24-16.48,14.92-29.63,32.79-29.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-908"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-140",
    d: "M34.23,6.35c17.79.26,32.02,13.78,31.77,30.2,0,.51-.03,1.02-.06,1.53v-1.25H1.6v.3c-.02-.51-.03-1.02-.02-1.53.24-16.42,14.86-29.51,32.65-29.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-980"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-69",
    d: "M34.23,6.48c17.71.26,31.88,13.72,31.64,30.07,0,.51-.03,1.02-.06,1.52v-1.24H1.75v.29c-.02-.5-.03-1.01-.02-1.52.23-16.34,14.79-29.38,32.5-29.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-706"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M34.23,6.61c17.64.26,31.74,13.66,31.5,29.94,0,.51-.03,1.01-.06,1.52v-1.23H1.88v.29c-.02-.5-.03-1.01-.02-1.52.24-16.28,14.73-29.26,32.37-29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-349"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M34.23,6.74c17.56.26,31.6,13.6,31.36,29.81,0,.51-.03,1.01-.06,1.51v-1.22H2.03v.28c-.02-.5-.03-1-.02-1.51.23-16.21,14.66-29.13,32.22-28.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-633"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-178",
    d: "M34.23,6.87c17.48.26,31.46,13.54,31.22,29.68,0,.5-.03,1.01-.06,1.5v-1.21H2.17v.28c-.02-.5-.03-1-.02-1.5.23-16.14,14.59-29.01,32.08-28.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-968"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-307",
    d: "M34.22,7c17.4.26,31.32,13.48,31.08,29.54,0,.5-.03,1-.06,1.5v-1.2H2.3v.27c-.02-.5-.03-1-.02-1.5.24-16.06,14.54-28.87,31.94-28.61Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-389"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-286",
    d: "M34.22,7.13c17.33.26,31.18,13.42,30.95,29.41,0,.5-.03,1-.06,1.49v-1.19H2.45v.27c-.02-.49-.03-.99-.02-1.49.23-16,14.47-28.75,31.79-28.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-812"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-181",
    d: "M34.22,7.25c17.25.26,31.04,13.37,30.81,29.29,0,.5-.03.99-.06,1.48v-1.19H2.58v.27c-.02-.49-.03-.99-.02-1.48.24-15.92,14.41-28.62,31.66-28.37Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-587"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M34.22,7.38c17.17.25,30.9,13.3,30.67,29.15,0,.5-.03.99-.06,1.48v-1.18H2.73v.26c-.02-.49-.03-.98-.02-1.48.23-15.84,14.34-28.48,31.51-28.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-777"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M34.22,7.51c17.09.26,30.76,13.25,30.53,29.02,0,.49-.03.98-.06,1.47v-1.17H2.87v.26c-.02-.49-.03-.98-.02-1.47.23-15.78,14.27-28.36,31.37-28.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-789"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M34.21,7.64c17.02.25,30.62,13.18,30.39,28.89,0,.49-.03.98-.06,1.46v-1.16H3v.25c-.02-.49-.03-.97-.02-1.46.23-15.7,14.22-28.23,31.23-27.98Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-977"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-207",
    d: "M34.21,7.77c16.94.25,30.49,13.13,30.26,28.76,0,.49-.03.97-.06,1.46v-1.15H3.14v.25c-.02-.48-.03-.97-.02-1.46.23-15.64,14.15-28.11,31.09-27.86Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-820"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-232",
    d: "M34.21,7.9c16.86.25,30.35,13.07,30.12,28.63,0,.49-.03.97-.06,1.45v-1.14H3.28v.24c-.02-.48-.03-.96-.02-1.45.23-15.57,14.09-27.98,30.95-27.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-586"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M34.21,8.03c16.78.25,30.21,13.01,29.98,28.49,0,.48-.03.97-.06,1.44v-1.13H3.42v.24c-.02-.48-.03-.96-.02-1.44.23-15.49,14.02-27.85,30.81-27.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-895"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M34.21,8.16c16.7.25,30.06,12.94,29.84,28.36,0,.48-.03.96-.06,1.44v-1.13H3.56v.23c-.02-.48-.03-.96-.02-1.44.23-15.41,13.96-27.71,30.67-27.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-579"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M34.2,8.29c16.63.25,29.93,12.89,29.7,28.23,0,.48-.03.96-.06,1.43v-1.12H3.69v.23c-.02-.47-.03-.95-.02-1.43.24-15.35,13.9-27.59,30.53-27.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-593"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M34.2,8.42c16.55.24,29.79,12.83,29.56,28.1,0,.48-.03.95-.06,1.42v-1.11H3.83v.22c-.02-.47-.03-.95-.02-1.42.24-15.27,13.84-27.46,30.39-27.21Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-750"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M34.2,8.55c16.48.24,29.65,12.76,29.43,27.97,0,.48-.03.95-.06,1.42v-1.1H3.98v.22c-.02-.47-.02-.94-.02-1.42.23-15.21,13.77-27.34,30.24-27.09Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-698"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-193",
    d: "M34.2,8.68c16.4.24,29.51,12.7,29.29,27.83,0,.47-.03.94-.06,1.41v-1.09H4.12v.21c-.02-.47-.02-.94-.02-1.41.23-15.12,13.7-27.2,30.1-26.95Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-932"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-156",
    d: "M34.2,8.81c16.32.24,29.37,12.65,29.15,27.71,0,.47-.03.94-.06,1.4v-1.08H4.26v.21c-.02-.47-.02-.93-.02-1.4.22-15.07,13.64-27.09,29.96-26.84Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-960"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-177",
    d: "M34.2,8.93c16.24.24,29.23,12.59,29.01,27.58,0,.47-.03.93-.06,1.4v-1.07H4.4v.21c-.02-.46-.02-.93-.02-1.4.22-15,13.57-26.96,29.82-26.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-863"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-168",
    d: "M34.19,9.06c16.17.24,29.09,12.53,28.87,27.44,0,.47-.03.93-.06,1.39v-1.06H4.53v.2c-.02-.46-.02-.92-.02-1.39.23-14.91,13.52-26.81,29.68-26.58Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-348"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-216",
    d: "M34.19,9.19c16.09.24,28.96,12.47,28.74,27.32,0,.46-.03.92-.06,1.38v-1.06H4.68v.2c-.02-.46-.02-.92-.02-1.38.22-14.85,13.44-26.69,29.53-26.46Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-714"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M34.19,9.32c16.01.24,28.82,12.41,28.6,27.18,0,.46-.03.92-.06,1.38v-1.05H4.82v.19c-.02-.46-.02-.92-.02-1.38.22-14.77,13.38-26.55,29.39-26.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-571"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-157",
    d: "M34.19,9.45c15.93.24,28.68,12.35,28.46,27.05,0,.46-.03.92-.06,1.37v-1.04H4.96v.19c-.02-.45-.02-.91-.02-1.37.22-14.7,13.31-26.43,29.25-26.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1054"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-240",
    d: "M34.19,9.58c15.85.24,28.53,12.29,28.32,26.92,0,.46-.03.91-.06,1.36v-1.03H5.1v.18c-.02-.45-.02-.91-.02-1.36.22-14.63,13.25-26.3,29.11-26.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-665"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M34.18,9.71c15.78.23,28.4,12.23,28.18,26.79,0,.46-.03.91-.06,1.36v-1.02H5.23v.18c-.02-.45-.02-.9-.02-1.36.23-14.57,13.19-26.18,28.97-25.95Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-829"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M34.18,9.84c15.7.23,28.26,12.17,28.05,26.66,0,.45-.03.9-.06,1.35v-1.01H5.38v.17c-.02-.45-.02-.9-.02-1.35.22-14.49,13.12-26.05,28.82-25.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-569"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M34.18,9.97c15.63.23,28.12,12.11,27.91,26.52,0,.45-.03.9-.06,1.34v-1H5.52v.17c-.02-.45-.02-.89-.02-1.34.22-14.42,13.05-25.92,28.68-25.69Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1019"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-248",
    d: "M34.18,10.1c15.55.23,27.98,12.05,27.77,26.39,0,.45-.03.89-.06,1.34v-.99H5.66v.16c-.02-.44-.02-.89-.02-1.34.21-14.35,12.99-25.79,28.54-25.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-660"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-241",
    d: "M34.18,10.23c15.47.23,27.84,11.99,27.63,26.26,0,.45-.03.89-.06,1.33v-.99H5.8v.16c-.02-.44-.02-.88-.02-1.33.21-14.27,12.93-25.66,28.4-25.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-901"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M34.17,10.36c15.4.22,27.71,11.92,27.5,26.13,0,.44-.03.88-.06,1.32v-.98H5.94v.16c-.02-.44-.02-.88-.02-1.32.21-14.21,12.86-25.54,28.25-25.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-390"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M34.17,10.49c15.32.23,27.56,11.87,27.35,26,0,.44-.03.88-.06,1.32v-.97H6.08v.15c-.02-.44-.02-.88-.02-1.32.21-14.14,12.8-25.41,28.11-25.18Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-475"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M34.17,10.61c15.24.23,27.42,11.81,27.22,25.87,0,.44-.03.88-.06,1.31v-.96H6.22v.15c-.02-.43-.02-.87-.02-1.31.21-14.06,12.73-25.28,27.97-25.06Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-503"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-328",
    d: "M34.17,10.74c15.16.22,27.28,11.75,27.08,25.74,0,.44-.02.87-.05,1.3v-.95H6.36v.14c-.02-.43-.02-.87-.02-1.3.21-13.99,12.67-25.15,27.83-24.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-976"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M34.17,10.87c15.08.22,27.14,11.69,26.94,25.61,0,.43-.02.87-.05,1.3v-.94H6.5v.14c-.02-.43-.02-.86-.02-1.3.21-13.93,12.6-25.03,27.69-24.81Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-594"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-247",
    d: "M34.16,11c15.01.22,27.01,11.63,26.8,25.47,0,.43-.02.86-.05,1.29v-.93H6.64v.13c-.02-.43-.02-.86-.02-1.29.21-13.84,12.54-24.89,27.54-24.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-910"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M34.16,11.13c14.93.22,26.87,11.57,26.66,25.34,0,.43-.02.86-.05,1.28v-.92H6.78v.13c-.02-.43-.02-.85-.02-1.28.21-13.78,12.47-24.77,27.4-24.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-752"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M34.16,11.26c14.85.22,26.73,11.51,26.53,25.21,0,.43-.02.85-.05,1.28v-.92H6.92v.12c-.02-.42-.02-.85-.02-1.28.21-13.7,12.41-24.63,27.26-24.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-512"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M34.16,11.39c14.77.22,26.59,11.45,26.39,25.08,0,.43-.02.85-.05,1.27v-.91H7.14v1.37c-.08-.83-.11-1.67-.1-2.53.2-13.62,12.34-24.5,27.12-24.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-368"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M34.16,11.56c14.67.22,26.4,11.37,26.2,24.91,0,.42-.02.84-.05,1.26v-.9H7.33v1.36c-.08-.83-.11-1.66-.1-2.51.2-13.53,12.26-24.33,26.93-24.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1052"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-220",
    d: "M34.15,11.73c14.57.22,26.22,11.29,26.02,24.74,0,.42-.02.84-.05,1.25v-.88H7.52v1.34c-.08-.82-.11-1.65-.1-2.49.2-13.45,12.17-24.17,26.73-23.96Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-743"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M34.15,11.91c14.47.21,26.03,11.2,25.84,24.55,0,.42-.02.83-.05,1.24v-.87H7.7v1.33c-.08-.81-.11-1.64-.1-2.47.2-13.35,12.09-24,26.55-23.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-904"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-300",
    d: "M34.15,12.08c14.36.21,25.85,11.13,25.65,24.38,0,.41-.02.83-.05,1.23v-.86H7.89v1.31c-.08-.81-.11-1.63-.1-2.46.2-13.24,12-23.81,26.36-23.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-345"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-261",
    d: "M34.15,12.25c14.26.21,25.66,11.05,25.47,24.21,0,.41-.02.82-.05,1.23v-.85H8.07v1.3c-.08-.8-.11-1.62-.1-2.44.2-13.16,11.92-23.66,26.18-23.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-729"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-255",
    d: "M34.14,12.42c14.16.21,25.48,10.97,25.28,24.03,0,.41-.02.81-.05,1.22v-.84H8.26v1.28c-.08-.8-.11-1.6-.1-2.42.2-13.06,11.83-23.48,25.98-23.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-455"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-262",
    d: "M34.14,12.6c14.05.21,25.29,10.89,25.1,23.86,0,.41-.02.81-.05,1.21v-.83H8.45v1.27c-.08-.79-.11-1.59-.1-2.4.19-12.98,11.74-23.32,25.79-23.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-953"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-264",
    d: "M34.14,12.77c13.95.21,25.1,10.81,24.91,23.68,0,.4-.02.8-.05,1.2v-.81H8.63v1.25c-.07-.78-.11-1.58-.1-2.39.2-12.87,11.66-23.14,25.61-22.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-530"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-63",
    d: "M34.14,12.94c13.85.2,24.92,10.73,24.73,23.51,0,.4-.02.8-.05,1.19v-.8H8.82v1.24c-.07-.78-.11-1.57-.09-2.37.18-12.78,11.56-22.97,25.41-22.77Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-725"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M34.13,13.11c13.75.21,24.74,10.65,24.55,23.33,0,.4-.02.79-.05,1.18v-.79H9v1.22c-.07-.77-.11-1.56-.09-2.35.19-12.67,11.48-22.79,25.22-22.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-999"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-114",
    d: "M34.13,13.28c13.64.2,24.55,10.57,24.36,23.16,0,.39-.02.78-.05,1.17v-.78H9.19v1.21c-.07-.77-.1-1.55-.09-2.33.18-12.59,11.39-22.63,25.03-22.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-794"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-183",
    d: "M34.13,13.46c13.54.2,24.36,10.49,24.18,22.98,0,.39-.02.78-.05,1.16v-.77H9.38v1.2c-.07-.76-.1-1.53-.09-2.31.18-12.5,11.3-22.46,24.84-22.26Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-572"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-304",
    d: "M34.13,13.63c13.43.2,24.18,10.41,23.99,22.81,0,.39-.02.77-.05,1.15v-.76H9.56v1.18c-.07-.76-.1-1.52-.09-2.3.18-12.39,11.22-22.28,24.66-22.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-857"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M34.12,13.8c13.33.2,23.99,10.33,23.81,22.63,0,.38-.02.77-.05,1.15v-.74H9.75v1.17c-.07-.75-.1-1.51-.09-2.28.18-12.31,11.13-22.13,24.46-21.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-521"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M34.12,13.97c13.23.2,23.81,10.25,23.63,22.46,0,.38-.02.76-.05,1.14v-.73H9.93v1.15c-.07-.74-.1-1.5-.09-2.26.18-12.21,11.05-21.95,24.28-21.76Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1018"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M34.12,14.15c13.12.19,23.62,10.17,23.44,22.28,0,.38-.02.75-.05,1.13v-.72H10.12v1.14c-.07-.74-.1-1.49-.09-2.24.18-12.13,10.96-21.79,24.09-21.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-422"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M34.12,14.32c13.02.19,23.43,10.09,23.26,22.11,0,.38-.02.75-.05,1.12v-.71H10.31v1.12c-.07-.73-.1-1.48-.09-2.23.17-12.02,10.87-21.6,23.9-21.41Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-881"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-162",
    d: "M34.11,14.49c12.92.19,23.25,10.01,23.07,21.93,0,.37-.02.74-.05,1.11v-.7H10.49v1.11c-.07-.73-.1-1.46-.09-2.21.18-11.92,10.79-21.43,23.71-21.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-814"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M34.11,14.66c12.82.19,23.06,9.93,22.89,21.76,0,.37-.02.74-.05,1.1v-.69H10.68v1.09c-.07-.72-.1-1.45-.09-2.19.17-11.82,10.71-21.26,23.52-21.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-561"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-293",
    d: "M34.11,14.84c12.71.19,22.88,9.85,22.7,21.58,0,.37-.02.73-.05,1.09v-.68H10.86v1.08c-.07-.72-.1-1.44-.09-2.17.18-11.73,10.63-21.09,23.34-20.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-352"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M34.11,15.01c12.61.19,22.69,9.77,22.52,21.41,0,.36-.02.72-.05,1.08v-.66H11.05v1.06c-.07-.71-.1-1.43-.09-2.16.18-11.64,10.54-20.92,23.15-20.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1040"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M34.1,15.18c12.51.18,22.51,9.69,22.34,21.23,0,.36-.02.72-.05,1.07v-.65H11.24v1.05c-.07-.7-.1-1.42-.09-2.14.17-11.54,10.45-20.75,22.95-20.56Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-753"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-321",
    d: "M34.1,15.35c12.4.18,22.32,9.61,22.15,21.06,0,.36-.02.71-.04,1.07v-.64H11.42v1.03c-.07-.7-.1-1.41-.08-2.12.17-11.45,10.36-20.58,22.76-20.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-545"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M34.1,15.52c12.3.18,22.14,9.53,21.97,20.88,0,.35-.02.71-.04,1.06v-.63H11.61v1.02c-.07-.69-.09-1.39-.08-2.1.16-11.35,10.27-20.41,22.57-20.23Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-769"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-281",
    d: "M34.1,15.7c12.2.18,21.95,9.45,21.78,20.71,0,.35-.02.7-.04,1.05v-.62H11.79v1c-.07-.69-.09-1.38-.08-2.09.17-11.26,10.19-20.23,22.39-20.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-380"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-244",
    d: "M34.09,15.87c12.09.18,21.76,9.37,21.6,20.53,0,.35-.02.7-.04,1.04v-.61H11.98v.99c-.06-.68-.09-1.37-.08-2.07.16-11.16,10.1-20.06,22.19-19.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-575"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M34.09,16.04c11.99.18,21.58,9.29,21.42,20.36,0,.35-.02.69-.04,1.03v-.59H12.17v.97c-.06-.67-.09-1.36-.08-2.05.16-11.07,10.01-19.9,22-19.72Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-465"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-332",
    d: "M34.09,16.21c11.89.18,21.39,9.21,21.23,20.18,0,.34-.02.68-.04,1.02v-.58H12.35v.96c-.06-.67-.09-1.35-.08-2.03.16-10.97,9.93-19.72,21.82-19.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-721"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M34.09,16.39c11.78.17,21.21,9.13,21.05,20.01,0,.34-.02.68-.04,1.01v-.57H12.54v.94c-.06-.66-.09-1.34-.08-2.01.16-10.88,9.84-19.56,21.63-19.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-966"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M34.08,16.56c11.68.17,21.02,9.05,20.86,19.83,0,.34-.02.67-.04,1v-.56H12.72v.93c-.06-.66-.09-1.32-.08-2,.16-10.78,9.76-19.37,21.44-19.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-462"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-319",
    d: "M34.08,16.73c11.58.17,20.84,8.97,20.68,19.66,0,.33-.02.67-.04,1v-.55H12.91v.91c-.06-.65-.09-1.31-.08-1.98.16-10.69,9.67-19.21,21.25-19.04Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-695"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-228",
    d: "M34.08,16.9c11.48.17,20.65,8.89,20.5,19.48,0,.33-.02.66-.04.99v-.54H13.09v.9c-.06-.65-.09-1.3-.08-1.96.16-10.59,9.59-19.04,21.07-18.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-598"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M34.08,17.07c11.37.17,20.47,8.81,20.31,19.31,0,.33-.02.65-.04.98v-.52H13.28v.88c-.06-.64-.09-1.29-.08-1.94.16-10.5,9.5-18.87,20.88-18.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-364"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-308",
    d: "M34.07,17.25c11.27.17,20.28,8.73,20.13,19.13,0,.32-.02.65-.04.97v-.51H13.47v.87c-.06-.63-.09-1.28-.08-1.93.15-10.4,9.41-18.7,20.68-18.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-681"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-278",
    d: "M34.07,17.42c11.17.16,20.09,8.65,19.94,18.96,0,.32-.02.64-.04.96v-.5H13.65v.85c-.06-.63-.09-1.27-.08-1.91.16-10.31,9.33-18.53,20.5-18.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-359"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-287",
    d: "M34.07,17.59c11.06.16,19.91,8.57,19.76,18.78,0,.32-.02.64-.04.95v-.49H13.84v.84c-.06-.62-.08-1.25-.08-1.89.15-10.21,9.24-18.35,20.31-18.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-556"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M34.07,17.76c10.96.16,19.72,8.49,19.57,18.61,0,.32-.02.63-.04.94v-.48H14.02v.82c-.06-.62-.08-1.24-.07-1.87.15-10.11,9.16-18.18,20.12-18.02Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-772"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M34.06,17.94c10.86.16,19.54,8.41,19.39,18.43,0,.31-.02.62-.04.93v-.47H14.21v.81c-.06-.61-.08-1.23-.07-1.86.14-10.01,9.07-18,19.92-17.84Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-585"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-253",
    d: "M34.06,18.11c10.75.16,19.35,8.33,19.21,18.26,0,.62-.05,1.23-.13,1.84v-1.37H14.4v.79c-.06-.61-.08-1.22-.07-1.84.14-9.93,8.98-17.84,19.73-17.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-818"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-224",
    d: "M34.06,18.28c10.65.16,19.17,8.25,19.02,18.08,0,.61-.05,1.22-.13,1.82v-1.35H14.58v.78c-.06-.6-.08-1.21-.07-1.82.14-9.83,8.9-17.67,19.55-17.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-578"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M34.05,18.45c10.55.16,18.98,8.17,18.84,17.91,0,.61-.05,1.21-.13,1.8v-1.33H14.76v.76c-.06-.59-.08-1.2-.07-1.8.15-9.73,8.82-17.49,19.36-17.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1033"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M34.05,18.62c10.44.15,18.8,8.09,18.65,17.73,0,.6-.05,1.2-.12,1.78v-1.3H14.95v.75c-.06-.59-.08-1.18-.07-1.79.15-9.63,8.73-17.32,19.17-17.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-548"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M34.05,18.8c10.34.15,18.61,8.01,18.47,17.56,0,.6-.05,1.19-.12,1.77v-1.28H15.14v.73c-.06-.58-.08-1.17-.07-1.77.14-9.55,8.64-17.17,18.98-17.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-646"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-26",
    d: "M34.05,18.97c10.24.15,18.43,7.93,18.29,17.38,0,.59-.05,1.17-.12,1.75v-1.26H15.33v.72c-.05-.58-.08-1.16-.07-1.75.14-9.46,8.55-16.99,18.79-16.84Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-606"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M34.05,19.11c10.15.15,18.27,7.87,18.13,17.23,0,.59-.05,1.16-.12,1.73v-1.25H15.48v.71c-.05-.57-.08-1.15-.07-1.74.14-9.35,8.48-16.83,18.64-16.68Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1031"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M34.04,19.26c10.07.15,18.12,7.8,17.98,17.09,0,.58-.05,1.15-.12,1.72v-1.23H15.64v.69c-.05-.57-.08-1.14-.07-1.72.13-9.29,8.41-16.7,18.47-16.55Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-564"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M34.04,19.4c9.98.15,17.96,7.73,17.83,16.94,0,.58-.05,1.14-.12,1.7v-1.21H15.79v.68c-.05-.56-.08-1.13-.07-1.71.14-9.2,8.34-16.55,18.32-16.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-816"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M34.04,19.54c9.89.15,17.81,7.67,17.67,16.8,0,.57-.05,1.13-.12,1.69v-1.2H15.95v.67c-.06-.55-.08-1.12-.07-1.69.13-9.13,8.26-16.41,18.16-16.27Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-784"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M34.04,19.69c9.81.14,17.65,7.6,17.52,16.65,0,.57-.05,1.12-.12,1.67v-1.18H16.1v.66c-.05-.55-.08-1.11-.07-1.68.14-9.05,8.2-16.27,18.01-16.12Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-949"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-238",
    d: "M34.03,19.83c9.72.14,17.5,7.53,17.37,16.51,0,.56-.05,1.11-.12,1.66v-1.16H16.26v.65c-.05-.55-.07-1.1-.07-1.66.13-8.99,8.12-16.14,17.84-16Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-756"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M34.03,19.97c9.64.14,17.34,7.47,17.21,16.36,0,.56-.05,1.1-.11,1.65v-1.15H16.41v.63c-.05-.54-.07-1.09-.07-1.64.14-8.89,8.06-15.99,17.69-15.85Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-463"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M34.03,20.12c9.55.14,17.19,7.4,17.06,16.21,0,.55-.05,1.09-.11,1.63v-1.13H16.57v.62c-.06-.53-.08-1.08-.07-1.63.13-8.81,7.98-15.84,17.53-15.7Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-979"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-243",
    d: "M34.03,20.26c9.47.14,17.03,7.33,16.91,16.07,0,.55-.05,1.08-.11,1.62v-1.11H16.72v.61c-.05-.53-.07-1.07-.06-1.62.12-8.74,7.9-15.71,17.37-15.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-928"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M34.03,20.4c9.38.14,16.88,7.27,16.75,15.92,0,.54-.05,1.08-.11,1.6v-1.09H16.88v.6c-.05-.53-.07-1.06-.06-1.6.12-8.66,7.83-15.56,17.21-15.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-375"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-236",
    d: "M34.02,20.55c9.29.14,16.73,7.2,16.6,15.78,0,.54-.05,1.07-.11,1.59v-1.08H17.03v.58c-.05-.52-.07-1.05-.06-1.59.12-8.58,7.76-15.42,17.05-15.28Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-739"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-245",
    d: "M34.02,20.69c9.21.14,16.57,7.13,16.45,15.63,0,.53-.04,1.06-.11,1.57v-1.06H17.18v.57c-.05-.52-.07-1.04-.06-1.57.13-8.5,7.69-15.28,16.9-15.14Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-791"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.02,20.83c9.12.13,16.42,7.07,16.29,15.49,0,.53-.04,1.05-.11,1.56v-1.04H17.34v.56c-.05-.51-.07-1.03-.06-1.56.12-8.43,7.62-15.14,16.74-15.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-404"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M34.02,20.98c9.04.13,16.26,7,16.14,15.34,0,.52-.04,1.04-.11,1.54v-1.03H17.49v.55c-.05-.51-.07-1.02-.06-1.54.13-8.34,7.55-15,16.59-14.86Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-963"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-283",
    d: "M34.02,21.12c8.95.13,16.11,6.93,15.99,15.19,0,.52-.04,1.03-.11,1.53v-1.01H17.65v.53c-.05-.5-.07-1.01-.06-1.53.12-8.25,7.47-14.84,16.43-14.71Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-957"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M34.01,21.26c8.86.13,15.95,6.87,15.83,15.05,0,.51-.04,1.02-.11,1.51v-.99h-31.93v.52c-.05-.5-.07-1-.06-1.52.12-8.17,7.41-14.7,16.27-14.57Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-552"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-172",
    d: "M34.01,21.41c8.78.13,15.8,6.8,15.68,14.9,0,.51-.04,1.01-.1,1.5v-.98h-31.63v.51c-.05-.49-.07-.99-.06-1.5.12-8.1,7.33-14.56,16.11-14.43Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-723"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-161",
    d: "M34.01,21.55c8.69.13,15.64,6.74,15.53,14.76,0,.5-.04,1-.1,1.48v-.96h-31.33v.5c-.05-.49-.07-.98-.06-1.49.12-8.02,7.27-14.42,15.96-14.29Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-914"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M34.01,21.69c8.61.13,15.49,6.67,15.37,14.61,0,.5-.04.99-.1,1.47v-.94h-31.01v.48c-.05-.48-.07-.98-.06-1.47.12-7.94,7.19-14.27,15.8-14.15Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-697"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-167",
    d: "M34,21.84c8.52.13,15.33,6.6,15.22,14.47,0,.49-.04.98-.1,1.45v-.92h-30.7v.47c-.05-.48-.07-.97-.06-1.46.12-7.87,7.12-14.14,15.64-14.01Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-563"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-267",
    d: "M34,21.98c8.44.12,15.18,6.54,15.07,14.32,0,.49-.04.97-.1,1.44v-.91h-30.39v.46c-.05-.47-.06-.96-.06-1.44.12-7.78,7.05-13.99,15.48-13.87Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-888"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M34,22.13c8.35.12,15.03,6.47,14.91,14.17,0,.48-.04.96-.1,1.43v-.89h-30.08v.45c-.04-.47-.06-.95-.06-1.43.12-7.71,6.98-13.86,15.33-13.73Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-611"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-229",
    d: "M34,22.27c8.26.12,14.87,6.4,14.76,14.03,0,.48-.04.95-.1,1.41v-.87h-29.77v.43c-.04-.46-.06-.94-.06-1.41.11-7.63,6.9-13.71,15.17-13.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-934"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-237",
    d: "M34,22.41c8.18.12,14.72,6.34,14.61,13.88,0,.47-.04.94-.1,1.4v-.86h-29.47v.42c-.04-.46-.06-.93-.06-1.4.12-7.54,6.84-13.56,15.02-13.44Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-471"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-215",
    d: "M33.99,22.56c8.09.12,14.56,6.27,14.45,13.74,0,.47-.04.93-.1,1.38v-.84h-29.14v.41c-.04-.46-.06-.92-.06-1.38.11-7.48,6.76-13.43,14.85-13.31Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-491"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-170",
    d: "M33.99,22.7c8.01.12,14.41,6.2,14.3,13.59,0,.46-.04.92-.1,1.37v-.82h-28.84v.4c-.04-.45-.06-.91-.05-1.37.11-7.4,6.69-13.29,14.69-13.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-886"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-205",
    d: "M33.99,22.84c7.92.12,14.25,6.14,14.15,13.45,0,.46-.04.91-.09,1.35v-.81h-28.54v.39c-.04-.45-.06-.9-.05-1.35.1-7.31,6.61-13.14,14.53-13.03Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-582"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M33.99,22.99c7.83.12,14.1,6.07,13.99,13.3,0,.45-.04.9-.09,1.34v-.79h-28.23v.37c-.04-.44-.06-.89-.05-1.34.11-7.23,6.54-13,14.38-12.88Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-441"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-219",
    d: "M33.99,23.13c7.75.11,13.94,6,13.84,13.15-.01.45-.04.89-.09,1.32v-.77h-27.92v.36c-.04-.44-.06-.88-.05-1.32.1-7.15,6.47-12.86,14.22-12.74Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-871"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-169",
    d: "M33.98,23.27c7.66.11,13.79,5.94,13.69,13.01-.01.44-.04.88-.09,1.31v-.76h-27.61v.35c-.04-.43-.06-.87-.05-1.31.1-7.07,6.4-12.71,14.06-12.6Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-340"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-280",
    d: "M33.98,23.42c7.58.11,13.64,5.87,13.53,12.86-.01.44-.04.87-.09,1.29v-.74h-27.29v.34c-.04-.43-.06-.86-.05-1.3.1-6.99,6.32-12.57,13.9-12.45Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-911"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-203",
    d: "M33.98,23.56c7.49.11,13.48,5.8,13.38,12.72-.01.43-.04.86-.09,1.28v-.72h-26.99v.32c-.04-.42-.06-.85-.05-1.28.1-6.92,6.26-12.43,13.75-12.32Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-523"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-336",
    d: "M33.98,23.7c7.4.11,13.33,5.74,13.23,12.57-.01.43-.04.85-.09,1.26v-.7h-26.68v.31c-.04-.42-.06-.84-.05-1.27.1-6.83,6.18-12.28,13.59-12.17Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-763"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M33.98,23.85c7.32.11,13.17,5.67,13.07,12.42-.01.42-.04.84-.09,1.25v-.69h-26.37v.3c-.04-.41-.06-.83-.05-1.25.1-6.75,6.12-12.14,13.44-12.03Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-519"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M33.97,23.99c7.23.11,13.02,5.6,12.92,12.28-.01.42-.04.83-.09,1.23v-.67h-26.05v.29c-.04-.41-.06-.82-.05-1.24.1-6.67,6.04-12,13.27-11.89Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-984"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-40",
    d: "M33.97,24.13c7.15.11,12.86,5.54,12.77,12.13-.01.41-.03.82-.08,1.22v-.65h-25.76v.27c-.04-.4-.05-.81-.05-1.22.1-6.59,5.97-11.85,13.12-11.75Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-962"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-302",
    d: "M33.97,24.28c7.06.1,12.71,5.47,12.61,11.99-.01.41-.03.81-.08,1.21v-.64h-25.44v.26c-.04-.4-.05-.8-.05-1.21.09-6.52,5.9-11.72,12.96-11.61Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-554"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M33.97,24.42c6.98.1,12.55,5.4,12.46,11.84-.01.4-.03.8-.08,1.19v-.62h-25.14v.25c-.04-.39-.05-.79-.05-1.19.1-6.44,5.83-11.57,12.81-11.47Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-562"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-201",
    d: "M33.96,24.56c6.89.1,12.4,5.34,12.31,11.7-.01.4-.03.79-.08,1.18v-.6h-24.65v1.38c-.16-.75-.23-1.53-.22-2.32.09-6.37,5.75-11.44,12.64-11.34Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-536"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-196",
    d: "M33.96,24.71c6.8.1,12.24,5.27,12.15,11.55-.01.39-.03.78-.08,1.16v-.59h-24.34v1.36c-.15-.74-.23-1.51-.22-2.29.1-6.28,5.69-11.29,12.49-11.19Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1007"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M33.96,24.85c6.72.1,12.09,5.21,12,11.4-.01.39-.03.77-.08,1.15v-.57h-24.04v1.33c-.15-.73-.23-1.49-.21-2.27.09-6.19,5.61-11.14,12.33-11.04Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-604"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-151",
    d: "M33.96,24.99c6.63.1,11.94,5.14,11.85,11.26-.01.38-.03.76-.08,1.13v-.55h-23.73v1.3c-.15-.72-.22-1.47-.21-2.24.09-6.11,5.54-10.99,12.17-10.9Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-936"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-188",
    d: "M33.96,25.14c6.55.1,11.78,5.07,11.69,11.11-.01.38-.03.75-.08,1.12v-.54h-23.42v1.28c-.15-.71-.22-1.45-.21-2.21.09-6.04,5.47-10.86,12.02-10.76Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-425"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M33.95,25.28c6.46.1,11.63,5.01,11.54,10.97-.01.37-.03.74-.08,1.1v-.52h-23.11v1.25c-.15-.71-.22-1.43-.21-2.18.09-5.96,5.4-10.71,11.86-10.62Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-595"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-160",
    d: "M33.95,25.42c6.37.09,11.47,4.94,11.39,10.82-.01.37-.03.73-.08,1.09v-.5h-22.8v1.22c-.14-.7-.21-1.41-.2-2.15.08-5.88,5.32-10.57,11.69-10.48Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-574"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-179",
    d: "M33.95,25.57c6.29.09,11.32,4.87,11.23,10.68-.01.36-.03.72-.07,1.07v-.48h-22.5v1.2c-.14-.69-.21-1.4-.2-2.12.08-5.82,5.25-10.44,11.54-10.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-894"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M33.95,25.71c6.2.09,11.16,4.81,11.08,10.53-.01.36-.03.71-.07,1.06v-.47h-22.2v1.17c-.14-.68-.21-1.38-.2-2.09.09-5.72,5.18-10.29,11.39-10.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-689"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-239",
    d: "M33.95,25.86c6.12.09,11.01,4.74,10.93,10.38-.01.35-.03.7-.07,1.04v-.45h-21.9v1.14c-.14-.67-.21-1.36-.19-2.06.08-5.64,5.11-10.15,11.23-10.05Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-939"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-291",
    d: "M33.94,26c6.03.09,10.85,4.67,10.77,10.24-.01.35-.03.69-.07,1.03v-.43h-21.57v1.12c-.14-.66-.2-1.34-.19-2.03.08-5.58,5.03-10.02,11.06-9.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-849"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-257",
    d: "M33.94,26.14c5.95.09,10.7,4.61,10.62,10.09-.01.34-.03.68-.07,1.01v-.42h-21.27v1.1c-.14-.65-.2-1.32-.19-2,.08-5.49,4.97-9.87,10.91-9.78Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-565"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M33.94,26.29c5.86.09,10.54,4.54,10.47,9.95-.01.68-.09,1.33-.24,1.97v-1.37h-20.8v1.06c-.13-.64-.2-1.3-.19-1.98.08-5.41,4.9-9.72,10.76-9.63Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-673"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-180",
    d: "M33.94,26.43c5.77.09,10.39,4.47,10.31,9.8-.01.67-.09,1.32-.24,1.94v-1.34h-20.49v1.04c-.13-.63-.19-1.28-.18-1.95.08-5.33,4.82-9.58,10.6-9.49Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-644"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M33.93,26.57c5.69.08,10.24,4.41,10.16,9.66-.01.66-.09,1.3-.24,1.91v-1.31h-20.17v1.01c-.13-.62-.19-1.26-.18-1.92.07-5.24,4.75-9.43,10.43-9.35Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1006"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M33.93,26.72c5.6.08,10.08,4.34,10.01,9.51-.01.65-.09,1.28-.23,1.88v-1.28h-19.88v.98c-.13-.61-.19-1.24-.18-1.89.08-5.16,4.68-9.29,10.28-9.2Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-717"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M33.93,26.86c5.52.08,9.93,4.27,9.85,9.36-.01.64-.09,1.26-.23,1.85v-1.24h-19.57v.96c-.12-.6-.18-1.22-.18-1.86.08-5.09,4.61-9.15,10.13-9.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-978"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M33.93,27c5.43.08,9.77,4.21,9.7,9.22-.01.63-.09,1.24-.23,1.83v-1.21h-19.26v.93c-.12-.59-.18-1.21-.17-1.83.07-5.02,4.53-9.02,9.96-8.94Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-468"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M33.93,27.15c5.34.08,9.62,4.14,9.54,9.07-.01.62-.09,1.22-.22,1.8v-1.18h-18.96v.9c-.12-.58-.18-1.19-.17-1.8.07-4.94,4.46-8.87,9.81-8.79Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-496"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-217",
    d: "M33.92,27.29c5.26.08,9.46,4.07,9.39,8.93-.01.61-.08,1.2-.22,1.77v-1.15h-18.65v.88c-.12-.57-.18-1.17-.17-1.77.07-4.87,4.4-8.74,9.65-8.66Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-896"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M33.92,27.43c5.17.08,9.31,4.01,9.24,8.78-.01.6-.08,1.18-.22,1.74v-1.12h-18.35v.85c-.12-.56-.17-1.15-.16-1.74.07-4.78,4.32-8.58,9.49-8.51Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-419"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M33.92,27.58c5.09.08,9.15,3.94,9.08,8.64-.01.59-.08,1.16-.21,1.71v-1.09h-18.04v.82c-.11-.56-.17-1.13-.16-1.72.06-4.69,4.24-8.44,9.33-8.36Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-883"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M33.92,27.72c5,.07,9,3.87,8.93,8.49-.01.58-.08,1.14-.21,1.68v-1.06h-17.74v.8c-.11-.55-.17-1.11-.16-1.69.07-4.61,4.18-8.29,9.18-8.22Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-528"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-195",
    d: "M33.92,27.86c4.92.07,8.85,3.81,8.78,8.34-.01.57-.08,1.12-.21,1.65v-1.03h-17.44v.77c-.11-.54-.16-1.09-.16-1.66.07-4.52,4.11-8.14,9.03-8.07Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-874"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-235",
    d: "M33.91,28.01c4.83.07,8.69,3.74,8.62,8.2-.01.56-.08,1.1-.2,1.62v-1h-17.13v.74c-.11-.53-.16-1.07-.15-1.63.07-4.45,4.03-8,8.86-7.93Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-828"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M33.91,28.15c4.74.07,8.54,3.68,8.47,8.05-.01.55-.08,1.08-.2,1.59v-.96h-16.82v.72c-.11-.52-.16-1.05-.15-1.6.06-4.38,3.96-7.87,8.7-7.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-384"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-299",
    d: "M33.91,28.29c4.66.07,8.38,3.61,8.32,7.91-.01.54-.07,1.06-.19,1.57v-.93h-16.53v.69c-.1-.51-.16-1.03-.15-1.57.06-4.31,3.89-7.73,8.55-7.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-965"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-301",
    d: "M33.91,28.44c4.57.07,8.23,3.54,8.16,7.76-.01.53-.07,1.04-.19,1.54v-.9h-16.22v.66c-.1-.5-.15-1.01-.15-1.54.07-4.22,3.83-7.59,8.4-7.52Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-821"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-270",
    d: "M33.91,28.58c4.49.07,8.07,3.48,8.01,7.61-.01.52-.07,1.02-.19,1.51v-.87h-15.91v.64c-.1-.49-.15-1-.14-1.51.05-4.14,3.74-7.45,8.23-7.38Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-848"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-246",
    d: "M33.9,28.72c4.4.06,7.92,3.41,7.86,7.47-.01.51-.07,1-.18,1.48v-.84h-15.61v.61c-.1-.48-.15-.98-.14-1.48.06-4.06,3.67-7.3,8.07-7.24Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-367"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-298",
    d: "M33.9,28.87c4.31.06,7.76,3.34,7.7,7.32-.01.5-.07.98-.18,1.45v-.81h-15.3v.58c-.1-.47-.14-.96-.14-1.46.06-3.97,3.61-7.15,7.92-7.08Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-950"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-276",
    d: "M33.9,29.01c4.23.06,7.61,3.28,7.55,7.18-.01.49-.07.96-.18,1.42v-.78h-15v.56c-.1-.46-.14-.94-.13-1.43.06-3.9,3.53-7.01,7.76-6.95Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-940"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-275",
    d: "M33.9,29.15c4.14.06,7.45,3.21,7.4,7.03-.01.48-.07.94-.17,1.39v-.75h-14.7v.53c-.09-.45-.14-.92-.13-1.4.05-3.81,3.45-6.86,7.6-6.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-713"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M33.89,29.3c4.06.06,7.3,3.14,7.24,6.89-.01.47-.07.92-.17,1.36v-.71h-14.38v.5c-.09-.44-.14-.9-.13-1.37.06-3.75,3.39-6.73,7.44-6.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-691"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-314",
    d: "M33.89,29.44c3.97.06,7.15,3.08,7.09,6.74-.01.46-.06.9-.17,1.33v-.68h-14.08v.48c-.09-.43-.13-.88-.13-1.34.06-3.66,3.32-6.59,7.29-6.53Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-366"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-55",
    d: "M33.89,29.59c3.88.06,6.99,3.01,6.94,6.59-.01.45-.06.88-.16,1.31v-.65h-13.79v.45c-.09-.42-.13-.86-.12-1.31.05-3.59,3.25-6.45,7.13-6.39Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-570"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M33.89,29.73c3.8.06,6.84,2.94,6.78,6.45-.01.44-.06.87-.16,1.28v-.62h-13.47v.42c-.09-.41-.13-.84-.12-1.28.05-3.51,3.17-6.31,6.97-6.25Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-677"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-166",
    d: "M33.89,29.87c3.71.05,6.68,2.88,6.63,6.3-.01.43-.06.85-.16,1.25v-.59h-13.17v.4c-.08-.41-.12-.82-.12-1.25.05-3.43,3.1-6.16,6.82-6.11Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-806"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M33.88,30.02c3.63.05,6.53,2.81,6.48,6.16-.01.42-.06.83-.15,1.22v-.56h-12.87v.37c-.08-.4-.12-.8-.12-1.22.06-3.36,3.04-6.03,6.66-5.97Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-900"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M33.88,30.16c3.54.05,6.37,2.74,6.32,6.01-.01.41-.06.81-.15,1.19v-.53h-12.55v.34c-.08-.39-.12-.79-.11-1.19.04-3.27,2.95-5.87,6.49-5.82Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-770"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-233",
    d: "M33.88,30.3c3.46.05,6.22,2.68,6.17,5.87-.01.4-.06.79-.14,1.16v-.5h-12.26v.32c-.08-.38-.12-.77-.11-1.17.05-3.19,2.88-5.73,6.34-5.68Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-884"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-338",
    x: 19.01,
    y: 23.36,
    width: 30.02,
    height: 0.75
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-402"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-338",
    x: 19.01,
    y: 24.1,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-952"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-99",
    x: 19.01,
    y: 24.13,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-946"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-107",
    x: 19.01,
    y: 24.15,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-944"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-323",
    x: 19.01,
    y: 24.18,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-823"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-41",
    x: 19.01,
    y: 24.2,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-686"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-52",
    x: 19.01,
    y: 24.22,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-933"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-184",
    x: 19.01,
    y: 24.25,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-622"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-266",
    x: 19.01,
    y: 24.27,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-817"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-150",
    x: 19.01,
    y: 24.29,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-836"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-39",
    x: 19.01,
    y: 24.32,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1000"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-337",
    x: 19.01,
    y: 24.34,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-720"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-111",
    x: 19.01,
    y: 24.36,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-920"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-326",
    x: 19.01,
    y: 24.39,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-740"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-38",
    x: 19.01,
    y: 24.41,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-773"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-123",
    x: 19.01,
    y: 24.43,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-451"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-222",
    x: 19.01,
    y: 24.46,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-602"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 19.01,
    y: 24.48,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-466"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-221",
    x: 19.01,
    y: 24.51,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-442"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 19.01,
    y: 24.53,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-527"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-194",
    x: 19.01,
    y: 24.55,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-964"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-185",
    x: 19.01,
    y: 24.58,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-837"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-274",
    x: 19.01,
    y: 24.6,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-947"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-197",
    x: 19.01,
    y: 24.62,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-882"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-95",
    x: 19.01,
    y: 24.65,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-684"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 19.01,
    y: 24.67,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-636"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-152",
    x: 19.01,
    y: 24.69,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-657"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 19.01,
    y: 24.72,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-991"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-199",
    x: 19.01,
    y: 24.74,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-985"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-118",
    x: 19.01,
    y: 24.76,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-663"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-213",
    x: 19.01,
    y: 24.79,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-869"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-226",
    x: 19.01,
    y: 24.81,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-678"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-282",
    x: 19.01,
    y: 24.84,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-635"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 19.01,
    y: 24.86,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1027"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-19",
    x: 19.01,
    y: 24.88,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-653"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 19.01,
    y: 24.91,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-525"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-315",
    x: 19.01,
    y: 24.93,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-444"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 19.01,
    y: 24.95,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-680"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-269",
    x: 19.01,
    y: 24.98,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-994"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-35",
    x: 19.01,
    y: 25,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-485"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-289",
    x: 19.01,
    y: 25.02,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-935"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-60",
    x: 19.01,
    y: 25.05,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-514"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 19.01,
    y: 25.07,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-517"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-31",
    x: 19.01,
    y: 25.1,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-945"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 19.01,
    y: 25.12,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1042"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-148",
    x: 19.01,
    y: 25.14,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-899"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-290",
    x: 19.01,
    y: 25.17,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-342"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-102",
    x: 19.01,
    y: 25.19,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-524"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 19.01,
    y: 25.21,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-762"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-85",
    x: 19.01,
    y: 25.24,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-937"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-288",
    x: 19.01,
    y: 25.26,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-372"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 19.01,
    y: 25.28,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1029"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-101",
    x: 19.01,
    y: 25.31,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-446"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-273",
    x: 19.01,
    y: 25.33,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-664"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-198",
    x: 19.01,
    y: 25.35,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-865"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-202",
    x: 19.01,
    y: 25.38,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-822"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-294",
    x: 19.01,
    y: 25.4,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-798"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-252",
    x: 19.01,
    y: 25.43,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-961"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-311",
    x: 19.01,
    y: 25.45,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1032"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-141",
    x: 19.01,
    y: 25.47,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-610"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 19.01,
    y: 25.5,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1044"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 19.01,
    y: 25.52,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1043"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-318",
    x: 19.01,
    y: 25.54,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-377"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 19.01,
    y: 25.57,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-625"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 19.01,
    y: 25.59,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-626"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-176",
    x: 19.01,
    y: 25.61,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-690"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-164",
    x: 19.01,
    y: 25.64,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-735"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-171",
    x: 19.01,
    y: 25.66,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-612"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-159",
    x: 19.01,
    y: 25.68,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-667"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-227",
    x: 19.01,
    y: 25.71,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-676"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 19.01,
    y: 25.73,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1037"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-200",
    x: 19.01,
    y: 25.76,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-436"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 19.01,
    y: 25.78,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-385"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-113",
    x: 19.01,
    y: 25.8,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-430"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-329",
    x: 19.01,
    y: 25.83,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-948"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-115",
    x: 19.01,
    y: 25.85,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-360"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-175",
    x: 19.01,
    y: 25.87,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1013"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-297",
    x: 19.01,
    y: 25.9,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-851"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-322",
    x: 19.01,
    y: 25.92,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-645"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-57",
    x: 19.01,
    y: 25.94,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-623"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 19.01,
    y: 25.97,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-637"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 19.01,
    y: 25.99,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-659"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 19.01,
    y: 26.01,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-761"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 19.01,
    y: 26.04,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-905"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-250",
    x: 19.01,
    y: 26.06,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-567"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 19.01,
    y: 26.09,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-799"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-206",
    x: 19.01,
    y: 26.11,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-875"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-145",
    x: 19.01,
    y: 26.13,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-779"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-64",
    x: 19.01,
    y: 26.16,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-540"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-303",
    x: 19.01,
    y: 26.18,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-560"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-218",
    x: 19.01,
    y: 26.2,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-755"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-263",
    x: 19.01,
    y: 26.23,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-615"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-309",
    x: 19.01,
    y: 26.25,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-751"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-306",
    x: 19.01,
    y: 26.27,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-859"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-78",
    x: 19.01,
    y: 26.3,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-424"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-324",
    x: 19.01,
    y: 26.32,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-815"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-254",
    x: 19.01,
    y: 26.35,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-534"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-313",
    x: 19.01,
    y: 26.37,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-609"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-128",
    x: 19.01,
    y: 26.39,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-529"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-260",
    x: 19.01,
    y: 26.42,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-975"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-312",
    x: 19.01,
    y: 26.44,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-919"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-242",
    x: 19.01,
    y: 26.46,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-355"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 19.01,
    y: 26.49,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-440"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-132",
    x: 19.01,
    y: 26.51,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-639"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-211",
    x: 19.01,
    y: 26.53,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-532"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-29",
    x: 19.01,
    y: 26.56,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-494"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-189",
    x: 19.01,
    y: 26.58,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-408"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 19.01,
    y: 26.6,
    width: 30.02,
    height: 0.02
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-608"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-76",
    x: 19.01,
    y: 26.63,
    width: 30.02,
    height: 0.48
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M43.58,26.39c-1.03.12-2.1-.12-3.14.08-.93.18-1.79.51-2.78.54-.87.02-1.68-.21-2.49-.38-.86-.17-1.47-.14-2.33-.08-1.4.09-2.82.14-4.23.15-1.28.01-2.58-.03-3.77-.32-.69-.17-1.36-.42-2.1-.41-.87.02-1.57.39-2.36.57-.26.06-1.09.06-1.25.19-.12.1.18.32.18.44l1.37,2.47,1.43,1.82,1.36,1.41,1.57,1.11,2.12,1.19,1.72.68,2.58.61,2.36.17,2.41-.18,1.96-.43,1.94-.7,1.78-.92,1.91-1.34,1.58-1.48.93-1.09.84-1.2.77-1.37.65-1.48.12-.33c0-.3.08.02.1-.28,0-.05.13-.08.08-.11s-.14-.03-.21-.03c-.54.03-1.08.07-1.63.1-.58.04-1.17.07-1.73.18-.46.09-.88.23-1.33.33-.14.05-.28.07-.41.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-212",
    d: "M46.87,16.5c-.06.03-.21.02-.27.01h-.01c.11-.05.21-.15.19-.29,0-.02-.02,0-.02.01,0,.16-.15.22-.3.23.06-.03.11-.07.15-.12.01-.01,0-.03-.01-.02-.02.02-.09.05-.16.07.02-.01.04-.03.06-.05.01-.01,0-.02-.01-.01-.04.04-.18.01-.22,0-.01,0-.02-.01-.04-.01.08-.02.15-.06.19-.13.01-.02-.01-.02-.02-.01-.08.09-.2.09-.32.06.07,0,.15-.01.21-.05.01,0,.02-.02.01-.02,0-.01-.01-.01-.01-.01,0,0-.01,0-.01.01-.09.01-.17-.01-.25-.03.05-.01.1-.04.08-.08,0-.01-.01,0-.01.01,0,.02-.07.03-.13.02,0-.01-.01-.02-.01-.03.11-.04.22-.09.3-.17,0,.05-.02.09-.04.14-.01,0-.02.02-.02.03h0s.02.01.03,0c.05-.06.08-.15.09-.22,0-.01,0-.02.01-.03.01-.01.02-.02.02-.04.01.07.01.15-.02.19-.01,0-.01.01-.01.02h0s.01.02.02.02c.06-.03.08-.17.08-.23.01-.07-.02-.15-.05-.22-.01-.02-.01-.03-.02-.04h-.01s0-.02-.01-.02h0c-.07-.11-.19-.19-.29-.25-.39-.24-.87-.36-1.3-.47-.25-.06-.5-.1-.75-.13.19-.03.39-.02.58.01.01,0,.03-.02.02-.03-.14-.08-.36-.12-.56-.09.05-.04.09-.08.09-.12,0-.02-.02-.01-.02,0-.02.05-.08.08-.15.11.05-.05.08-.12.09-.19,0-.02-.02,0-.02.01-.01.04-.03.08-.05.11v-.03c-.01-.16-.44-.16-.54-.17h0s.07-.03.11-.05c.01-.01.02-.03,0-.03-.03.01-.06,0-.09.01-.02,0-.03.01-.04.01h0s.01-.08,0-.12l.06.03s.04.03.05.03h0s.03-.03.02-.04l-.02-.02s-.04-.03-.06-.04c-.03-.02-.06-.04-.09-.05-.01,0-.01-.01-.02-.01h-.01s.05,0,.07.01c.05.02.11.04.15.07.04.02.06.07.09.1.01.01.04-.02.03-.03-.03-.04-.05-.08-.08-.12-.04-.04-.11-.07-.15-.09-.07-.03-.13-.06-.19-.05-.04-.04-.07-.08-.1-.1h0c-.03-.15-.13-.3-.24-.36-.01-.01-.03.02-.02.03.05.05.1.11.14.19-.02-.04-.05-.07-.09-.1-.01-.01-.02.01-.02.02.03.03.05.07.07.1-.03-.02-.06-.04-.1-.06-.02-.03-.04-.05-.05-.07-.11-.16-.28-.25-.46-.25-.01,0-.02.02-.01.02.14.02.27.09.36.21-.09-.06-.21-.1-.3-.17-.01-.01-.03.01-.02.02.02.02.04.03.05.05-.52-.18-1.06-.24-1.6-.27-.05,0-.1-.01-.16-.01.02,0,.04-.01.05-.02,0,0,.01-.02,0-.02-.04.01-.09-.01-.14-.02.11-.02.22-.02.32-.03.01,0,.03-.03.01-.03-.17-.04-.35-.04-.52,0-.04.01-.08.02-.12.03.12-.1.3-.15.43-.17.01,0,.03-.03.01-.03-.18.01-.35.06-.48.17.05-.08.12-.16.2-.2.01-.01.02-.04,0-.03-.08.03-.14.08-.19.14.03-.06.05-.11.07-.17.01-.02-.01-.01-.02,0-.03.05-.06.1-.09.15,0-.04-.01-.08-.01-.11-.01-.04-.02-.09-.05-.12-.02-.02-.06-.04-.07-.06-.01-.01-.02.01-.02.02t.03.03s.05.11.06.17v.08c-.02-.1-.07-.2-.14-.28-.01-.01-.03.01-.02.02.03.06.07.15.09.23-.01-.01-.02-.02-.03-.03-.01-.02-.02-.03-.02-.05-.02-.05-.06-.1-.1-.14-.01-.01-.02.01-.02.02.02.03.03.05.05.08-.15-.12-.37-.21-.49-.25-.02-.03-.04-.05-.06-.07-.09-.11-.22-.14-.33-.2-.01,0-.02.02-.02.02.08.06.17.1.24.17.01.01.03.03.04.04h-.01s-.04-.04-.06-.06c-.09-.06-.17-.1-.27-.14-.01,0-.02.02-.01.02.06.04.13.08.18.13-.25-.07-.51-.14-.77-.17-.05-.01-.11-.01-.17-.02.09-.03.19-.04.28-.07.01,0,.03-.03.01-.03-.06.01-.13.01-.19.01.07-.03.13-.05.2-.08.01,0,.02-.03,0-.03-.13.03-.26.05-.38.12,0,0-.01.01-.02.01.03-.06.04-.12.06-.19.01-.03-.02-.01-.03,0-.03.06-.04.13-.08.18.02-.07.02-.14.02-.21,0-.02-.03,0-.03.01,0,.03-.01.06-.01.09-.02-.04-.08-.07-.13-.09-.03-.01-.07-.02-.1-.03.13-.06.26-.15.3-.19.01-.01.01-.03-.01-.02-.04.03-.14.09-.24.13h.01c.08-.05.12-.13.15-.22.01-.02-.01-.01-.02,0-.04.06-.08.12-.14.16,0,0-.01,0-.01.01.01-.02.02-.04.03-.06.02-.05.08-.21.02-.25-.01-.01-.02.01-.02.02.02.04,0,.1-.02.15,0-.11-.04-.23-.15-.33-.46-.38-1.23-.39-1.82-.43-.09-.01-.18-.01-.27-.01-.41-.03-.83-.04-1.25-.04,0,0,0-.01-.01-.01-.03-.01-.06-.01-.1-.01-.06-.03-.11-.06-.14-.13-.01-.01-.03.01-.02.02.01.04.03.07.06.1-.09,0-.17-.01-.23-.08-.01-.01-.03.01-.02.02.02.03.05.05.08.07-.02,0-.04-.01-.06-.01-.06-.01-.15-.01-.18-.08,0-.01-.02.01-.02.01.01.04.04.07.08.1-.33.03-.69.07-.98.2-.01,0-.03.01-.04.01h-.02c-.07.02-.22.05-.26-.01-.01-.01-.02.01-.02.02.02.05.07.07.13.07-.05.02-.1.02-.14,0-.01,0-.03.02-.01.02.02.01.05.02.08.02-.09.05-.17.11-.2.21-.1-.01-.2-.06-.22-.17,0-.02-.02,0-.02.01,0,.08.05.14.11.19-.06-.01-.12-.03-.14-.08-.01-.01-.02.01-.02.02.02.05.05.08.09.1-.03,0-.05-.01-.08-.01-.01,0-.03.02-.02.03.02.01.04.02.06.02-.19.03-.38.08-.57.15-.21.07-.52.16-.68.32-.05.05-.11.1-.16.14h-.04s-.09-.03-.08-.07t-.01,0s.01-.04.01-.06c.01-.02-.02-.01-.02,0-.03.07-.05.14-.04.22-.03-.01-.07-.03-.1-.04-.07-.03-.1-.08-.15-.13-.02-.02-.04.02-.05.03-.02.04.01.09.03.13-.08-.05-.17-.08-.26-.07-.03,0-.08.06-.05.09.04.03.09.04.13.07h.01c-.41.03-.82.07-1.22.13-.01,0-.02-.01-.03-.01-.07-.05-.05-.16-.03-.23,0-.02-.02,0-.02,0-.03.06-.05.14-.04.2-.06-.03-.1-.07-.15-.13-.02-.02-.06.03-.06.05s.01.03.02.05c-.05-.02-.1-.05-.15-.08-.02-.02-.06.02-.06.05.01.04.03.06.05.09-.06,0-.12,0-.17-.03-.01,0-.03.02-.02.03.05.04.11.07.18.08h-.02c-.32.05-.7.08-1.05.17-.12-.01-.25.02-.36.05-.04.01-.31.09-.28.16,0-.01-.02,0-.02.01h0s.01.03.02.02c.05-.04.1-.06.15-.08-.1.05-.27.16-.24.27.01.02.03,0,.03-.02.01-.05.07-.1.14-.14-.05.06-.09.14-.08.21-.19.05-.38.1-.57.17-.31.11-.63.24-.87.49-.02.02-.03.03-.04.05-.01,0-.02-.01-.03-.01-.05-.01-.13-.04-.14-.1,0-.02-.02,0-.02.01-.01.06.02.12.08.15-.02,0-.04,0-.07-.01-.02,0-.03-.01-.05-.01-.01-.01-.02-.01-.03-.01-.07,0-.1-.01-.11-.04,0-.01-.02.01-.02.02s.01.03.01.04h-.01c-.06-.02-.08-.06-.13-.09-.01-.01-.02.01-.02.02.01.03.03.06.05.09h0c-.07-.01-.18-.04-.22-.11,0-.01-.01.01-.01.01,0,.06.06.11.11.15-.38.04-.77.13-1.13.23-.18.05-.35.1-.51.17-.04.01-.08.01-.13,0-.06-.01-.16-.05-.16-.13,0-.02-.02,0-.02.01-.01.06.01.11.05.15-.05-.01-.1-.02-.13-.07-.01-.01-.02.01-.02.02.03.07.1.1.18.11-.01,0-.02.01-.03.02h-.01s-.04.02-.06.03c-.05.02-.1.05-.15.07h-.02s-.06.03-.09.04c-.06.02-.12.02-.19-.01-.01-.01-.04.02-.02.03.02.01.04.02.06.03-.08.02-.16.03-.24-.01-.01-.01-.03.02-.02.02.04.04.1.06.16.06-.13.07-.28.17-.28.28h0s-.01-.01-.02-.01c-.07-.04-.12-.1-.15-.16-.01-.01-.02.01-.02.02.02.07.05.14.1.2h-.05c-.05-.01-.14-.04-.16-.1,0-.01-.02.01-.02.01-.02.06.05.11.1.14v.02s.05.05.08.06c-.01,0-.03.01-.04.01-.03,0-.04-.01-.06-.02-.02,0-.04.03-.03.04.02.03.02.05.05.06.01.01.03.01.04.01-.05.04-.1.07-.16.07-.02,0-.06.05-.03.06.05.02.1.01.15-.01-.05.05-.1.1-.15.09-.02,0-.07.04-.04.06s.07.03.11.02c-.1.08-.22.14-.31.06-.02-.02-.05.02-.04.04.03.06.08.1.14.1-.02.02-.05.03-.07.05-.06.04-.13.1-.17.17-.01.01-.01.03,0,.03h0s.02,0,.03,0c.04-.03.08-.05.12-.08-.02,0-.03.02-.04.02-.04.04-.07.08-.11.13-.03.04-.06.11-.1.14-.01.01-.03.05-.02.06-.03.03-.06.06-.08.09h-.01s-.02.05-.03.06c-.1.12-.2.32-.16.48.01.05.07,0,.07-.03.01-.12.09-.23.17-.32-.01.02-.02.05-.03.07-.07.16-.17.37-.1.55,0,.01.02.02.03.02h.02c-.04.06-.03.13,0,.2.02.04.08-.02.07-.05-.01-.09.03-.16.08-.23h.01c-.03.06-.06.14-.03.18h0s.05-.02.06-.04c.02-.05.05-.1.09-.15,0,.01-.01.01-.01.02-.02.04-.11.23,0,.22.02,0,.06-.04.04-.06-.01-.02.03-.08.07-.12,0,.07.06.23.15.18.01-.01.05-.06.02-.07-.01,0-.01-.05-.01-.09.04.01.09.02.15.03.21.01.42-.01.62-.05-.06.05-.12.09-.18.14-.02.02-.03.08.01.05.12-.06.22-.14.35-.18.02-.01.05-.01.07-.02-.03.05-.05.09-.06.14h0c0,.05.03.06.06.03.07-.07.13-.13.21-.18,0,0,.01,0,.01-.01h0s-.01.04,0,.05c.04.04.16-.06.2-.08.04-.03.07-.06.11-.09h0c-.07.07-.11.15-.15.25v.02h0s.03,0,.04-.01c.05-.05.1-.09.15-.13,0,.01.01.02.02.02.15.04.33-.09.46-.15.05-.02.09-.05.14-.07-.04.08-.07.16-.05.24.01.05.07-.01.07-.03.01-.09.09-.17.16-.23-.03.05-.06.11-.07.17,0,.02,0,.03.02.04.05.03.11.03.18.02h0c.01.05.02.08.04.12h0c.01.05.03.08.04.11h0c.07.17.17.3.32.39.14.08.26.1.42.13.06.01.17.02.25.04.11.22.26.41.48.58.55.42,1.39.17,2.02.19.41.02.82.08,1.22.12.16.02.32.03.47.04h.01c.07,0,.14.01.21.01.03,0,.06,0,.09.01.03,0,.05,0,.08.01.03,0,.07,0,.1.01.02,0,.04,0,.07.01.06,0,.11.01.17.02.38.04.76.11,1.12.26.38.16.73.41,1.07.65.28.2.58.4.84.63.14.13.26.28.35.45s.05.4.04.59c-.01.36.02.69.14,1.03.1.28.26.55.24.82-.05.14-.1.26-.16.4-.2.26-.44.48-.61.77s-.27.64-.32.98c-.02.13-.03.27-.08.39-.05.19-.13.36-.28.5l-.03.03h0l-.05.05h0l-.05.05h0s-.03.04-.04.05h0s-.03.04-.04.06h0s-.03.04-.04.06h0s-.03.04-.04.06l-.38.74s-.02.04-.04.06c0,0,0,.01-.01.01l-.03.06s0,.01-.01.01c-.01.02-.02.04-.03.05,0,.01-.01.01-.01.02-.01.02-.02.03-.03.05,0,.01-.01.01-.01.02-.01.02-.02.03-.02.05,0,.01-.01.02-.01.02-.01.01-.01.03-.02.04,0,.01-.01.02-.01.03-.01.01-.01.03-.02.04,0,.01-.01.02-.01.03s-.01.02-.01.03c-.01.01-.01.03-.02.04,0,.01-.01.02-.01.03-.01.02-.02.05-.02.07h.46c.09,0,.23,0,.4.01h.07c.14,0,.29.01.46.01h.22c.06,0,.11,0,.17-.01h.01c.06,0,.12-.01.18-.01h.04c.06,0,.12-.01.18-.02.14-.01.54-2.56.63-2.76.01-.03.02-.05.04-.08.02-.04.04-.08.06-.11.07-.11.14-.22.23-.33.42-.53.67-1.05.59-1.76-.04-.44-.08-.82-.02-1.26.04-.32.15-.66.43-.82.38-.22.88-.27,1.3-.37.16-.04.32-.08.48-.12.64-.15,1.29-.3,1.91-.54.06-.02.12-.05.17-.07.02-.01.05-.02.07-.03s.04-.02.06-.03c.02-.01.04-.02.06-.03.02-.01.04-.02.06-.03.02-.01.04-.02.06-.03.02-.01.04-.02.05-.03.02-.01.04-.02.06-.04.02-.01.04-.02.05-.04.02-.01.04-.02.06-.04.02-.01.04-.02.05-.04.02-.01.04-.03.06-.04.02-.01.03-.03.05-.04.02-.01.04-.03.05-.04.02-.01.03-.03.05-.04.02-.01.04-.03.05-.04.02-.01.03-.03.05-.04.02-.02.04-.03.05-.05.02-.01.03-.03.05-.04.02-.02.04-.03.05-.05.02-.01.03-.03.05-.04.02-.02.04-.03.06-.05l.04-.04s.04-.04.06-.05l.04-.04s.04-.04.06-.06c.01-.01.02-.02.04-.04.02-.02.04-.04.07-.07.01-.01.02-.02.03-.03.03-.03.06-.06.09-.09.04-.04.08-.09.12-.13.01-.01.02-.02.03-.03.18-.21.35-.43.5-.66.05-.09.09-.18.14-.28.13-.08.26-.13.42-.18.02-.01.05-.03.07-.06h.01c.27.01.54.03.81,0,.06,0,.12,0,.18-.01h.04s.04-.01.06-.01h.01s.03-.01.05-.01h.02s.04-.01.06-.02h0s.03-.02.05-.02c0,0,.01,0,.01-.01.02-.01.04-.02.05-.03.04-.03.08-.06.11-.09h.01s.08.01.14-.01h.1s-.03.09-.04.13c-.01.05.06.01.07-.01.02-.04.04-.08.07-.12h.02c0,.05,0,.1.02.15.02.04.07-.02.08-.05l.03-.12h0c.04.09.1.18.19.23.03.02.08-.03.09-.06.06.05.13.09.21.11.06.01.12-.06.12-.12.05.04.1.06.16.08.02.01.04-.01.05-.02h0s.02-.03.01-.05c0-.01-.01-.01-.01-.02.11.03.26.03.36,0,0,0,.01,0,.01-.01.05.03.09.07.12.12.02.03.06-.02.06-.04v-.07s.09.06.14.08h0s.05-.03.05-.05h0c.07.03.15.08.19.14.02.03.08-.04.07-.07-.02-.04-.04-.08-.07-.11.02,0,.05-.01.07-.01.01.03.03.06.05.09.02.03.05.06.08.09s.07.03.1.03c.02,0,.05-.03.04-.05.06.03.11.04.17.02,0,.04-.01.08-.03.11-.01.02.01.02.02.01.03-.04.05-.1.07-.15.02-.01.03-.02.04-.03.01.03.01.05.01.07,0,.04.05,0,.06-.01.05-.07.05-.16.05-.24v-.07h0s.03.06.04.09c.01.05.07-.01.07-.04,0-.04-.01-.07-.02-.11.02.02.04.04.06.06.02.02.03.05.04.08h0s.02,0,.02-.01c0-.04.01-.07-.01-.11-.02-.03-.04-.06-.06-.09l-.02-.02s.07.01.09.02c.04.01.11-.08.06-.1-.05-.02-.11-.05-.16-.08.03-.01.06-.02.08-.03.02-.01.06-.08.01-.08s-.1-.01-.15-.02c.08-.01.18-.02.24-.07,0-.09,0-.12-.02-.11ZM41.58,16.88c-.04-.12-.11-.22-.21-.29h0s-.03-.02-.04-.03h-.01s-.03-.02-.05-.03h0s-.03-.01-.04-.02h0s.01-.01.01-.02.01-.02.01-.03c0,0,0-.01.01-.01,0,.01,0,.02.01.03.11.06.24.01.35-.04.01,0,.02-.01.03-.02h0s-.06.09,0,.07c.11-.03.19-.11.26-.2-.01.03-.02.07-.02.1-.01,0-.01.01-.02.01h-.01s-.01.02-.02.03h-.01c-.04.05-.08.1-.11.14-.06.07-.08.17-.11.27h0s-.01.02-.01.03-.01.01-.01.02h0ZM31.73,18.93c-.08-.04-.17-.08-.23-.16-.02-.02-.03-.05-.04-.07-.02-.04-.03-.09-.04-.13,0-.01-.01-.03-.01-.04-.01-.04-.03-.08-.05-.12-.05-.06-.09-.12-.12-.19-.02-.04-.04-.07-.07-.1l-.08-.08s-.05-.04-.08-.06c-.06-.03-.1-.06-.14-.11-.07-.1-.06-.27-.03-.38.04-.13.23-.16.28-.3.01-.02.01-.03.02-.05h0s.01-.04.01-.06h0s0-.04.01-.05h0v-.05h0s-.01-.07-.02-.1h0s-.02-.06-.03-.08h0s-.03-.06-.05-.09c0-.03,0-.06-.01-.09-.04-.13-.13-.22-.21-.31-.02-.02-.04-.04-.06-.07-.03-.03-.05-.06-.08-.09.01-.01.03-.03.03-.04v-.02s.02.06.03.08c.01.02.04,0,.05-.01.02-.02.03-.06.04-.1.06.02.12.02.18.01h0v.02s-.02.01-.03.01c-.03,0-.09.07-.04.09.03.01.06.01.09,0,0,.01.01.02.02.03,0,0,0,.01.01.01,0,.01.01.02.01.02h.01s.01.02.01.03h.01s.01.02.01.03h.01s.01.02.01.02h.01s.01.02.02.02c0,0,.01,0,.01.01.01,0,.01.01.02.01,0,0,.01,0,.01.01.01,0,.01.01.02.01h0c.07.03.15.06.24.12.14.1.06.35.18.49.02.03.04.06.06.09.01.04.02.07.04.11.18.54.61.94.47,1.56-.02.1-.03.19-.03.28h0v.15h0c-.14-.07-.3-.17-.47-.26ZM30.89,18.59c-.05-.01-.1-.03-.15-.04-.01,0-.02-.01-.03-.01s-.01,0-.02-.01c-.02-.01-.04-.01-.06-.01-.13-.02-.26-.04-.39-.06-.26-.03-.52-.04-.79-.05-.14-.01-.28-.01-.43-.02-.28-.02-.55-.05-.83-.07-.13-.01-.28.02-.39-.07-.11-.1-.1-.28-.24-.37-.09-.05-.19-.07-.29-.1-.18-.05-.45-.14-.34-.39.06-.13.08-.26.09-.38h0v-.11s0-.04-.01-.06v-.03h0c.08-.01.17-.05.25-.08.01,0,.02-.01.03-.01-.01.01-.01.02-.02.03-.01.02-.02.06.01.07.07.02.14,0,.22-.03-.01.02-.02.03-.04.05-.02.03-.01.07.03.04s.07-.06.1-.09c.01.02.02.04.02.06,0,.01.01.01.01.02.01.02.02.04.03.06h0s.03.06.04.09h0c.11.2.26.35.52.39.09.01.16.02.23.01h.02s.02,0,.03-.01c.01,0,.02-.01.04-.01.01,0,.02-.01.03-.01s.02-.01.03-.01.01-.01.02-.01c.02-.01.03-.02.05-.03h.01s.04-.03.06-.05c.15-.1.31-.16.47-.22.08-.01.15-.02.22-.02.05,0,.09-.01.14-.01h.05s.07,0,.1-.01h.36c.22.01.59.05.48.37-.06.2-.07.42,0,.62.02.05.04.1.07.14,0,0,0,.01.01.01.02.04.05.07.08.11h.01s.03.04.04.06c.02.03.06.06.09.09.04.05.09.11.13.16,0,.01.01.03.01.04-.02-.03-.06-.04-.1-.04h0ZM25.63,18.03c-.18-.14-.3-.33-.41-.53-.04-.08-.08-.16-.12-.23-.03-.05-.05-.1-.08-.15h0s.05-.06.05-.08c0-.05.02-.11.05-.15,0,.02.01.03.02.05.01.03.04.04.06.06.01.01.02.01.03,0h0s.06-.05.05-.08h0s-.01-.03-.01-.05v-.08s.09-.02.13-.04c-.01.02-.02.04-.03.07-.01.05.04.03.05.01.02-.04.05-.07.09-.1-.02.04-.03.09-.01.12h0s.05,0,.05-.02c.01-.02.03-.04.04-.07-.02.08-.02.14.04.14.01,0,.04-.03.04-.05.01-.06.05-.11.08-.16.04.02.09.02.16-.01,0,.01.01.01.01.02v.06s.01.01.02.01.03,0,.03-.01c.04.04.09.07.14.09s.13.02.19.04c.02.01.04.01.05.02h.01s.03.01.05.02c0,0,.01,0,.01.01.02.01.05.02.07.04.02.01.05.03.07.04.1.06.1.17.13.27-.06.17-.15.32-.12.51.03.19.24.27.39.31.13.04.24.06.36.13-.11-.01-.23.01-.34.04-.12.01-.24.01-.36.02-.34,0-.69-.03-.99-.27ZM38.39,19.66s-.03.01-.04.02c-.02.01-.05.02-.07.03s-.03.01-.05.02c-.02.01-.04.02-.06.02-.02.01-.04.01-.06.02-.02.01-.03.01-.05.02-.02.01-.04.01-.07.02-.01,0-.02.01-.03.01-.09.03-.19.05-.29.07-.05.01-.11.02-.17.03-.34.04-.68.03-1.02.07-.3.03-.56.11-.85.19-.08.02-.15.05-.21.08h0s-.01.01-.02.01c-.02.01-.04.02-.06.02.03-.07.06-.14.1-.2.01-.02.03-.04.04-.05.09-.08.19-.16.29-.22.12-.06.26-.11.38-.17.23-.11.46-.19.69-.32.02-.01.05-.03.07-.05.03-.02.06-.03.08-.05.07-.05.12-.12.19-.18h0s.01-.01.02-.01c.15-.06.29-.11.43-.18.18-.09.36-.17.51-.3.01-.01.02-.02.03-.03-.01.01,0,.02.01.01.07-.06.12-.14.16-.22,0-.01.01-.01.02-.02.08-.12.16-.11.26-.18.27-.19.4-.41.38-.71.09-.25.12-.53.12-.8.04-.09.07-.19.12-.28.01-.02.02-.04.03-.06s.02-.04.03-.05h0v.02s0,.04.01.07h0s0,.05.01.07c.02.13.01.25.04.37.03.1.16.16.23.23.15.14.28.53.53.53.07,0,.15-.02.23-.04h0s.07-.02.11-.03c.01,0,.03-.01.04-.01h.02s.03-.01.05-.01h.01s.03-.01.04-.01h.01s.03-.01.05-.01h.16s.03,0,.04.01h0s.03.01.04.01h.01s.03.01.04.02h0s.02.02.03.03h.01s.02.03.03.04c0,0,0,.01.01.01.01.01.02.03.03.04s.01.01.02.01c.01.03.01.06.02.08,0,.01-.01.01-.01.02-.05.08-.11.16-.15.24-.09.19-.2.36-.35.5-.16.11-.34.19-.47.34-.12.14-.2.29-.35.4-.13.09-.3.17-.44.24-.15.06-.31.05-.46.08-.14.03-.27.1-.39.17-.04-.02-.08,0-.11.02ZM24.94,16.93s.04-.04.05-.06c0,.01-.01.02-.01.03-.01.03-.01.06-.02.09-.01-.02-.02-.04-.02-.06ZM40.89,17.19h0s-.03-.01-.04-.01h-.01s-.03-.01-.04-.01h-.11c-.14,0-.28.06-.42.09-.16.03-.32-.29-.39-.39s-.16-.17-.25-.25c-.09-.07-.1-.19-.13-.3h0v-.02s0-.02-.01-.02c0-.02-.01-.03-.01-.05-.02-.06-.03-.13-.04-.19h0v-.06s.01-.01.01-.02.01-.01.01-.02c.01-.01.02-.03.04-.04.01-.01.02-.02.03-.03.1-.05.21-.1.32-.14-.14.09-.26.2-.38.32-.02.02-.03.06-.01.09.05.07.2.04.37-.02-.07.06-.16.1-.24.13-.02.01-.05.06-.02.06.09-.01.18-.04.25-.09-.03.11-.01.22.07.28.03.02.08-.03.07-.06-.01-.05,0-.1.01-.14,0,.03,0,.05.02.08.02.04.06-.01.07-.03.01-.01.01-.03.02-.04.04,0,.08-.01.12-.02t-.01.02s0,.01-.01.02c0,.02-.01.03-.01.05v.1h0c0,.05.01.09.02.14.09.26.33.27.56.24,0,.04,0,.08.01.12.01.07.06.12.1.17.02.02.03.04.05.07.01-.02,0-.02-.02-.03h0ZM32.35,17.51h0s-.01-.04-.02-.05h0s-.01-.04-.02-.06h0s-.01-.03-.02-.04c0,0,0-.01-.01-.01-.01-.01-.02-.03-.03-.04-.15-.18-.25-.31-.31-.54-.02-.09-.06-.17-.09-.25-.01-.08-.02-.16-.03-.23,0-.01,0-.03-.01-.05.07,0,.15-.01.24-.04-.02.01-.03.02-.05.03-.01,0-.02.02-.03.02h0s0,.01.01.01c.07,0,.14-.05.2-.09,0,.01-.01.01-.01.02-.01.01-.01.04.01.03.03-.02.04-.04.06-.06.01-.01.02-.02.03-.03.01.05.03.1.06.15v.05h0v.04h0v.04h0v.04h0c0,.05.01.09.01.11.02.09.06.18.08.27,0,.26.02.51-.06.76.01-.02,0-.05-.01-.08h0ZM31.56,16.36s-.05-.03-.09-.05c-.07-.03-.12-.03-.18-.07.01-.04.03-.07.05-.1,0,.02,0,.05.01.07.01.02.03-.01.03-.02,0-.04.02-.07.03-.11,0,0,0-.01.01-.01h0s.01.02.02.03c.05.02.11.02.17.01h0s-.05.06-.08.08c-.01.01,0,.03.01.02.02-.02.05-.04.07-.05,0,.02,0,.03.01.05h0s.01.07.02.1c0,.01,0,.03-.01.04h0s0,.03-.01.04c-.02,0-.04-.02-.06-.03h0ZM31.23,16.2s-.01-.02-.01-.03c.01,0,.01-.01.02-.01s.01-.01.02-.01c-.01.02-.01.04-.02.06-.01,0-.01-.01-.01-.01ZM40.85,16.45s0,.01,0,0t0,0h0c-.11.02-.22.02-.28-.03l-.02-.02h0s-.01-.02-.01-.03h0s-.01-.02-.01-.04h0v-.06s.01-.04.01-.06c.01-.01.03-.02.04-.04-.02.04-.03.07-.03.11,0,.01-.01.02-.01.03s0,.02.01.03c.03.02.06-.02.07-.04.02-.05.05-.08.09-.12-.02.04-.03.08-.03.12s.05-.01.06-.02c.02-.05.06-.09.09-.12-.02.07-.02.14-.02.22,0,.04.06,0,.06-.02.03-.09.06-.18.12-.25-.05.09-.07.17-.05.22-.03.03-.06.07-.09.12ZM38.62,17.09s.01.04.01.06v.06h0v.14s-.01.03-.01.04,0,.01-.01.02c0,.01-.01.02-.01.03s-.01.02-.01.02c0,.01-.01.02-.01.03s-.01.02-.02.04c0,.01-.01.02-.01.03-.01.01-.01.02-.02.03,0,.01-.01.01-.01.02-.01.01-.01.02-.02.03h0s-.03.05-.05.07h0s-.02.02-.03.04h0c-.14.17-.34.31-.55.43h0c-.08.04-.15.08-.23.12h0c-.07.03-.14.06-.21.09h-.01s-.03.01-.05.02c0,0-.01,0-.01.01-.02.01-.04.01-.05.02-.19.07-.38.2-.58.2-.21,0-.29-.18-.33-.37-.01-.11-.02-.21-.02-.32.01-.06.01-.12.01-.17.06-.07.11-.13.16-.21.03-.05.06-.1.09-.15.01-.01.03-.03.04-.04.18-.18.4-.26.56-.47.09-.11.16-.23.23-.36h0s.03-.06.04-.09c0-.01.01-.01.01-.02h0s.02-.03.02-.03c.01-.04.03-.07.04-.11.15.03.32-.02.48-.1h0s-.03.04-.04.04h0s-.04.04-.05.05h0s.01.03.02.03c.02,0,.05-.01.07-.02.01.03.01.06.02.08,0,.01.01.01.01.02.01.02.01.04.02.06h0c.06.13.15.23.25.33.07.08.19.17.23.28h0s.03,0,.03.02ZM34.09,20.16s-.01.01-.02.01h-.02s-.02,0-.02.01h-.05s-.07-.01-.11-.01c-.18-.13-.34-.29-.53-.39-.12-.07-.24-.14-.35-.22-.03-.04-.06-.09-.08-.14-.12-.24-.13-.5.09-.73.1-.1.24-.19.31-.33.09-.17.19-.36.25-.55,0-.01.01-.02.01-.04.03-.1.05-.19.05-.29.01-.28-.16-.51-.32-.72-.14-.19-.25-.35-.31-.53-.01-.02-.01-.03-.02-.05t-.01-.02s-.01-.04-.01-.05h0s.01-.01,0-.02h0s-.01-.03-.01-.04h0v-.03h0s.03-.01.05-.02l.06-.03c0,.05,0,.11.03.15.01.01.03-.01.03-.03h0s0-.08,0-.13c.03.05.07.1.12.09.01,0,.04-.03.02-.03-.03-.01-.05-.04-.07-.07h0c.05.05.22.19.28.09.01-.01,0-.03-.01-.03-.02,0-.08-.06-.1-.07-.01-.01-.03-.02-.04-.03.05.03.1.06.15.09v.26h0c.01.27.05.52.19.75.11.18.26.37.41.54.03.08.06.17.09.26.04.12.14.18.24.26.03.03.06.06.08.1.04.11.08.24.15.35.02.04.04.07.06.1.05.13.11.26.14.39.04.2.02.29-.14.44-.1.1-.2.19-.29.3-.09.12-.17.24-.26.36l-.02.02s-.02.01-.03.01t.01.02ZM32.5,18.85c0-.08.01-.17.02-.26.05-.25.06-.43-.01-.66.1-.22.25-.47.26-.72.01-.22-.05-.45-.13-.65-.03-.07-.05-.14-.07-.21,0-.01,0-.02-.01-.03-.01-.03-.02-.06-.02-.09h0s-.01-.08-.02-.12c0-.02,0-.03-.01-.05.04,0,.08-.03.1-.05.01,0,.01-.01.02-.01-.03.04-.05.08-.09.11-.01.01-.03.05,0,.04.04-.01.08-.05.11-.08,0,.01,0,.02.01.03,0,.03.01.07.01.1h0s.01.07.02.11h0c.14.55.62,1.07.39,1.63-.12.32-.41.57-.58.91,0-.01,0-.01,0,0ZM36.57,16.6c-.07.13-.16.23-.21.36-.02.06-.02.14-.03.2-.01.11-.05.19-.11.27-.14-.09-.33-.13-.46-.14h-.01c.12-.16.2-.34.18-.57-.01-.09-.05-.18-.08-.27v-.24s.09-.05.12-.07c.02-.01.03-.02.05-.03-.01.03-.02.06-.04.08-.01.01-.01.04.01.03.04-.02.07-.06.09-.1.03.04.05.07.1.1.01.01.04-.02.03-.03-.02-.03-.03-.07-.04-.1.11.03.21.05.32.06-.12.07-.26.14-.39.14-.02,0-.06.05-.03.06.15.06.35-.02.49-.09.02-.01.04-.02.07-.03,0,0,0,.01.01.01-.01.01-.01.02-.02.02-.03.04-.09.13-.15.12-.02,0-.05.03-.03.04.06.04.14-.03.18-.07.01-.01.03-.03.05-.04h0s0,.03.01.04c-.01.04-.02.08-.02.12-.04.03-.06.08-.09.13ZM36.15,18.8h0c-.12.04-.24.08-.35.14-.33.18-.43.6-.77.75-.1.05-.19.1-.27.16h0c.15-.25.31-.49.42-.75.06-.14.08-.26.05-.39.03-.16.1-.32.23-.4.03-.01.06-.03.09-.04.02-.01.04-.02.07-.02.02,0,.05-.01.07-.01.09,0,.22-.05.31-.11,0,.08-.01.15-.01.22,0,.11.09.19.14.29.01.03.02.06.03.08,0,.02.01.04.01.06,0,.02,0,.02-.02.02ZM34.81,17.74h0s-.02-.04-.04-.05c-.01-.02-.03-.04-.04-.06-.07-.09-.15-.14-.24-.2-.11-.07-.14-.3-.2-.41-.13-.26-.39-.45-.44-.75.01-.02.01-.04.02-.06.01,0,.03-.02.03-.03h0v-.07l.02-.02h0s0,.05.01.08c0,.02.02.04.01.06,0,.02.02.01.03,0,.01-.03.02-.06.02-.09.04.03.07.06.11.09.03.02.15.12.19.06.01-.01.01-.03-.01-.02h-.01.13v.02h0s-.01.09-.01.13h0c-.01.12-.01.23,0,.35.03.24.12.5.28.69h0s.02.04.03.05h0s.04.04.06.06c.01,0,.01.01.02.01.01.01.02.01.02.02.01.01.02.01.03.02l.02.02s.02.01.03.02c.01,0,.01.01.02.01.02.01.04.02.05.03.01.01.02.01.04.02-.06.02-.11.04-.16.07-.01-.03-.02-.04-.02-.05h0ZM35.07,18.3s-.01-.01-.01-.02c-.01-.01-.01-.03-.02-.04,0-.01-.01-.02-.01-.03s-.01-.02-.01-.03c-.01-.02-.01-.04-.02-.07-.02-.09.03-.17.1-.24.08-.03.17-.06.25-.11.01,0,.02-.01.02-.02.19,0,.37-.01.54.09h.01s-.07.05-.11.07c-.21.1-.48.13-.63.34-.03.04-.05.08-.07.12,0,0,0-.01-.01-.01h0s-.03-.03-.03-.05ZM35.27,17.27c-.25-.04-.35-.3-.46-.51-.06-.12-.1-.25-.12-.39-.01-.03-.01-.07-.01-.1v-.03s0-.05-.01-.07c.01-.01.01-.02.01-.02h0s-.01-.02-.01-.02v-.02c.06.02.12.03.18.04.01,0,.03-.02.02-.03-.04-.03-.09-.05-.13-.07.1.02.2.03.31.04h.06c.11.07.25.08.39.07.01.06.01.12.02.17h0c.01.07.01.14.02.21.02.22.06.5-.01.73h-.01c-.09.01-.17.01-.25,0ZM34.4,16.14h0s0,.04-.01.05c-.03-.02-.07-.03-.1-.04.04,0,.08,0,.11-.01ZM35.83,16.13s.02-.01.02-.01t-.02.01s0,0,0,0ZM36.91,16.78h0c0-.12.02-.25.04-.37v-.12h0c.1,0,.2-.02.3-.04h0v.02s-.01.04-.02.05h0c-.01.05-.02.1-.03.14-.01.06-.03.11-.06.16-.06.09-.15.13-.23.19v-.03ZM38.32,16.08v.02-.02h0ZM26.74,16.74s0,.02.01.03h0s0,.01-.01.01c-.01-.01-.03-.02-.04-.03M38.91,16.2c-.03.16-.05.32-.08.48-.01-.01-.02-.01-.03-.02-.06-.07-.13-.13-.18-.19-.08-.08-.17-.16-.24-.25.02-.01.05-.04.05-.06,0-.08.03-.14.06-.2,0,.05.01.1.04.14.02.04.08-.02.07-.05-.01-.08.01-.16.04-.23.01,0,.01.01.02.01.08.02.18-.02.27-.09h0s-.01.03-.01.05v.03s-.01.03-.01.05v.32h0ZM39.1,15.8s.01-.05.02-.07c.03,0,.07-.01.11-.02-.04.05-.1.12-.12.18-.01-.03-.01-.06-.01-.09ZM42.07,16.24s-.01.05-.01.07c-.02.01-.04.02-.06.02.03-.03.05-.06.07-.09ZM29.18,16.7c-.12.01-.24,0-.35-.03,0-.01-.01-.02-.01-.03s-.01-.01-.01-.02-.01-.01-.01-.02,0-.01-.01-.02h0s.01,0,.02.01c.01.02.04.04.05.06.02.03.06-.02.06-.04v-.05s.09.03.13.04c.03,0,.09-.05.05-.08-.01,0-.01-.01-.02-.02.06.01.12.01.16.02.11.01.31.04.37-.08.02-.03.02-.07,0-.11.05.01.1,0,.13-.01.01-.01.06-.06.02-.06-.02,0-.03-.01-.04-.02,0,0-.01,0-.01-.01.04-.01.07-.02.09-.02.03,0,.08-.08.03-.08-.07,0-.13-.01-.2,0h-.04l.02-.02h0s.02-.04.02-.06t.02-.01s.09.02.13.02c.03.01.08-.04.06-.08l.02-.02s.03.01.04.01c.03,0,.06-.03.05-.06t-.01-.02s.04.02.06.03c-.01.03-.01.07-.01.11s.06,0,.07-.01c0-.01.01-.02.01-.03,0,0,0-.01.01-.01.01-.01.01-.03.02-.04h.04s-.01.01-.01.02c-.01.04.03.05.05.02.01-.02.03-.03.04-.04h0v.02h0c-.03.07-.04.13,0,.17.01.01.03,0,.05-.01,0,.01.01.02.01.04.01.02.02.04.03.05,0,.01.01.01.01.02s.01.01.01.02h0c.08.13.2.24.3.33.02.02.04.03.05.05h0c.04.06.08.11.11.18h0c-.13-.13-.37-.17-.54-.18-.33-.02-.69.04-1.07.07ZM39.13,16.17c0-.05-.01-.1-.01-.15h0s.07-.02.08-.05c.01-.04.04-.08.08-.12-.01.03-.02.06-.01.09h0v.02h0c-.05.09-.08.2-.12.31v-.03h0s-.02-.04-.02-.07ZM43.52,16.63h.02s-.04.07-.06.1h-.03s.05-.06.07-.1ZM27.93,17h0l-.02-.02s-.04-.04-.06-.06c-.01-.01-.02-.03-.03-.04-.01-.01-.02-.02-.03-.04,0-.01-.01-.01-.01-.02.09-.03.17-.09.24-.13-.02.03-.04.05-.07.08-.01.01-.03.05,0,.05.04,0,.06-.03.09-.06.06-.06.13-.12.19-.19l.06-.06c-.01.05-.02.1-.02.15,0,.04.06,0,.06-.02,0-.01.01-.02.01-.03h0v.02s.01.02.01.03h0s.01.02.01.03h0s.01.04.02.06c0,0,0,.01.01.01.03.06.08.12.14.17.01.01.03.02.05.03.01,0,.01.01.02.01.01.01.02.01.03.02.01,0,.01.01.02.01.01.01.03.01.04.02.02.01.04.01.07.02-.07.04-.14.09-.21.11-.18.05-.47-.01-.62-.15ZM30.66,16.13s-.01-.01-.01-.02v-.02s.02-.03.03-.04c-.02.02-.02.05-.02.08ZM41.29,16.38s0,.01,0,0c0,.01-.01.01-.01.02t.01-.02ZM43.4,16.6h.01s-.02.08-.03.11c-.01,0-.03,0-.04-.01h-.01s.05-.06.07-.1ZM42.34,16.55h0s.02-.01.02-.02c.02-.02.04-.04.05-.06l.02-.02h0s.06.07.07.1h0s.02.02.03.01c.05-.04.05-.1.05-.16v-.06c.11.12.25.2.39.14.01,0,.02-.01.03-.02.01.02.02.03.03.05.03.06.08.12.15.08.02-.01.05-.07.02-.08-.01-.01-.01-.02-.02-.03.03.02.07.04.1.06-.01.05-.02.1-.04.15-.03,0-.06-.01-.09-.01h0c-.28-.04-.58-.08-.84.01h0s-.03.01-.05.02c-.01,0-.01.01-.02.01-.01.01-.03.01-.04.02s-.02.01-.03.02-.02.01-.03.02c-.02.01-.04.03-.06.04-.01.01-.03.02-.04.03-.04.03-.07.06-.11.09.01-.02.02-.04.03-.06.11-.11.25-.21.38-.33ZM42.99,17.03c-.07.01-.13.02-.2.02-.04,0-.09-.01-.13-.01.1,0,.21-.01.33-.01ZM24.62,17.61c-.13-.04-.22-.1-.31-.18l-.06-.06s-.01-.02-.02-.03c-.01-.01-.02-.03-.03-.04-.01-.01-.01-.02-.02-.03-.01-.02-.02-.03-.03-.05-.01-.01-.01-.02-.02-.03-.01-.03-.03-.05-.04-.08h0s.05-.02.07-.03c-.01.01-.01.03.01.03.15.05.27-.04.4-.1.02-.01.04-.02.06-.03-.02.03-.05.05-.07.08-.03.03-.01.07.03.04.07-.05.13-.11.2-.16h0v.02s-.04.04-.06.05-.04.06,0,.06c.02,0,.05-.01.07-.02.03.21.07.42.14.61-.13,0-.23-.03-.32-.05Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M31.75,25.61c.04.06.16.24.25.49,0,0,.14.4.02.51,0,0-.04.05-.1.01,0,0-.04-.03-.03-.06,0,0,.01-.04.05-.03,0,0,.07.01.08-.07,0,0-.02-.29-.13-.51"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M32.76,23.79s.16.18.23.2l.2.03s.08,0,.12-.02c.01-.03.01-.07.02-.09.01-.03.02-.06.04-.08.02-.01.09-.01.1.02s-.04.07-.05.09c.02.04-.04.14-.04.14-.03.07-.07.07-.07.07-.03,0-.31.08-.31.08-.03.01-.09.04-.09.04-.02.02-.07-.01-.07-.01-.02-.01-.19-.01-.21,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M31.78,25.77l-.13-.3s-.12-.27-.05-.56l.05-.19s.06-.19.13-.28c0,0,.13-.17.17-.24,0,0,.13-.24.24-.38,0,0,.1-.14.15-.24,0-.05,0-.18.1-.28l.03-.02s.04-.08.08-.12c.03-.06.13-.3.22-.41v-.04s-.02-.05-.01-.07c.02-.05.05-.03.08,0,.04-.03.15-.11.23-.07,0,0,.05.03.09.02,0,0,.07-.02.06.09.02.04.01.08,0,.11,0,.03-.01.07-.05.11,0,0-.07.07-.12.16,0,0-.08.19-.12.27.02.03.15.21.22.24l.21.05s.08,0,.13-.01c0-.03.02-.07.03-.09.01-.03.03-.07.05-.08.02-.01.08-.01.09.02s-.02.08-.03.11c.01.04-.07.14-.07.14-.04.07-.09.06-.09.06-.03,0-.33.05-.33.05-.04,0-.1.04-.1.04-.03.02-.07-.02-.07-.02-.02-.01-.06,0-.08.01-.02.12-.04.12-.06.18,0,.03-.1.28-.1.27-.1.21-.46.61-.53.67.03.05.12.22.19.47,0,0,.06.16.12.17,0,0,.05,0,.09-.01.01-.06.03-.14.08-.13.04,0,.05.07.04.11.01.04-.02.1-.04.12s-.04.04-.07.04l-.04.02c-.07.03-.2,0-.2,0-.05,0-.07-.07-.07-.07-.04-.09-.15-.19-.2-.22,0,.06-.02.27-.03.38,0,0-.02.21.03.31l.14.29s.06.09.04.13c0,0-.01.04-.04.03-.03.02-.06-.03-.06-.07-.01-.01-.03-.04-.04-.06-.02-.03-.04-.07-.04-.07"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M27.2,30.62h-.24l-.67-1.66h.2l.58,1.47.59-1.47h.2l-.66,1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M29.61,30.62h-.2l-.19-.46h-.82l-.19.46h-.2l.68-1.66h.24l.68,1.66ZM28.47,29.98h.68l-.34-.83-.34.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M30.78,28.93c.07,0,.14.01.21.02.07.02.13.04.19.07.06.03.11.07.16.11s.09.09.12.14l-.16.11s-.06-.08-.1-.11-.08-.06-.12-.08-.09-.04-.14-.05c-.05-.01-.1-.02-.16-.02-.09,0-.18.02-.26.05-.08.03-.15.08-.21.14s-.11.13-.14.21c-.03.08-.05.17-.05.27s.02.19.05.27.08.15.14.21.13.1.21.14c.08.03.17.05.26.05.11,0,.21-.02.3-.07s.16-.11.22-.2l.15.11s-.08.1-.12.14c-.05.04-.1.08-.16.11-.06.03-.12.05-.19.07s-.14.02-.21.02c-.12,0-.24-.02-.34-.06-.1-.04-.2-.1-.27-.18-.08-.08-.14-.17-.18-.27s-.06-.22-.06-.34.02-.24.06-.34.1-.19.18-.27.17-.13.27-.18c.12-.05.23-.07.35-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M32.21,29.69h1.01v-.73h.19v1.66h-.19v-.75h-1.01v.75h-.19v-1.66h.19v.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M35.23,30.62h-1.17v-1.66h1.16v.18h-.97v.56h.94v.18h-.94v.57h.98v.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M36.99,30.62h-1.15v-1.66h.19v1.48h.96v.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M38.61,30.62h-1.15v-1.66h.19v1.48h.96v.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M39.26,30.62h-.19v-1.66h.19v1.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M41.33,30.62h-.2l-.19-.46h-.82l-.19.46h-.2l.68-1.66h.24l.68,1.66ZM40.18,29.98h.68l-.34-.83-.34.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M27.37,31.33c.09,0,.18.01.25.03s.13.05.18.09.09.09.11.15c.03.06.04.12.04.2,0,.07-.01.14-.04.19-.03.06-.07.11-.12.15-.05.04-.11.07-.18.09-.07.02-.15.03-.24.03h-.03l.6.72h-.24l-.59-.72h-.21v.72h-.19v-1.66h.66ZM26.91,31.51v.59h.46c.13,0,.22-.03.29-.08.06-.05.1-.12.1-.22s-.03-.17-.1-.22c-.07-.05-.16-.07-.29-.07,0,0-.46,0-.46,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M29.67,32.99h-1.17v-1.66h1.16v.18h-.97v.56h.94v.18h-.94v.57h.98s0,.17,0,.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M31.37,31.64c-.07-.05-.14-.08-.23-.11-.08-.03-.17-.04-.28-.04-.06,0-.12.01-.17.02s-.1.03-.14.06c-.04.03-.07.06-.09.09-.02.04-.03.08-.03.13,0,.08.03.14.09.18s.16.07.29.09l.16.02c.07.01.13.02.2.04.06.02.12.05.16.08.05.03.09.08.11.13.03.05.04.11.04.19s-.02.15-.05.22c-.03.06-.08.11-.14.16-.06.04-.13.07-.21.1-.08.02-.16.03-.25.03-.06,0-.12-.01-.18-.02s-.12-.02-.18-.04-.11-.04-.16-.07c-.05-.03-.1-.06-.13-.09l.1-.15s.06.05.1.07.08.04.13.06c.05.02.1.03.15.04.05.01.11.02.16.02.06,0,.12-.01.18-.02s.1-.03.15-.06c.04-.03.07-.06.1-.09.02-.04.04-.08.04-.13,0-.08-.03-.14-.1-.19-.07-.04-.17-.07-.3-.09l-.17-.02c-.07-.01-.14-.02-.2-.04-.06-.02-.11-.05-.15-.08-.04-.04-.08-.08-.1-.13s-.04-.11-.04-.18c0-.08.02-.15.05-.21s.08-.11.13-.15.12-.07.2-.1c.08-.02.16-.03.25-.03.06,0,.12,0,.18.01s.11.02.16.04.1.03.14.06c.04.02.08.05.12.07l-.09.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M33.23,32.99h-1.17v-1.66h1.16v.18h-.97v.56h.94v.18h-.94v.57h.98v.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M35.24,32.99h-.2l-.19-.46h-.82l-.19.46h-.2l.68-1.66h.24l.68,1.66ZM34.1,32.35h.68l-.34-.83-.34.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M36.35,31.33c.09,0,.18.01.25.03s.13.05.18.09c.05.04.09.09.11.15s.04.12.04.2c0,.07-.01.14-.04.19-.03.06-.07.11-.12.15-.05.04-.11.07-.18.09s-.15.03-.24.03h-.03l.6.72h-.24l-.59-.72h-.21v.72h-.19v-1.66h.66ZM35.89,31.51v.59h.46c.13,0,.22-.03.29-.08s.1-.12.1-.22-.03-.17-.1-.22-.16-.07-.29-.07c0,0-.46,0-.46,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M38.25,31.31c.07,0,.14.01.21.02.07.02.13.04.19.07.06.03.11.07.16.11s.09.09.12.14l-.16.11s-.06-.08-.1-.11-.08-.06-.12-.08-.09-.04-.14-.05c-.05-.01-.1-.02-.16-.02-.09,0-.18.02-.26.05-.08.03-.15.08-.21.14s-.11.13-.14.21c-.03.08-.05.17-.05.27s.02.19.05.27c.03.08.08.15.14.21s.13.1.21.14c.08.03.17.05.26.05.11,0,.21-.02.3-.07s.16-.11.22-.2l.15.11s-.08.1-.12.14c-.05.04-.1.08-.16.11s-.12.05-.19.07-.14.02-.21.02c-.12,0-.24-.02-.34-.06-.1-.04-.2-.1-.27-.18-.08-.08-.14-.17-.18-.27s-.06-.22-.06-.34.02-.24.06-.34c.04-.1.1-.19.18-.27s.17-.13.27-.18c.11-.05.22-.07.35-.07Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-251",
    d: "M39.67,32.07h1.01v-.73h.19v1.66h-.19v-.75h-1.01v.75h-.19v-1.66h.19v.73Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M33.79,36.83c-8.83,0-16.02-7.19-16.02-16.02S24.96,4.79,33.79,4.79s16.02,7.19,16.02,16.02c0,8.84-7.18,16.02-16.02,16.02ZM33.79,5.19c-8.61,0-15.62,7.01-15.62,15.62s7.01,15.63,15.62,15.63,15.63-7.01,15.63-15.63-7.01-15.62-15.63-15.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M40.89,10.74c.21-.01.43-.01.64,0,.01-.03.04-.04.07-.04s.06,0,.08-.01c.09-.02.15-.11.21-.19.15-.21.38-.37.63-.45,0,.02-.02.04-.04.05-.01.02-.02.04-.02.06-.02.01-.04.03-.06.04.01,0,.01.01.02.01-.02.03-.04.04-.07.05,0,.01.01.01.01.02-.02.01-.04.02-.06.03t.02.02c-.06.02-.1.08-.14.13-.09.12-.18.25-.27.37.01.03.04.05.08.06.03.01.07,0,.1,0,.04-.01.08-.01.12-.02.01.01.01.03.02.04,0,.02-.01.03-.02.04.02.01,0,.04-.02.04.02.02,0,.06-.02.06.02.02.01.06-.01.08-.02.02-.05.03-.08.04-.01.02-.04.04-.06.04-.04.04-.11.06-.16.04-.03.03-.08.02-.11-.01-.03-.03-.03-.07-.02-.11s.03-.07.05-.11c-.05-.05-.09-.1-.14-.15-.01-.01-.02-.02-.03-.02-.02,0-.03.01-.04.03s-.01.03,0,.05c-.01-.03-.01-.06-.02-.09-.2-.11-.46-.02-.66-.11h.03"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M27.71,10.31l-.58-.04h-.05c-.05.02-.06.08-.06.13-.02-.06-.04-.13-.03-.19,0-.07.04-.14.1-.17.03-.01.06-.02.09-.04.04-.04.02-.1-.01-.14-.11-.12-.33-.1-.48-.18-.14-.06-.21-.22-.18-.36.01.01.03.02.04.03,0-.02.02-.04.04-.04s.03.02.03.04c.03-.02.08.01.08.04h.05s.01.02.01.03h.05s.07.02.1.04c.11,0,.17.11.27.14.08.02.17,0,.25.02.13.04.18.19.3.22.04.01.1.01.1.05v.04s.04.04.07.03c.03,0,.06-.01.09-.01.06,0,.09.05.12.09.08.09.18.17.29.22.04.02.08.03.11.04.02,0,.04.03.02.05.04-.01.08.01.09.05.03-.01.05.03.03.04.03-.01.06,0,.08.02.04.02.08.05.12.07h-.04s.02.03.04.04c-.02.02-.05.03-.08.02.02,0,.04.01.05.02-.06.04-.13.02-.19.01-.28-.07-.57-.15-.82-.29q-.06,0-.1-.02"
  }))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-889",
    transform: "translate(52.41 25.78)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "VACHELLIA RESEARCH"))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLogo2);
export default __webpack_public_path__ + "static/media/header-logo2.7bdf9f15748029bcca482cc15d06c5b8.svg";
export { ForwardRef as ReactComponent };